// Importing countries
import { COUNTRIES_EN } from './countries';

export const LANG_DA_CODE = 'da-DA';
export const LANG_DA_NAME = 'Dan';
export const LANG_DA_COMPLETE_NAME = 'Dansk';

const LANG_DA = {
  'ALL': 'All',
  'MORE_INFO': 'More info',
  'VIEW INTRO': 'View intro',
  'TESTING_KEY': 'Key for testing purpose',
  'NO_RESULTS_FOUND': 'No results found',
  'CHARACTERS_LEFT': 'characters left',
  'UPLOADING': 'Uploading...',
  'ORIGINAL_TEXT': 'Original Text',
  'LOADING': 'Loading',
  'LINK': {
    'PARTICIPANT_QUESTIONS': 'Participant Questions Link Copied',
    'BRAINSTORMING': 'Brainstorming Link Copied',
    'SORTING': 'Sorting Link Copied',
    'RATING': 'Rating Link Copied',
    'SORTING_RATING': 'Sorting & Rating Link Copied',
    'LINK_COPIED': 'Link copied to clipboard!'
  },

  // ==== SUPPORTED LANGUAGES ====
  // =============================
  'SUPPORTED_LANGUAGES': {
    'en-US': 'English',
    'es-ES': 'Español',
    'de-DE': 'Deutsch',
    'fr-FR': 'Français',
    'fr-CA': 'Français (Canada)',
    'da-DA': 'Dansk',
    'nl-NL': 'Nederlands'
  },

  // =========== ROLES ===========
  // =============================
  'ROLES': {
    'PARTICIPANTQUESTIONS': 'Participant Questions',
    'BRAINSTORMING': 'Brainstorming',
    'SORTING': 'Sorting'
  },

  // ======== PAGINATION =========
  // =============================
  'PAGINATION': {
    'ROWS_PER_PAGE': 'Rows per page',
    'PAGE': 'Page',
    'OF': 'of',
    'ALL': 'All'
  },
  // ==== PARTICIPANT FOOTER =====
  // =============================
  'PARTICIPANT_FOOTER': {
    'ITEMS': {
      'PRIVACY': 'Privacy',
      'TERMS': 'Terms',
      'HELP': 'Help & Support'
    },
    'COPYRIGHT': 'Copyright © 2000-2023. All rights reserved. Powered by',
    'COPYRIGHT_STRING': 'Concept Systems, Inc'
  },

  // =========== LOGIN ===========
  // =============================
  'FORMS': {
    'LABEL': {
      'OPTIONAL': 'Optional'
    },
    'ERROR': {
      'NOT_MATCH': 'Passwords don\'t match',
      'WRONG_EMAIL': 'Invalid email, try again',
      'INVALID_PHONE': 'This is not a valid cellphone number, try again',
      'REQUIRED_EMAIL': 'You must enter an email',
      'REQUIRED_LASTNAME': 'You must enter a last name',
      'REQUIRED_FIRSTNAME': 'You must enter a first name',
      'INVALID_EMAIL_FORMAT': 'Invalid email format',
      'REQUIRED_REPEAT_PASSWORD': 'You must enter your password again',
      'OPEN_DATE': 'Open date cannot be after Close date',
      'CLOSE_DATE': 'Close date cannot be before Open date',
      'REQUIRED_NAME': 'You must enter a name',
      'INVALID_NAME_FORMAT': 'Invalid name format',
      'REQUIRED_FIELD': 'This field is required',
      'OPEN_EQUALS_DATE': 'Open date is the same as the close date',
      'CLOSE_EQUALS_DATE': 'Close date is the same as the open date',
      'INVALID_COLOR_FORMAT': 'Invalid color format',
      'USERNAME': 'Username is required',
      'ROLE': 'Role is required',
      'NO_USER_SELECTED': 'One or more fields have no users selected. Please select a rating with available users and select some users.'
    },

    'PASSWORD_REQUIREMENTS': {
      'TITLE': 'A secure password should include at least:',
      'ITEMS': {
        'LENGTH': 'Six characters in length',
        'BASE_10': 'One number (0 through 9)',
        'UPPERCASE': 'Uppercase characters (A through Z)',
        'LOWERCASE': 'Lowercase characters (a through z)',
        'NON_ALPHABETIC': 'Non alphabetic characters (for example, !, $, %, #)'
      },
      'REQUIREMENTS': {
        'LENGTH': 'Your password needs a minimum of 6 characters',
        'NOT_NAME': 'Your password cannot include your first or last name',
        'REQUIRED': 'You must enter a password',
        'NOT_USERNAME': 'Your password is too similar to your username'
      },
      'WEAK': 'WEAK',
      'STRONG': 'STRONG',
      'FORGOT_PASSWORD': 'Forgot password?'
    }
  },
  'FIRST_LOGIN': {
    'TITLE': 'Activate your account',
    'CREATE_PASSWORD': 'Create a password',
    'SUB_TITLE': 'Create an account and start contributing with important research projects while having fun!',
    'SET_NEW_PASSWORD': 'Set a new password',
    'EXPIRED_TOKEN': 'Your activation link has expired please request a new one below to activate your account.',
    'FIELD': {
      'EMAIL': { 'LABEL': 'Email', 'PLACEHOLDER': 'example@conceptsystems.com' },
      'OLD_PASSWORD': { 'LABEL': 'Old Password', 'PLACEHOLDER': 'Enter your old password' },
      'PASSWORD': { 'LABEL': 'Password', 'PLACEHOLDER': 'Enter your password' },
      'REPEAT_PASSWORD': { 'LABEL': 'Repeat Password', 'PLACEHOLDER': 'Enter again your password' },
      'FIRSTNAME': { 'LABEL': 'First Name' },
      'LASTNAME': { 'LABEL': 'Last Name' },
    },
    'BUTTON': 'Activate',
    'DONE': 'Done',
    'RESEND_LINK': 'Resend link',
    'HAVE_AN_ACCOUNT': 'Already have an account?',
    'LOGIN_HERE': 'Login here',
    'LINKS': {
      'PRIVACY': 'Privacy',
      'TERMS': 'Terms',
      'HELP_CENTER': 'Help Center',
      'GCM_ACADEMY': 'GCM Training',
    },
    'COPYRIGHT': {
      'MAIN': 'Copyright © 2026. Concept Systems, Inc. All rights reserved.',
      'POWERED': 'Powered by',
      'BY': 'Concept Systems, Inc.'
    },
    'GO_TO_LOGIN_BUTTON': 'Go to login page',
    'TOKEN_EXPIRED': 'Your account is already activated'
  },
  'LOGIN_PAGE': {
    'TITLE': 'Login',
    'BUTTON': 'Log in',
    'NEW_TO_GW': 'New to GroupWisdom?',
    'CREATE_ACCOUNT': 'Create an account',
    'WRONG_EMAIL_PASSWORD': 'Your email/password combination is not valid, try it again.',
    'TRIES': 'Wrong password! You have %0 more tries!',
    'TRY': 'Wrong password! You have 1 more try',
    'ACCOUNT_LOCKED': 'Your account has been locked, please reset your password',
    'BUTTON_LOCKED': 'Reset Password'
  },
  'FORGOT_PASSWORD_PAGE': {
    'TITLE': 'Reset password',
    'SUB_TITLE': 'We will send you an email with instructions on how to reset your password to the following address:',
    'BUTTON': 'Reset password',
    'RESETTED': {
      'TITLE': 'Check your inbox',
      'SUB_TITLE': 'An email is on its way! You should be getting instructions on how to reset your password soon, just make sure to check your spam (just in case).',
      'DID_NOT_GET': 'Didn\'t get the email?',
      'RESEND': 'Resend me the link',
      'BUTTON': 'Back to login'
    }
  },
  'RESET_PASSWORD': {
    'TITLE': 'Reset password',
    'BUTTON': 'Reset password',
    'EXPIRED_TOKEN': 'Your reset password link has expired. Please request a new one below to reset your password',
    'EXPIRED_BUTTON': 'Resend',
    'SUCCESS': {
      'TITLE': 'New password confirmation',
      'SUB_TITLE': 'Your password has been changed successfully.',
      'BUTTON': 'Continue'
    }
  },
  'PHONE_VERIFICATION': {
    'TITLE': 'Phone Verification',
    'SUB_TITLE': 'We have sent you a text message to <span>%0</span> with a verification code that you’ll need to enter to continue.',
    'LABEL': 'Verification Code',
    'NEED_CHANGE_PHONE': 'Need to change your phone number?',
    'CONTACT_US': 'Contact us',
    'BUTTON_VERIFY': 'Verify',
    'BUTTON_CALLME': 'Call me with a code',
    'TOOLTIP': 'Your account sign in requires a security code authentication',
    'INCORRECT_CODE': 'Incorrect code',
    'DID_NOT_GET_CODE': 'Didn\'t get the code?',
    'CLICK_HERE': 'Click here'
  },
  'SIGN_UP': {
    'TITLE': 'Create an account',
    'SUB_TITLE': 'This page is for project administrators who have purchased a groupwisdom™ license. You can find purchase details here:',
    'BUTTON': 'Register',
    'SUCCESS': {
      'TITLE': 'Check your inbox',
      'SUB_TITLE': 'We’ve sent an email to <span>%0</span> with a link to activate your account.',
      'SMALL_MESSAGE': 'Click on the link and you’re good to go!',
      'BUTTON': 'Back to login'
    }
  },
  'AUTO_LOGOUT': {
    'WARNING': {
      'TITLE': 'Still there?',
      'BUTTON': 'Continue Working',
      'MESSAGE': 'For security, we\'ll log you out if you\'re still inactive after ',
      'SECONDS': 'seconds'
    }
  },

  // ======= SAVING STATUS =======
  // =============================
  'SAVING_STATUS': {
    'SAVED': 'All changes saved',
    'SAVING': 'Saving changes'
  },

  // ========= HEAD BAR ==========
  // =============================
  'HEAD_BAR': {
    'SEARCH': {
      'TITLE': 'Search for a participant or statement',
      'ALL_PROJECTS': 'All Projects',
      'INPUT_PLACEHOLDER': 'Start searching...',
      'TAB_NAMES': {
        'PARTICIPANTS': 'Participants',
        'STATEMENTS': 'Statements'
      },
      'PARTICIPANT_TAB': {
        'USERNAME': 'Username',
        'LAST_ACTIVITY': 'Last Activity'
      },
      'STATEMENT_TAB': {
        'TITLE': 'Statements'
      },
    },
    'NOTIFICATIONS': {
      'TITLE_SINGLE': 'NEW MESSAGE',
      'TITLE_MULTIPLE': 'NEW MESSAGES',
      'TITLE_NO': 'NO NEW MESSAGES',
      'ALL': 'VIEW ALL NOTIFICATIONS',
      'NO_NOTIFICATIONS': 'You have no notifications yet'
    }
  },

  // =========== ADMIN ===========
  // =============================
  'ADMIN': {
    'USER_MENU': {
      'SIGN_OUT': 'Sign Out',
      'MY_ACCOUNT': 'My Account',
      'MY_PROJECTS': 'My Projects',
      'SUPER_ADMIN': 'CSI SUPER ADMIN'
    }
  },
  // ========= NOTIFICATIONS =====
  // =============================
  'NOTIFICATIONS': {
    'NOTIFICATIONS': 'NOTIFICATIONS',
    'EMAILS': 'EMAILS',
    'TITLE_SINGLE': 'new notification',
    'TITLE_MULTIPLE': 'new notifications',
    'FROM': 'From',
    'TO': 'To',
    'NOTIFICATION': 'Notification',
    'NO_NOTIFICATIONS': 'You have no notifications yet.',
    'PAGER': {
      'SHOWING': 'Showing',
      'TO': 'to'
    },
    'HEAD_LIST': {
      'NAME': 'NOTIFICATION',
      'DATE': 'DATE'
    },
    'DROPDOWN_TIME': {
      'ALL': 'All',
      'LABEL': 'Show',
      'RECENTLY': 'Last 7 days',
      'LAST_WEEK': 'Last 14 days',
      'LAST_MONTH': 'Last 30 days'
    },
    'DROPDOWN_PROJECT': {
      'LABEL': 'Project',
      'ALL': 'All Projects',
    },
    'BUTTONS': {
      'ALL': 'ALL',
      'UNREAD': 'UNREAD',
      'AS_UNREAD': 'Mark as unread',
      'AS_READ': 'Mark as read'
    },
  },
  // ========= MY ACCOUNT ========
  // =============================
  'MY_ACCOUNT': {
    'TITLE': 'My Account',
    'PHONE_REQUIRED': {
      'TITLE': 'Enter a phone number',
      'TEXT': 'You need to enter your phone number first.'
    },
    'GENERAL_INFORMATION': {
      'TITLE': 'General Information',
      'FIELDS': {
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'EMAIL': 'Email',
        'PHONE': 'Phone',
        'SUBSCRIBE': 'Don\'t send me any GroupWisdom emails'
      }
    },
    'LICENSES': {
      'STANDARD': 'Standard License',
      'GOLD': 'Gold License'
    },
    'UPDATE': 'Update',
    '2FA_MODAL': {
      'TITLE': 'Verify your phone number',
      'MESSAGE': 'You have just updated your cellphone number so we have sent you a text message to <span>%0</span>, with a verification code that you need to enter below.'
    },
    'EMAIL_VALIDATION_MODAL': {
      'TITLE': 'Verify your email',
      'MESSAGE': 'You have just requested to change your email to <span>%0</span>, so we\'ve emailed you with a verification code that you need to enter below in order to update your email.',
      'DID_NOT_GET_CODE': 'Didn\'t receive the email?',
      'WARNING': 'The email could take a minute to arrive. In case doesn\'t recibe the email please review the spam folder.',
      'CLICK_HERE': 'Resend here'
    },
    'SECURITY': {
      'TITLE': 'Security',
      'ITEMS': {
        'TFA': {
          'LABEL': 'Two-Factor authentication',
          'STATES': {
            'ENABLED': 'Enabled',
            'DISABLED': 'Disabled'
          }
        },
        'CHANGE_PASSWORD': {
          'LABEL': 'Change password',
          'MODAL': {
            'BUTTON': {
              'CANCEL': 'Cancel',
              'CHANGE': 'Change Password'
            },
            'INPUTS': {
              'NEW_PASSWORD': {
                'LABEL': 'New Password',
                'PLACEHOLDER': 'Enter your new password'
              },
              'REPEAT_PASSWORD': {
                'LABEL': 'Repeat Password',
                'PLACEHOLDER': 'Repeat password'
              },
              'CURRENT_PASSWORD': {
                'LABEL': 'Current Password',
                'PLACEHOLDER': 'Enter your password'
              }
            }
          },
          'CHANGED': 'Changed'
        }
      }
    },
    'LICENSE_AGREEMENT': {
      'SHOW': 'Show',
      'AGREE': 'I Agree',
      'TITLE': 'License Agreement',
      'LABEL': 'GroupWisdom Software License Agreement',
      'STATUS': {
        'ACCEPTED': 'Accepted',
        'DECLINED': 'Declined',
        'PENDING': 'Pending'
      },
      'DECLINE': 'Decline',
    },
    'TERMS': {
      'SHOW': 'Show',
      'LABEL': 'GroupWisdom Terms'
    },
    'PRIVACY': {
      'SHOW': 'Show',
      'LABEL': 'GroupWisdom Privacy'
    },
    'MY_PROJECTS': {
      'TITLE': 'My Projects'
    },
    'EMAIL_WAS_NOT_CHANGED': 'Your email wasn\'t updated because you didn\'t verify the code!',
    'PHONE_WAS_NOT_CHANGED': 'Your number wasn\'t updated because you didn\'t verify the code!',
    'INVALID_MAIL': 'Please check this field, can not be blank or invalid mail.',
    'ROLE_PERMISSIONS': {
      'TITLE': 'Account Role',
      'ROLE_PERMISSIONS': 'Role Permissions'
    }
  },

  // ======= LICENSE MODAL =======
  // =============================
  'LICENSE_MODAL': {
    'TEXT': 'You cannot create or enter an existing project. <br>Please go to My Account to review.',
    'TITLE': 'You Declined',
    'TITLE2': 'You Declined the License Agreement',
    'BUTTON': 'Go to my account'
  },

  // ======= EXPORT MODAL =======
  // =============================
  'EXPORT_MODAL': {
    'ALL_LANGUAGES': 'All languages',
    'LANGUAGE_TITLE': 'Select language to download:',
    'JPG': 'JPG image',
    'PNG': 'PNG image',
    'SVG': 'Vector image',
    'PDF': 'PDF document',
    'DOC': 'Word document',
    'PPT': 'PowerPoint document',
    'CSV': 'CSV file',
    'NO_FILE': 'No file extensions to show'

  },

  // ======== MY PROJECTS ========
  // =============================
  'MY_PROJECTS': {
    'TITLE': 'My Projects',
    'NEW_PROJECT': {
      'TITLE': 'New Project',
      'SUBTITLE': 'Let\'s get you started with this...',
      'FIELD': {
        'NAME': { 'LABEL': 'Project Name' },
        'ABBREVIATION': {
          'LABEL': 'Abbreviation',
          'TOOLTIP': 'Choose a unique abbreviation for your project. Remember to use letters only!',
          'REQUIREMENT': '(max. 3 char.)'
        },
        'ADVANCED': { 'LABEL': 'Advanced Options' },
        'LOGO': { 'LABEL': 'Company Logo', 'MESSAGE': 'Upload file from...' },
        'INTERFACE_COLOR': { 'LABEL': 'Interface Color' }
      },
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'CREATE': 'Create Project'
      },
      'IMAGE_TOOLTIP': 'Accepted images are jpg or png and need to be 235 x 60 pixels in size. If your image is larger, it will be scaled to fit.',
      'REQUIRED_FIELDS_TIP': '* are required to create a project',
    },
    'UPGRADE_LICENSE': {
      'TEXT': 'Your current license does not allow new project creation, contact <span>sales@conceptsystems.com</span> to purchase an additional project',
      'TITLE': 'Upgrade License',
      'BUTTON': 'Contact Sales'
    },
    'PROJECT_LIST': {
      'LIST_HEADERS': {
        'PROJECT': 'Project',
        'STATUS': 'Status',
        'DATE': 'Date',
        'ROLE': 'Role'
      },
      'ARCHIVE': 'Archive',
      'CREATED': 'Created',
      'UNARCHIVE': 'Unarchive',
      'SHOW_FILTER': {
        'LABEL': 'Show',
        'ITEM': {
          'ALL': 'All projects',
          'CLOSED': 'Closed',
          'ARCHIVED': 'Archived',
          'CLOSED_ACTIVITIES': 'Active with closed activities',
          'OPEN_ACTIVITIES': 'Active with open activities',
          'INACTIVE': 'Inactive',
        }
      },
      'SORT_FILTER': {
        'LABEL': 'Sort by',
        'ITEM': {
          'LAST_OPENED': 'Last opened by me',
          'LAST_ACTIVITY': 'Last activity status changed',
          'ALPHABETICAL': 'Alphabetical'
        }
      },
      'NO_PROJECT': {
        'CREATED': {
          'TITLE': 'You haven\'t created any projects yet',
          'MESSAGE': 'Let\'s do it! Select New Project to create a new one'
        },
        'CLOSED': 'You don\'t have any closed projects yet',
        'ARCHIVED': 'You don\'t have any archived projects yet',
        'CLOSED_ACTIVITIES': 'You don\'t have any active projects with closed activities',
        'OPEN_ACTIVITIES': 'You don\'t have any active projects with open activities',
        'INACTIVE': 'You don\'t have any inactive projects',
        'FOUND': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, adipisci!'
      }
    }
  },

  // ======== HELP CENTER ========
  // =============================
  'HELP_CENTER': {
    'TITLE': 'Help Center',
    'PLACEHOLDER': 'Search for a topic or question',
    'METHODOLOGY': 'Methodology',
    'METHODOLOGY_DESCRIPTION': 'Documentation and project-related information.',
    'TROUBLESHOOTING': 'Troubleshooting',
    'TROUBLESHOOTING_DESCRIPTION': 'Having any issues with Global Max? Find your answers here.',
    'LICENSING_AND_SALES': 'Licensing and Sales',
    'LICENSING_AND_SALES_DESCRIPTION': 'Looking to increase the size of your team? Find all the information here.',
    'CANT_FIND_WHAT_YOU_RE_LOOKING_FOR': 'Cant find what you’re looking for? ',
    'CONTACT_US': 'Contact us',
    'WE_RE_ALWAYS_HAPPY_TO_HELP': ', we’re always happy to help!',
  },
  'CONTACT_US': {
    'WE_ARE_ARE_HAPPY_TO_HELP': 'We are happy to help!',
    'IF_YOU_HAVE_ANY_PROBLEMS_WITH': 'If you have any problems with GroupWisdom, need assistance with something, \
    or having problems with your license, we’re happy to help! Shoot us a message and we’ll get back to you as soon as we can.',
    'EMAIL_ADDRESS': 'Email address',
    'EXAMPLE_YOUREMAIL_COM': 'example@youremail.com',
    'PHONE': 'Phone',
    'EXAMPLE_PHONE': ' ',
    'TOPIC': 'Topic',
    'SELECT_AN_OPTION': 'Select an option',
    'SUBJECT': 'Subject',
    'SUMMARIZE_WHAT_YOU_NEED_HERE': 'Summarize what you need here',
    'MESSAGE': 'Message',
    'TELL_US_EVERYTHING_YOU_NEED': 'Tell us everything you need, please include all the details you can',
    'MAX_200_CHARACTERS': '(max. 200 characters)',
    'SEND_MESSAGE': 'SEND MESSAGE',
    'INVALID_EMAIL_FORMAT': 'Invalid email format',
    'INVALID_PHONE_FORMAT': 'Invalid phone format',
    'INVALID_TOPIC': 'Invalid topic',
    'INVALID_MESSAGE': 'Invalid message',
    'TECHNICAL': 'Technical',
    'LICENSE': 'License',
    'ACCOUNT': 'Account',
    'YOUR_MESSAGE_HAS_BEEN_SENT': 'Your message has been sent',
    'WE_WILL_BE_IN_TOUCH_SHORTLY': 'We’ll be in touch shortly',
    'SOMETHING_WENT_WRONG': 'Something went wrong',
    'WE_WERENT_ABLE_TO_SEND_YOUR_MESSAGE': 'We weren’t able to send your message, we are working to fix this.',
    'IN_THE_MEANTIME': 'In the meantime, here’s what you wrote so you can copy your message to the clipboard and send it back later or write an email to ',
    'EMAIL_SUPPORT': 'support@globalwisdom.com',
    'COPY_TO_CLIPBOARD': 'Copy to clipboard',
    'RETRY_TO_SEND_MESSAGE': 'RETRY TO SEND MESSAGE'
  },
  'HELP_CENTER_ARTICLES': {
    'READ_MORE': 'Read more'
  },

  // ====== PROJECT LANDING ======
  // =============================
  'PROJECT_LANDING': {
    'SUMMARY_TITLE': 'Project Summary',
    'ACTIVITY_NAMES': {
      'PQ': 'Participant Questions',
      'BS': 'Brainstorming',
      'ST': 'Sorting',
      'RT': 'Rtg.'
    },
    'NUMBERS': {
      'ASSIGNED': 'Assigned',
      'STARTED': 'Started',
      'FINISHED': 'Finished'
    },
    'QUOTA': 'Available participants',
    'PROGRESS': {
      'TITLE': 'How to Get Started',
      'HIDE': 'Hide',
      'SHOW': 'Show',
      'COMPLETED': 'Completed',
      'OF': 'of'
    },
    'COPY_LINK': 'Copy link',
    'LOCK_MESSAGE_TITLE': 'To %0 %1 you need to:',
    'STATUS_MODAL': 'Activity status cannot be changed',
    'ACTIVITY': 'Activity'
  },

  // ===== PROJECT SETTINGS ======
  // =============================
  'PROJECT_SETTINGS': {
    'TITLE': 'Project Settings',
    'ACTIONS': {
      'EXPORT': 'Export Full Size Project'
    },
    'SIZE': 'Focus statement font size',
    'TABS': {
      'PROJECT_CONTENT': 'Project Content',
      'ADMIN_MANAGEMENT': 'Role Management',
      'GENERAL_SETTINGS': 'General Settings'
    },
    'PROJECT_CONTENT': {
      'FOCUS_PROMPT': {
        'TITLE': 'Focus Prompt',
        'BOX_LABEL': 'Intro to activity',
        'PLACEHOLDER': 'Type your project\'s Focus Prompt here...',
        'EMPTY_ERROR': 'Focus Prompt cannot be empty',
        'WARNING_MODAL': {
          'TITLE': 'Focus Prompt Change',
          'TEXT': 'If you have already collected brainstorming statements, changing the focus prompt will remove important context from the collected data.\
           Are you absolutely sure you want to change your focus prompt?',
          'BUTTONS': {
            'CANCEL': 'Cancel',
            'CONTINUE': 'Continue'
          }
        },
        'TOOLTIP': 'If any of your participants may use mobile devices, we suggest a focus prompt no longer than 130 characters.' +
        ' Please view the prompt on mobile devices before inviting participants.',
      },
      'INFORMED_CONSENT': {
        'TITLE': 'Consent to Participate',
        'FILE_BUTTON': 'Browse file (.pdf, .doc, .docx)',
        'REQUEST_SIGN': 'Request sign-off and re-upload',
        'REQUEST_SIGN_TOOLTIP': 'A file for consent to participate has been uploaded. The default is to require participants' +
        ' to download the attachment, sign the document and re-upload to show acceptance. This box can be unchecked; in that' +
        ' case the attached document will be provided only for download along with the text.',
        'EDITED': 'Edited',
        'BACK_TO_DEFAULT': 'Back to default ',
        'DEFAULT': 'Default',
        'TOOLTIP': 'If enabled, participants will need to provide consent to enter the project. ' +
        'If any of your participants may use mobile devices, we suggest the textbox hold no more than 500 characters.' +
        ' A file can be uploaded to accompany the text below. Please note a checkbox will appear below the uploaded' +
        ' file asking if a signature will be required from participants.',
        'MODAL': {
          'TITLE': 'Upload consent to participate',
          'BUTTONS': { 'CANCEL': 'Cancel', 'UPLOAD': 'Upload' },
          'SUBTITLE': 'Upload a pdf or word file for your participants to download',
          'DRAGDROP': {
            'TITLE': 'Drag a pdf or word file here to upload <small>or</small>',
            'ANCHOR': 'Browse file (.pdf, .doc, .docx)',
            'DIFFERENT': 'Upload a different file (.pdf, .doc, .docx)',
            'ERROR': {
              'TYPE': 'Consent to Participate can only be uploaded in PDF or WORD format.',
              'SIZE': 'File limit is 10MB, try again.',
              'LIMIT': 'Only one file can be uploaded, try again.',
            }
          }
        },
        'REMOVE_WARNING': {
          'TITLE': 'Remove Consent to Participate',
          'BUTTONS': { 'CANCEL': 'Cancel', 'CONTINUE': 'Continue' },
          'SUBTITLE': 'Are you sure you want to remove this file?'
        }
      },
      'WELCOME_MESSAGE': {
        'TITLE': 'Project Welcome Message',
        'TITLE_MESSAGE': 'Welcome message title',
        'BODY_MESSAGE': 'Welcome message text',
        'TOOLTIP': 'This message appears after the participant accepts the Consent to Participate.  The participant will see this message only the first time they enter the project.',
      },
      'THANK_YOU_MESSAGE': {
        'TITLE': 'Thank You Message',
        'TITLE_MESSAGE': 'Thank you title',
        'BODY_MESSAGE': 'Project completion thank you',
        'URL': 'URL',
        'REMOVE_URL': 'Remove redirection url',
        'URL_PLACEHOLDER': 'Paste url here',
        'REMOVE_REDIRECTION': 'Remove redirection url',
        'ADD_REDIRECTION_URL': 'ADD REDIRECTION URL',
        'EDITED': 'Edited',
        'BACK_TO_DEFAULT': 'Back to default ',
        'DEFAULT': 'Default',
        'URL_ERROR': 'Invalid url',
        'TOOLTIP': 'This text appears when participants complete all activities assigned to them and return to the project homepage.',
      }
    },
    'ADMIN_MANAGEMENT': {
      'BUTTONS': {
        'INVITE': 'Invite new user'
      },
      'INVITE_USER': {
        'TITLE': 'Invite New User',
        'SUBTITLE': 'Send an invitation to a researcher to join your project',
        'INVALID_EMAIL': 'Please enter a valid email address',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'SUBMIT': 'Select role'
        }
      },
      'SELECT_ROLE': {
        'TITLE': 'Select Role',
        'SUBTITLE': 'Choose the permissions you want this user to have',
        'EMPTY_SELECTION': 'Please choose user role',
        'TABS': {
          'ROLES': 'Roles',
          'PERMISSIONS': 'Permissions'
        },
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'SUBMIT': 'Send invite'
        }
      },
      'USER_LIST': {
        'STATUS': {
          'PENDING': 'Pending',
          'INACTIVE': 'Inactive'
        },
        'DROPDOWN': {
          'EDIT': 'Edit permissions',
          'DELETE': 'Delete user',
          'ACTIVATE': 'Activate',
          'DEACTIVATE': 'Deactivate'
        },
        'TOOLTIP': 'This is how you invite other project managers to your project and select a role.' +
        '  Do not invite participants using this button.  Those invited from this button will not be added to the project as participants.' +
        ' They will show as pending until they activate their account.',
      },
      'EDIT_USER': {
        'SUBTITLE': 'Customize the permissions for this user',
        'BUTTONS': {
          'SAVE': 'Save',
          'CANCEL': 'Cancel'
        }
      },
      'REMOVING_PERMISSIONS_WARNING': {
        'TITLE': 'Removing Permissions',
        'TEXT': 'Are you sure you want to remove permissions?',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'CONTINUE': 'Continue'
        }
      },
      'DELETING_ADMIN_WARNING': {
        'TITLE': 'Deleting User!',
        'TEXT': 'Are you sure you want to delete this user from the project?',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'CONTINUE': 'Continue'
        }
      },
      'DEACTIVATING_ADMIN_WARNING': {
        'TITLE': 'Deactivating Admin!',
        'TEXT': 'Are you sure you want to deactivate this user from the project?',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'CONTINUE': 'Continue'
        }
      }
    },
    'GENERAL_SETTINGS': {
      'GENERAL_SETTINGS': {
        'GENERAL_SETTINGS': 'General Settings',
        'PROJECT_NAME': 'PROJECT NAME',
        'ABBREVIATION': 'ABBREVIATION',
        'PROJECT_STATUS': 'PROJECT STATUS',
        'LANGUAGES': 'LANGUAGES',
        'DEFAULT_LANGUAGE': 'DEFAULT LANGUAGE',
        'ACTIVE': 'Active',
        'INACTIVE': 'Inactive',
        'HIDDEN': 'Hidden',
        'SHOWN': 'Shown',
        'MAX_CHARS': 'max. 3 char.',
        'ERRORS': {
          'NAME': 'You must enter a project name',
          'ABBREVIATION': 'You must enter an abbreviation'
        },
        'STATUS_WARNING': {
          'TITLE': 'Changing Project Status',
          'TEXT': 'Setting this project as inactive will close any open activities and prevent data changes. Once inactive, the project will be read only.',
          'BUTTONS': {
            'CANCEL': 'Cancel',
            'CONTINUE': 'Continue'
          }
        },
        'TOOLTIP': 'If you close the project and deactivate it, all available activities will close.  While a project is inactive, you will not be able to open project activities. ',
        'LANGUAGES_TOOLTIP': 'These are the languages that are currently enabled for the participant sections of your project.',
        'HIDE_ENGLISH_TOOLTIP': 'If a language other than English is selected as the default, you may hide English.',
        'CAPACITY_NOTIFICATION_TOOLTIP': 'You can check any of these boxes to notify all project administrators when participant capacity reaches the respective threshold.',
      },
      'CONTACT_INFORMATION': {
        'TITLE': 'Contact Information',
        'CONTACT_EMAIL': 'CONTACT EMAIL',
        'CONTACT_PHONE': 'CONTACT PHONE',
        'CONTACT_TOOLTIP': 'The email address you enter will appear on invitations and when participants use the help/support link for the project.',
        'PHONE_TOOLTIP': 'The number will appear on invitations and when participants use the help/support link for the project.',
      },
      'CUSTOMIZATION': {
        'TITLE': 'Customization',
        'MESSAGE': 'UPLOAD FILE FROM...',
        'PREVIEW': 'Preview',
        'COMPANY_LOGO': 'COMPANY LOGO',
        'INTERFACE_COLOR': 'INTERFACE COLOR',
        'INTERFACE_COLOR_TOOLTIP': 'Your selection changes the color of the participant activities interface.'
      },
      'PREVIEW': {
        'EXIT_TITLE': 'You are previewing as a participant.',
        'EXIT_TITLE_STAFF': 'You are editing as a staff member.',
        'EXIT_BUTTON': 'Exit preview',
        'EXIT_BUTTON_STAFF': 'Exit project entry',
        'LANG': 'EN',
        'ACTIVITIES': 'Your available activities',
        'CLOSES': 'Closes'
      }
    },
    'CHARS_LEFT': 'characters left',
    'CHARS': 'characters',
    'LIMIT_EXCEEDED': 'Keep characters within limit in order to save',
    'MULTI_LANG': {
      'TITLE': 'This page contains multi-language content',
      'EDITING': 'Editing content in %0'
    },
    'EXPORT': {
      'TITLE': 'Downloading project...',
      'DESCRIPTION': 'This might take a while. Select OK to continue working as we\'ll send you an email with the finished file. ' +
        'Do not select OK if you want to wait for the file to download in your browser.',
      'BUTTON': 'ok'
    },
    'EXPORT_ERROR': {
      'TITLE': 'Download Error',
      'DESCRIPTION_1': 'Ther was an error while downloading the project.',
      'DESCRIPTION_2': 'Please try again!',
      'BUTTON': 'Close'
    }
  },

  // ====== PROJECT SIDEBAR ======
  // =============================
  'PROJECT_SIDEBAR': {
    'SEARCH': 'Search',
    'PROJECT_SETTINGS': 'Project Settings',
    'PROJECT_MESSAGES': 'Project Messages',
    'ACTIVITIES': {
      'TITLE': 'Activities',
      'PARTICIPANT_QUESTIONS': 'Participant Questions',
      'BRAINSTORMING': 'Brainstorming',
      'SORTING': 'Sorting',
      'RATING': 'Rating',
      'REVIEWDATA': 'Review Data',
      'OFFLINEDATAMANAGER': 'Offline data manager'
    },
    'PARTICIPANTS': {
      'TITLE': 'Participant Data',
      'PARTICIPANTS': 'Participants'
    },
    'ANALYSIS': {
      'TITLE': 'Analysis & Reporting',
      'ANALYSIS': 'Analysis',
      'REPORTS': 'Reports'
    }
  },

  // === PARTICIPANT QUESTIONS ===
  // =============================
  'PARTICIPANT_QUESTIONS': {
    'TITLE': 'Participant Questions',
    'NEW_PAGE': '+ Add new page',
    'NEW_QUESTION': 'New Question',
    'PAGE_EMPTY': 'This page is empty. Drag and drop to place questions here',
    'NONE': 'None',
    'END': 'End Survey',
    'ACTIONS': {
      'OPEN': 'Open',
      'PREVIEW': 'Preview as participant',
      'DROPDOWN': {
        'COPY': 'Copy <strong>Participant Questions</strong> link',
        'DOWNLOAD': 'Download <strong>Participant Question</strong>'
      },
      'ACTIVITY': 'Activity'
    },
    'TABS': {
      'QUESTIONS': 'Questions',
      'SETTINGS': 'Settings',
      'PARTICIPANTS': 'Participants'
    },
    'PAGES': {
      'LABEL': 'Page',
      'NEW_PAGE': '+ Add new page'
    },
    'CARD': {
      'ACTIONS': {
        'DRAG': 'Drag',
        'DUPLICATE': 'Duplicate',
        'DELETE': 'Delete'
      },
      'OPTIONS': {
        'OPTION': 'Option',
        'ADD_DESCRIPTION': 'Add description',
        'ADD_DESCRIPTION_TOOLTIP': 'If you have additional information to clarify the question, add it on this line of text.',
        'DOWNLOAD_TOOLTIP': 'This downloads the list of usernames you are currently entering into the system.',
        'ALLOW_LOGIC_JUMPS': {
          'TEXT': 'Allow logic jumps',
          'TOOLTIP': 'If you turn on logic jumps, you will be able to select whether participants who select a response skip to a later question or end the survey (none).' +
          ' Their response to skipped questions will be \'did not respond\' in analysis and reports.',
        },
        'MAX_CHARACTERS_TOOLTIP': 'This setting limits the number of characters participants can use in their response to the question.',
        'MANDATORY': {
          'TEXT': 'Required',
          'TOOLTIP': 'When you set a question as required, your participants will not be able to complete an activity until the question is answered.'
        },
        'DECIMALS_ALLOWED': {
          'TOOLTIP': 'The number of decimals the participant is allowed to enter.'
        }
      },
      'ERROR': {
        'TITLE': 'The title cannot be blank',
        'DESCRIPTION': 'The description cannot be blank'
      }
    },
    'QUESTION_TYPES': {
      'SINGLE_CHOICE': 'Single Choice',
      'MULTIPLE_CHOICE': 'Multiple Choice',
      'SCALE': 'Scale',
      'OPEN_TEXT': 'Open Text'
    },
    'QUESTION': {
      'TYPE': 'Type',
      'MAX_CHARS_ERROR': '0 characters is not valid',
      'INVALID_NUMBER': 'Maximum value should be greater than minimum'
    },
    'EXAMPLES': {
      'TITLE': 'Enter your question',
      'DESCRIPTION': 'Description Example'
    },
    'ERROR_MODAL': {
      'TITLE': 'Participant Question Limit',
      'TEXT': 'You have reached your limit for Participant Questions. No new question can be created.',
      'BUTTON': 'Accept'
    },
    'DELETE_MODAL': {
      'TITLE': 'Delete Page',
      'TEXT': 'All the participant questions of page %0 will be deleted',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'CONTINUE': 'Continue'
      }
    },
    'CARD_TEXT': {
      'JUMP': 'Jump to:',
      'OTHER': 'Andre',
      'ADD_OPTION': '+ add option',
      'ADD_OTHER': '+ add other',
      'MAX': 'max',
      'MIN': 'min',
      'TO': 'to',
      'ANSWER': 'Enter an Aswer',
      'WARNING': 'A participant belonging to two or more groups won\'t be counted in group comparisons.',
      'READ_MORE': 'Read more',
      'RANGE': 'Range',
      'NUMERIC': 'Numeric',
      'DECIMALS_ALLOWED': 'Decimals allowed',
      'MAX_CHARACTERS': 'Max. characters'
    },
    'DELETE_CARD_MODAL': {
      'TITLE': 'Delete Participant Question',
      'TEXT': 'Are you sure you want to delete this question?',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'CONTINUE': 'Continue'
      }
    },
    'LOGIC_JUMP_WARNING_MODAL': {
      'TITLE': 'Disable Logic Jumps',
      'TEXT': 'Are you sure you want to disable Logic Jumps?',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'CONTINUE': 'Continue'
      }
    },
    'EXPORT_MODAL': {
      'TITLE': 'Download Questions As...',
      'SUBTITLE': 'Select your download options',
      'TYPES': {
        'WORD': 'Word document',
        'PDF': 'PDF document'
      },
      'DOWNLOAD': 'download'
    },
    'QUESTIONS_AMOUNT_MODAL': {
      'TITLE': 'Attach Participant Questions?',
      'TEXT': 'In order to ask participant questions to another activity:',
      'SUB_TEXT': 'You need to create a question first from the questions tab',
      'BUTTON': 'OK'
    },
    'QUESTIONS_DELETE_WARNING_MODAL': {
      'TITLE': 'Deleting Participant Questions',
      'TEXT': 'In order to delete a participant question you need to set this activity as independent from the settings tab.',
      'SUB_TEXT': 'If participants have already answered questions, you will lose their data if you continue to delete a question.',
      'BUTTON': 'OK'
    },
    'SETTINGS': {
      'TITLE': 'ATTACH BEFORE',
      'TOOLTIP': 'If a participant is assigned  to multiple activities,  they will answer participant questions the first' +
      ' time they click any of the attached activities. If they do not complete the questions at the first  activity, ' +
      'they will be asked to complete them when they enter the project again.',
      'IDENTIFICATION': 'IDENTIFICATION',
      'IDENTIFICATION_TOOLTIP': 'Lorem ipsum in door.',
      'ASSIGNED-PARTICIPATION-ONLY': 'Assigned participation only',
      'ASSIGNED-PARTICIPATION-ONLY-TOOLTIP': 'When this option is enabled, only existing participants assigned to this activity (from the participants page) will be able to participate.\
      New participants will not be able to sign up and contribute to this activity. \
      This allows the project team to precisely control which participants contribute to this activity.',
      'SELECT_PLACEHOLDER': 'Select an activity',
      'IDENTIFIER_TOOLTIP': 'If you have a preferred naming standard or structure you would like your participants to use when creating their account,' +
      ' edit this text for instruction. [example: Please enter your Student ID]',
    },
    'SHOW_BY_DROPDOWN': {
      'LABEL': 'Show',
      'ITEMS': {
        'ALL': 'All',
        'ASSIGNED': 'Assigned to Participant Questions',
        'NOT_ASSIGNED': 'Not assigned for Participant Questions',
        'COMPLETED': 'Completed Participant Questions',
        'STARTED': 'Started Participant Questions',
        'APPROVED': 'Approved Participant Questions',
        'REJECTED': 'Rejected Participant Questions',
      },
    },
    'PARTICIPANTS': {
      'LOADING': 'Loading',
      'NO_RESULTS': 'No results found',
      'PARTICIPANTS': 'participants',
      'SEARCH_PLACEHOLDER': 'Search Participants',
      'SHOW_BY_DROPDOWN': {
        'LABEL': 'Show',
        'ITEMS': {
          'ALL': 'All',
          'ASSIGNED': 'Assigned to Participant Questions',
          'NOT_ASSIGNED': 'Not assigned for Participant Questions',
          'COMPLETED': 'Completed Participant Questions',
          'STARTED': 'Started Participant Questions',
        }
      },
      'ONLY_CONTRIBUTORS': {
        'LABEL': 'Show contributors only',
        'TOOLTIP': 'Lorem ipsum'
      },
      'NEW_PARTICIPANT': 'New Participant',
      'TABLE_TABS': {
        'IC': 'IC',
        'USERNAME': 'Username',
        'PQ_STATUS': 'PQ Status',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_ACCEPTANCE': 'Time of Acceptance',
        'TIME_DECLINE': 'Time of Declination',
        'LAST_ACTIVITY': 'Last Active',
        'LAST_LOGIN': 'Last Login',
        'TOOLTIP': {
          'IC': 'Consent to Participate',
          'PQ_STATUS': 'Participant Questions Status',
          'IC_ACCEPTED': 'Accepted',
          'IC_REJECTED': 'Rejected',
          'IC_PENDING': 'Pending',
          'IC_DISABLED': 'Disabled'
        }
      },
      'TABLE_SETTINGS': {
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
        'TIME_OF_DECLINE': 'Time of Declination',
        'LAST_ACTIVE': 'Last Active',
        'LAST_LOGIN': 'Last Login'
      },
      'ASSIGNATION': {
        'PARTICIPANTS': 'Participants',
        'SELECTED': 'Selected',
        'ASSIGN_FOR': 'Assign for:',
        'UNASSIGN_FOR': 'Unassign for:',
        'PARTICIPANT_QUESTIONS': 'Participant Questions',
        'ASSIGN': 'Assign',
        'ASSIGN_SENT': 'Assign & Send',
        'UNASSIGN': 'Unassign',
        'APPLY': 'Apply'
      },
      'ASSIGN_MODAL': {
        'TITLE': 'Send Invites for Participant Questions',
        'PREVIEW': {
          'DO_YOU_HAVE_QUESTIONS': 'Do you have any questions or feedback for our project? Contact us:',
          'UNSUSCRIBE': 'Unsubscribe',
          'PRIVACY': 'Privacy'
        },
        'MESSAGE': {
          'TITLE': 'You have been invited to answer Participant Questions.',
          'P1': 'We really appreciate your collaboration in our project!',
          'P2': `In this important project, we would like you to participate and answer Participant Questions.
          Please complete the set of questions, where you can skip any non-mandatory questions if you feel necessary. <br> <br>
          Your answers to these questions will help to organize and analyze the data. <br>`,
          'P3': 'Thank you in advance for your help!'
        },
        'LINK': 'Begin Participant Questions',
      },
      'DISCARD_CHANGES': {
        'TITLE': 'Apply filter?',
        'TEXT_1': 'If you filter, any activities you have selected to be assigned or unassigned will be removed.',
        'TEXT_2': 'Are you sure you want to apply this filter?',
        'BUTTONS': {
          'CANCEL': 'No, cancel',
          'DISCARD': 'Yes, apply'
        }
      },
      'QUOTA_REACHED': {
        'TITLE': 'Participant quota limit reached',
        'TEXT_1': 'You can\'t add any more offline data for participants because you\'ve reached your license limit.',
        'TEXT_2': 'Contact sales@conceptsystems.com to purchase a quota increase or if applicable, deactivate unused participants.',
        'BUTTONS': {
          'OK': 'Ok'
        }
      }
    },
    'DATE_TOOLTIP_OPEN': 'Set a date and time for the server to automatically open the activity. The server time zone ' +
    'is UTC +0. If you intend to open the activity manually, set it to "Manual Open."',
    'DATE_TOOLTIP_CLOSE': 'Set a date and time for the server to automatically close the activity. The server time zone' +
    ' is UTC +0. If you intend to open the activity manually, set it to "Manual Close."',
  },

  // ======= BRAINSTORMING =======
  // =============================
  'BRAINSTORMING': {
    'TITLE': 'Brainstorming',
    'NO_DATA': 'No data to export.',
    'ACTIONS': {
      'OPEN': 'Open',
      'PREVIEW': 'Preview as participant',
      'PREVIEW_KEYWORD': 'You can create keywords and then attach them to statements.  This will allow you to filter and organize the statements. ',
      'PREVIEW_KEYWORD_MORE': 'More Info...',
      'SPLIT_TOOLTIP': 'If the statement contains multiple ideas, it is recommended to split the statement.  Each statement should be one idea.  ',
      'DROPDOWN': {
        'COPY': 'Copy <strong>Brainstorming</strong> link',
        'IMPORT': 'Import <strong>Statements</strong>',
        'EXPORT': 'Export <strong>Statements</strong>',
        'DOWNLOAD': 'Download <strong>Raw Statement</strong> list'
      },
      'KEYWORDS': {
        'TITLE': 'Keyword',
        'CREATE': 'Create new keyword',
        'ADD': '+ Add keyword'
      },
      'SEARCH': {
        'PLACEHOLDER': 'Search statements or keywords'
      },
      'SPLIT': 'Split',
      'DELETE': 'Delete',
      'ACTIVITY': 'Activity',
      'EDIT': {
        'ERROR_BLANK': 'Statement cannot be blank',
      },
    },
    'TABS': {
      'STATEMENTS': 'Statements',
      'SETTINGS': 'Settings',
      'PARTICIPANTS': 'Participants',
      'MONITOR': 'Activity Monitor'
    },
    'STATEMENTS': {
      'SHOW_PROMPT': 'Show Prompt',
      'HIDE_PROMPT': 'Hide Prompt',
      'FOCUS_PROMPT': 'Focus Prompt:',
      'ALL_LANGUAGES': 'All languages',
      'NO_KEYWORDS_YET': 'No Keywords added yet',
      'LOADING_STATEMENTS': 'Loading Statements...',
      'NEW_STATEMENT': 'New Statement',
      'LOCKED_ADD_STATEMENT': 'Statements should not be added while sorting and rating are open. You should not add or ' +
      'delete statements once actual sorting and rating data has been collected from participants. These statements ' +
      'will also lock once you enter analysis.',
      'NEW_STATEMENT_PLACEHOLDER': 'Type statement',
      'DONE': 'Done',
      'CHARS_LEFT': 'characters left',
      'ENTER_TO_ADD': 'enter to add',
      'ADD': 'Add',
      'STATEMENT': 'Statement',
      'STATEMENTS': 'Statements',
      'ABC': 'abc',
      'KEYWORD_PLACEHOLDER': 'Enter a keyword',
      'ORIGINAL_TEXT': 'Original Text',
      'KEYWORD_LIMIT_MODAL': {
        'TITLE': 'Keywords Limit',
        'MESSAGE': 'You can only have two keywords per statement.',
        'BUTTON': 'Accept'
      },
      'KEYWORD_EXIST_MODAL': {
        'TITLE': 'Keyword Already Exist',
        'MESSAGE': 'This keyword already exist, please add another one.',
        'BUTTON': 'Accept'
      },
      'SPLIT_MODAL': {
        'TITLE': 'Split Statement',
        'SPLIT_INTO': 'Split Into...',
        'NOTE': 'Note: Initial Statement will be deleted',
        'ADD_NEW': '+ Add new statement',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'SPLIT': 'Split'
        }
      },
      'DELETE_MODAL': {
        'TITLE': 'Delete Statement',
        'TEXT': 'Are you sure you want to delete this statement?',
        'WARNING_TEXT': 'Any user sorting or rating data for this statement will also be deleted!',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'CONTINUE': 'Continue'
        }
      }
    },
    'EXPORT_MODAL': {
      'TITLE': 'Export Statements As...',
      'SUBTITLE': 'Select your download options',
      'DOWNLOAD': 'download',
      'TYPES': {
        'WORD': 'Word document',
        'CSV': 'CSV file'
      }

    },
    'IMPORT_MODAL': {
      'TITLE': 'Import Statements',
      'DESCRIPTION': 'Import statements from a .csv file',
      'DRAG': {
        'TITLE': 'Drag a .csv file here to upload <small>or</small>',
        'BROWSE': 'Browse file (.csv)',
        'DIFFERENT': 'Upload a different file (.csv)',
        'ERROR': {
          'TYPE': 'Statements can only be uploaded in CSV format.',
          'LIMIT': 'Only one file can be uploaded, try again.',
        }
      },
      'REPLACE': {
        'WHEN': 'when uploading',
        'LABEL': 'Replace current list',
        'TOOLTIP': 'If checked, this will delete the current list of statements and completely replace it with items in the uploaded file.'
      },
      'BUTTON': {
        'CANCEL': 'Cancel',
        'UPLOAD': 'Upload'
      }
    },
    'SETTINGS': {
      'STATEMENTS_SIZE': {
        'TITLE': 'statements size',
        'LABEL': 'characters',
        'TOOLTIP': 'Enter the maximum number of characters for a brainstorming statement. Default is 250 to encourage participants to enter one idea at a time. ',
      }
    },
    'PARTICIPANTS': {
      'LOADING': 'Loading',
      'NO_RESULTS': 'No results found',
      'PARTICIPANTS': 'participants',
      'SEARCH_PLACEHOLDER': 'Search Participants',
      'SHOW_BY_DROPDOWN': {
        'LABEL': 'Show',
        'ITEMS': {
          'ALL': 'All',
          'ASSIGNED': 'Assigned to Brainstorming',
          'NOT_ASSIGNED': 'Not assigned for Brainstorming',
          'COMPLETED': 'Completed Brainstorming',
          'STARTED': 'Started Brainstorming',
        }
      },
      'ONLY_CONTRIBUTORS': {
        'LABEL': 'Show contributors only',
        'TOOLTIP': 'This lists only participants who have contributed ideas to date.'
      },
      'NEW_PARTICIPANT': 'New Participant',
      'TABLE_TABS': {
        'IC': 'IC',
        'USERNAME': 'Username',
        'BS_STATUS': 'BS Status',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_ACCEPTANCE': 'Time of Acceptance',
        'TIME_DECLINE': 'Time of Declination',
        'LAST_ACTIVITY': 'Last Active',
        'LAST_BRAINSTORMING': 'Last Brainstorming',
        'TOOLTIP': {
          'IC': 'Consent to Participate',
          'BS_STATUS': 'Brainstorming Status',
          'IC_ACCEPTED': 'Accepted',
          'IC_REJECTED': 'Rejected',
          'IC_PENDING': 'Pending',
          'IC_DISABLED': 'Disabled'
        }
      },
      'TABLE_SETTINGS': {
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
        'TIME_OF_DECLINE': 'Time of Declination',
        'LAST_ACTIVE': 'Last Active',
        'LAST_BRAINSTORMING': 'Last Brainstorming'
      },
      'ASSIGNATION': {
        'PARTICIPANTS': 'Participants',
        'SELECTED': 'Selected',
        'ASSIGN_FOR': 'Assign for:',
        'UNASSIGN_FOR': 'Unassign for:',
        'BRAINSTORMING': 'Brainstorming',
        'ASSIGN': 'Assign',
        'ASSIGN_SENT': 'Assign & Send',
        'UNASSIGN': 'Unassign',
        'APPLY': 'Apply'
      },
      'ASSIGN_MODAL': {
        'TITLE': 'Send Invites for Brainstorming',
        'PREVIEW': {
          'DO_YOU_HAVE_QUESTIONS': 'Do you have any questions or feedback for our project? Contact us:',
          'UNSUSCRIBE': 'Unsubscribe',
          'PRIVACY': 'Privacy'
        },
        'MESSAGE': {
          'TITLE': 'You have been invited to Brainstorming',
          'P1': 'We really appreciate your collaboration in our project!',
          'P2': `In this important project, we would like you to participate in the brainstorming activity.
          The time commitment for this activity is minor, but your input is vital.
          You don’t have to contribute all your ideas at once.
          You may add ideas and return to the activity any time while it is open.`,
          'P3': 'Thank you in advance for your participation!'
        },
        'LINK': 'Begin Brainstorming',
      },
      'DISCARD_CHANGES': {
        'TITLE': 'Apply filter?',
        'TEXT_1': 'If you filter, any activities you have selected to be assigned or unassigned will be removed.',
        'TEXT_2': 'Are you sure you want to apply this filter?',
        'BUTTONS': {
          'CANCEL': 'No, cancel',
          'DISCARD': 'Yes, apply'
        }
      },
      'QUOTA_REACHED': {
        'TITLE': 'Participant quota limit reached',
        'TEXT_1': 'You can\'t add any more offline data for participants because you\'ve reached your license limit.',
        'TEXT_2': 'Contact sales@conceptsystems.com to purchase a quota increase or if applicable, deactivate unused participants.',
        'BUTTONS': {
          'OK': 'Ok'
        }
      }
    },
    'ACTIVITY_MONITOR' : {
      'TO': 'to',
      'HEADER1': 'Statements added in this period',
      'HEADER2': 'Total statements added so far',
      'GRAPH_LABEL': 'Added statements',
      'ERROR': 'First date cannot be after second date.',
      'NO_STATEMENTS': 'No statements were added in this timeframe.',
      'DATE_ADDED': 'DATE ADDED',
      'LIST_TITLE': 'STATEMENTS ADDED THIS PERIOD',
      'SHOW_BY_DROPDOWN': {
        'LABEL': 'Brainstorming activity from',
        'ITEMS': {
          '24_HOURS': 'Last 24 hours',
          '7_DAYS': 'Last 7 days',
          '30_DAYS': 'Last 30 days',
          '6_MONTHS': 'Last 6 months',
          '12_MONTHS': 'Last 12 months',
          'CUSTOM_RANGE': 'Custom range',
        }
      },
      'DOWNLOAD_DROPDOWN': {
        'ITEMS': {
          'PDF': 'Download graph as PDF',
          'CSV': 'Download statements as CSV',
        }
      },
    },
    'IMPORT_WARNINGS': {
      'ADD': 'You are about to add the statements in your file to the current statement list. Are you sure you want to add these statements?',
      'REPLACE': 'You are about to replace your entire statement list with the statements in the file. If there is any sorting data or rating data connected to the \
      current list of statements, the data will be removed and it is not recoverable. Are you sure you want to replace the current list of statements?',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'CONTINUE': 'Continue'
      }
    },
    'ERROR_MODAL': {
      'TITLE': 'Brainstorming Limit',
      'TEXT': 'Your current license type does not permit the creation of additional statements.',
      'BUTTON': 'ACCEPT'
    }
  },

  // ========== SORTING ==========
  // =============================
  'SORTING': {
    'TITLE': 'Sorting',
    'TABS': {
      'SETTINGS': 'Settings',
      'PARTICIPANTS': 'Participants'
    },
    'TOOLTIPS': {
      'IDENTIFICATION': 'Select how you would like your participants to log in to complete activities. 1 .Email or Identifier:' +
      ' Participants can log in using their email address or a username of their choice. 2. Email address: Participants ' +
      'must create their username with their email address. 3. Identifier: If you have a preferred naming standard or structure you would like your participants to use ' +
      'when creating their account, edit this text for instruction. [example: Please enter your Student ID] ' +
      '4. Anonymous: Participants use a randomly generated account that cannot be linked to their identity.',
      'BLOCK_REGISTRATION': 'Only existing participants assigned to this activity can participate. New participants will not be assigned to the activity from this link.',
      'ANONYMOUS': 'When enabled, this will allow your participants to return to activities under the same anonymous username.',
      'LAYOUT': 'Statements can be split into pages, only when there is more than 10 statements'
    },
    'ACTIONS': {
      'PREVIEW': 'Preview as participant',
      'DROPDOWN': {
        'COPY': 'Copy <strong>Sorting</strong> link',
        'IMPORT': 'Copy <strong>Sort & Rate</strong> link'
      },
      'BUTTON': {
        'CLOSE': 'Close',
        'OPEN': 'Open'
      },
      'ACTIVITY': 'Activity'
    },
    'COPY_LINK_MODAL': {
      'TITLE': 'Copy Sort & Rate Link',
      'SUBTITLE': 'Select a type of identification ',
      'WARNING': 'Identification will be set for all rating questions and sorting.',
      'CANCEL': 'CANCEL',
      'COPY_LINK': 'COPY LINK'
    },
    'PARTICIPANTS': {
      'LOADING': 'Loading',
      'TOOLTIP': 'Check sorting data',
      'NO_RESULTS': 'No results found',
      'PARTICIPANTS': 'participants',
      'SEARCH_PLACEHOLDER': 'Search Participants',
      'SHOW_BY_DROPDOWN': {
        'LABEL': 'Show',
        'ITEMS': {
          'ALL': 'All',
          'ASSIGNED': 'Assigned to Sorting',
          'NOT_ASSIGNED': 'Not assigned for Sorting',
          'COMPLETED': 'Completed Sorting',
          'STARTED': 'Started Sorting',
          'APPROVED': 'Approved Sorting',
          'REJECTED': 'Rejected Sorting',
        }
      },
      'ONLY_CONTRIBUTORS': {
        'LABEL': 'Show contributors only',
        'TOOLTIP': 'Lorem ipsum'
      },
      'NEW_PARTICIPANT': 'New Participant',
      'TABLE_TABS': {
        'IC': 'IC',
        'USERNAME': 'Username',
        'ST_STATUS': 'ST Status',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_ACCEPTANCE': 'Time of Acceptance',
        'TIME_DECLINE': 'Time of Declination',
        'LAST_ACTIVITY': 'Last Active',
        'LAST_SORTING': 'Last Sorting',
        'TOOLTIP': {
          'IC': 'Consent to Participate',
          'ST_STATUS': 'Sorting Status',
          'IC_ACCEPTED': 'Accepted',
          'IC_REJECTED': 'Rejected',
          'IC_PENDING': 'Pending',
          'IC_DISABLED': 'Disabled'
        }
      },
      'TABLE_SETTINGS': {
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
        'TIME_OF_DECLINE': 'Time of Declination',
        'LAST_ACTIVE': 'Last Active',
        'LAST_SORTING': 'Last Sorting'
      },
      'ASSIGNATION': {
        'PARTICIPANTS': 'Participants',
        'SELECTED': 'Selected',
        'ASSIGN_FOR': 'Assign for:',
        'UNASSIGN_FOR': 'Unassign for:',
        'SORTING': 'Sorting',
        'ASSIGN': 'Assign',
        'ASSIGN_SENT': 'Assign & Send',
        'UNASSIGN': 'Unassign',
        'APPLY': 'Apply'
      },
      'ASSIGN_MODAL': {
        'TITLE': 'Send Invites for Sorting',
        'PREVIEW': {
          'DO_YOU_HAVE_QUESTIONS': 'Do you have any questions or feedback for our project? Contact us:',
          'UNSUSCRIBE': 'Unsubscribe',
          'PRIVACY': 'Privacy'
        },
        'MESSAGE': {
          'TITLE': 'You have been invited to Sorting.',
          'P1': 'We really appreciate your collaboration in our project!',
          'P2': `In this important project, we would like you to participate in the sorting activity. Your participation will help us build a base of knowledge. <br> <br>
          Step 1: You may be asked to answer Participant Questions that will help to organize and analyze the data. <br> <br>
          Step 2: Complete the sorting activity, where you will group the ideas into categories that make sense to you, in terms of how they are related in meaning. <br>`,
          'P3': 'Thank you in advance for your help!'
        },
        'LINK': 'Begin Sorting',
      },
      'DISCARD_CHANGES': {
        'TITLE': 'Apply filter?',
        'TEXT_1': 'If you filter, any activities you have selected to be assigned or unassigned will be removed.',
        'TEXT_2': 'Are you sure you want to apply this filter?',
        'BUTTONS': {
          'CANCEL': 'No, cancel',
          'DISCARD': 'Yes, apply'
        }
      },
      'QUOTA_REACHED': {
        'TITLE': 'Participant quota limit reached',
        'TEXT_1': 'You can\'t add any more offline data for participants because you\'ve reached your license limit.',
        'TEXT_2': 'Contact sales@conceptsystems.com to purchase a quota increase or if applicable, deactivate unused participants.',
        'BUTTONS': {
          'OK': 'Ok'
        }
      }
    },
    'DATA_REVIEW_MODAL': {
      'TITLE': 'Data Review',
      'ACTIVITY': 'Sorting',
      'SEARCH_PLACEHOLDER': 'Search words',
      'PILE': 'Pile',
      'REJECT': 'Reject',
      'APPROVE': 'Approve',
      'ROLLING_BACK': 'Rolling Back...',
      'SAVING': 'Saving...',
      'SORTED': {
        'LABEL': 'Sorted',
        'STATEMENTS': 'statements'
      },
      'PILES': {
        'LABEL': 'Into',
        'PILES': 'piles'
      },
      'NO_SEARCH_MATCH': 'There are no statements that match your search'
    }
  },

  // ========== RATING ===========
  // =============================
  'RATING': {
    'TITLE': 'Rating',

    'ACTIONS': {
      'OPEN': 'Open All',
      'PREVIEW': 'Preview as participant',
      'DROPDOWN': {
        'COPY': 'Copy all <strong>Rating Questions</strong> link',
        'IMPORT': 'Import <strong>Current Presence</strong> link',
        'EXPORT': 'Copy <strong>Sort & Rate</strong> link',
        'DOWNLOAD': 'Download all <strong>Rating Questions</strong>',
        'COPY_LINK': 'Copy <strong>Rating</strong> link',
      },
      'ACTIVITY': 'Questions'
    },
    'TABS': {
      'QUESTIONS': 'Questions',
      'SETTINGS': 'Settings',
      'PARTICIPANTS': 'Participants'
    },
    'SHOW_BY_DROPDOWN': {
      'LABEL': 'Show',
      'ITEMS': {
        'ALL': 'All',
        'ASSIGNED': 'Assigned to Rating',
        'NOT_ASSIGNED': 'Not assigned for Rating',
        'COMPLETED': 'Completed Rating',
        'STARTED': 'Started Rating',
        'APPROVED': 'Approved Rating',
        'REJECTED': 'Rejected Rating',
      },
    },
    'PARTICIPANTS': {
      'SEARCH': 'Search participants',
      'SHOW': 'Show',
      'NEW_PARTICIPANT': 'NEW PARTICIPANT',
      'PARTICIPANTS': 'participants',
      'PARTICIPANTS_SELECTED': 'Participants Selected',
      'ASSIGN': 'ASSIGN',
      'ASSIGN_&_SEND': 'ASSIGN & SEND',
      'ASSIGN_FOR': 'Assign for:',
      'TOOLTIP': 'Check rating data',
      'USERNAME': 'USERNAME',
      'ACTIVITY_STATUS': 'IMPORTANCE',
      'CURRENT_PR': 'CURRENT PR',
      'LOADING': 'Loading',
      'TABLE_TABS': {
        'IC': 'IC',
        'USERNAME': 'Username',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'LAST_ACTIVE': 'Last Active',
        'LAST_LOGIN': 'Last Login',
        'TIME_ACCEPTANCE': 'Time of Acceptance',
        'TIME_DECLINE': 'Time of Declination',
        'RT': 'RT',
        'TOOLTIP': {
          'IC': 'Consent to Participate',
          'IC_ACCEPTED': 'Accepted',
          'IC_REJECTED': 'Rejected',
          'IC_PENDING': 'Pending',
          'IC_DISABLED': 'Disabled'
        }
      },
      'TABLE_SETTINGS': {
        'BS_STATUS': 'BS Status',
        'EMAIL': 'Email',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
        'TIME_OF_DECLINE': 'Time of Declination',
        'LAST_ACTIVE': 'Last Active',
        'LAST_LOGIN': 'Last Login'
      },
      'ASSIGNATION': {
        'RATING': 'Rating',
        'SELECTED': 'Selected',
        'ASSIGN_FOR': 'Assign for:',
        'UNASSIGN_FOR': 'Unassign for:',
        'SORTING': 'Sorting',
        'ASSIGN': 'Assign',
        'ASSIGN_SENT': 'Assign & Send',
        'UNASSIGN': 'Unassign',
        'APPLY': 'Apply'
      },
      'UNASSIGN_RATING': {
        'TITLE': 'Deselect participants',
        'TEXT_1': 'If you deselect this Rating Question, all selected participants will not be assigned/unassigned to this activity.',
        'TEXT_2': 'Are you sure you want to continue?',
        'BUTTONS': {
          'CANCEL': 'No, cancel',
          'DISCARD': 'Yes, apply'
        }
      },
      'DISCARD_CHANGES': {
        'TITLE': 'Apply filter?',
        'TEXT_1': 'If you filter, any activities you have selected to be assigned or unassigned will be removed.',
        'TEXT_2': 'Are you sure you want to apply this filter?',
        'BUTTONS': {
          'CANCEL': 'No, cancel',
          'DISCARD': 'Yes, apply'
        }
      },
      'QUOTA_REACHED': {
        'TITLE': 'Participant quota limit reached',
        'TEXT_1': 'You can\'t add any more offline data for participants because you\'ve reached your license limit.',
        'TEXT_2': 'Contact sales@conceptsystems.com to purchase a quota increase or if applicable, deactivate unused participants.',
        'BUTTONS': {
          'OK': 'Ok'
        }
      }
    },
    'MODAL': {
      'DATA_REVIEW': {
        'TITLE': 'Data Review',
        'REJECT': 'REJECT',
        'APPROVE': 'APPROVE',
        'DATA': {
          'TITLE': 'Rated: ',
          'SUB_TITLE': 'Rating',
          'STATEMENTS': 'Statements',
          'ACTIVITY': 'PILE',
          'INTO': 'Into',
          'PILES': 'piles',
          'RATING_COLUMN': 'Rtg.',
          'RATING_DESCRIPTION': 'Statements'
        }
      },
      'ASSIGN': {
        'TITLE': 'Send Invites for Rating',
        'TO': 'To',
        'PARTICIPANTS': 'participants',
        'EDIT': 'EDIT',
        'PREVIEW': 'PREVIEW',
        'CONTACT_INFORMATION': 'Show contact information',
        'COPY': 'Send me a copy',
        'SEND': 'SEND'
      },
      'MESSAGE': {
        'TITLE': 'You have been invited to Rating',
        'P1': 'We really appreciate your collaboration in our project!',
        'P2': `In this important project, we would like you to participate in the rating activity. <br> <br>
        Step 1: You may asked to answer Participant Questions that will help to organize and analyze the data. <br> <br>
        Step 2: Complete the rating activity, where you will rate each idea according to the rating instructions. <br> <br>`,
        'P3': 'Thank you in advance for your help!',
        'DO_YOU_HAVE_QUESTIONS': 'Do you have any questions or feedback for our project? Contact us:',
        'UNSUBSCRIBE': 'Unsubscribe',
        'PRIVACY': 'Privacy'
      },
      'LINK': 'Begin Rating',
    },
    'EXPORT_MODAL': {
      'TITLE': 'Download Rating Questions As...',
      'SUBTITLE': 'Select your download options',
      'TYPES': {
        'CSV': 'CSV file',
        'WORD': 'Word document',
        'PDF': 'PDF document'
      },
      'DOWNLOAD': 'download'
    },
    'RATING_STATEMENTS': 'Rating statements',
    'TABLE_SETTINGS': {
      'EMAIL': 'Email',
      'FIRST_NAME': 'First Name',
      'LAST_NAME': 'Last Name',
      'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
      'TIME_OF_DECLINE': 'Time of Declination',
      'LAST_ACTIVE': 'Last Active',
      'LAST_LOGIN': 'Last Login',
      'RT': 'Rt'
    }
  },

  // ====== RATING SETTINGS ======
  // =============================
  'RATING_SETTINGS': {
    'SAME_SETTINGS': 'Use the same settings for all rating questions',
    'IDENTIFICATION': 'IDENTIFICATION',
    'IDENTIFICATION-TOOLTIP': 'This will set your participant\'s registration type for this activity.',
    'ASSIGNED-PARTICIPATION-ONLY': 'Assigned participation only',
    'ASSIGNED-PARTICIPATION-ONLY-TOOLTIP': 'When this option is enabled, only existing participants assigned to this activity (from the participants page) will be able to participate.\
     New participants will not be able to sign up and contribute to this activity. \
    This allows the project team to precisely control which participants contribute to this activity.',
    'STATEMENTS-RANDOMIZATION': 'STATEMENT RANDOMIZATION',
    'LAYOUT': {
      'LABEL': 'LAYOUT',
      'SPLIT': 'pages',
      'DROPDOWN': {
        'SINGLE_PAGE': 'Single page',
        'SPLIT': 'Split into pages'
      }
    },
    'OPEN-DATE': {
      'LABEL': 'OPEN DATE'
    },
    'CLOSE-DATE': {
      'LABEL': 'CLOSE DATA'
    },
    'HIDE-FOCUS-PROMPT': {
      'LABEL': 'Hide focus prompt by default',
    },
    'ADD_REDIRECTION_URL': 'ADD REDIRECTION URL',
    'THANK_YOU_MESSAGE': {
      'URL': 'URL',
      'REMOVE_URL': 'Remove redirection url',
      'URL_PLACEHOLDER': 'Paste url here',
      'REMOVE_REDIRECTION': 'Remove redirection url',
      'URL_ERROR': 'Invalid url'
    },
    'RATING_LIST': {
      'LEGEND': 'Question'
    }
  },

  // ========== OFFLINE DATA MANAGER ==========
  // ==========================================
  'OFFLINE_DATA_MANAGER': {
    'TITLE': 'Offline Data Manager',
    'PROJECT_INSTRUCTION': 'Project Instructions',
    'PROJECT_INSTRUCTION_TOOLTIP': 'You may download the editable instructions from the project.',
    'DOWNLOAD_RATING_SHEETS_NUMERIC_TOOLTIP': 'During setup, the option for Numeric rating was selected. Bubble or Checkbox Rating Sheets are not available' +
    ' for numeric rating. If you would like different rating sheet options, please return to Ratings to edit the setting for this rating question from Numeric to Radio buttons.',
    'IMPORT_PARTICIPANT_QUESTION_TOOLTIP': 'Please upload data for only the participant you have selected. For more information click',
    'MORE_INFO': 'Read more',
    'BULK_IMPORT_PARTICIPANT_QUESTION_TOOLTIP': 'Upload Participant Question data for several participants at once.',
    'BULK_EXPORT_PARTICIPANT_QUESTION_TOOLTIP': 'Export all Participant Question data to .csv file.',
    'SHOW_FILTER_TOOLTIP': 'Filter participants by their assignment or status in this activity.' +
    ' Warning: If the filter is left on, it will also affect the switch participant list inside individual data entry.',
    'SHOW_FILTER_REVIEW_TOOLTIP': 'Filter participants by their assignment or status in this activity.',
    'TIME_TOOLTIP': 'Elapsed time for each activity is the total amount of time taken once the participant has entered the activity and the last save.\n' +
    'If the participant has marked it as FINISHED for Sorting or Rating, then system displays the time elapsed from start to finish. ',
    'SHOW_FILTER_TOOLTIP_REVIEW': 'Only approved data is used in analysis. You need to quality check each participant\'s data for each activity. Any filters or pagination selected will affect the individual review screen navigation arrows. The navigation arrows will only toggle through the participant data rows shown on the current screen.',
    'ERROR_BRAINSTORMING': 'Brainstorming needs to be closed',
    'ERROR_STATEMENTS': 'Lorem',
    'ERROR_RATING': 'No rating questions have been set',
    'IMPORT_FROM': 'Import from file',
    'SORTING': {
      'TITLE': 'Sorting',
      'FOR': 'For',
      'BODY': 'Enter answers from your participants from Sorting activities.',
      'ENTER': 'Enter',
      'RESULTS': 'Sorting Results',
      'RESOURCES': 'SORTING RESOURCES:',
      'SORT_CARD': 'Sort Cards',
      'RECORDING': 'Sort Recording Sheets',
      'SORT_RECORDING': 'Sort Recording Sheets',
      'NO_STATEMENTS': 'No statements set',
      'ERROR_PILE_NAME': 'Pile name is required',
      'UPLOAD_DATA': {
        'SWITCH_PARTICIPANT': 'Switch participant',
        'SWITCH_TOOLTIP': 'Switch to filter any of the available participants. This will be affected by the Show filter on the previous page. ',
        'STATUS': 'S:',
        'PILE': 'Pile',
        'PLACEHOLDER': 'Unnamed pile',
        'STATEMENT_NUMBERS': 'Statement Numbers',
        'ADD_NEW_PILE': 'Add New Pile',
        'SAVE': 'Save Sorting',
        'IMPORT': 'Import from file',
        'TAB_HELP': 'You can toggle between boxes by pressing the %0 key, it’ll save some time!',
        'OK': 'Ok',
        'DELETE_TOOLTIP': 'Delete pile',
        'SUCCESS': 'Data saved',
      },
      'IMPORT_MODAL': {
        'TITLE': 'Upload offline data for Sorting',
        'DESCRIPTION': 'Import offline data from a csv file',
        'NOTE': 'Note: ',
        'WARNING': 'This will override all data entered so far.',
        'DRAG': {
          'TITLE': 'Drag a csv file here to upload <small>or</small>',
          'BROWSE': 'Browse file (.csv)',
          'BROWSE_IMAGE': 'Browse file (.jpg or .png)',
          'DIFFERENT': 'Upload a different file (.csv)',
          'DIFFERENT_IMAGE': 'Upload a different file (.jpg or .png)',
          'ERROR': {
            'TYPE': 'Statements can only be uploaded in CSV format.',
            'LIMIT': 'Only one file can be uploaded, try again.',
          }
        },
        'BUTTON': {
          'CANCEL': 'Cancel',
          'UPLOAD': 'Upload'
        }
      },
      'DELETE_MODAL': {
        'TITLE': 'Delete Pile',
        'DESCRIPTION': 'Are you sure you want to delete pile %0',
        'BUTTON': {
          'CANCEL': 'No, don\'t delete',
          'OK': 'Yes, delete'
        }
      },
      'SWITCH_PARTICIPANTS_MODAL': {
        'TITLE': 'Switch participant',
        'PARTICIPANTS': {
          'TABLE_TABS': {
            'FIRST_NAME': 'First Name',
            'LAST_NAME': 'Last Name',
            'EMAIL': 'Email',
            'USERNAME': 'Username',
            'ST': 'St'
          }
        }
      },
      'EXPORT_MODAL': {
        'TITLE': 'Download Sort Cards',
        'TITLE_RECORDING': 'Download Sort Recording Sheets',
        'SUBTITLE': 'Select how you want your cards printed',
        'CONTENT': {
          'TITLE': 'Layout',
          'CARDS_PER_PAGE': 'cards per page',
          'ONLY_ONE_STATEMENT_PER_SHEET': 'Repeat statement on each page',
          'HIDE_TRIM_MARKS': 'Hide trim marks',
          'ADVANCED_CUSTOMIZATION': 'Advanced Customization',
          'FONT_STYLE': 'Font style',
          'TEXT_POSITION': 'Text Position',
          'RESET': 'reset',
          'TOOLTIP': 'Depending on the number of statements in your set, the PDF  may take 45 seconds or more to compile.' +
          '  You can continue to navigate through your project. When the PDF is finished, it will open in another browser screen/tab.' +
          '  Please do not hit the button multiple times.',
          'TOOLTIP_LONGER_COMPILATION': 'Selecting this option may lead to longer compilation time depending on the number' +
          ' of statements per page and the total number of statements. Please only click the button once. ' +
          'The report will compile in the background. You can navigate to other sections of the project while the cards ' +
          'are being compiled and the PDF will open in another browser screen when compiled.',
          'TOOLTIP_LAYOUT': 'Below, select the 1. the rating scale, 2. the layout type and 3. the checkbox to show labels inputted during' +
          ' the ratings setup. Bubble layout is optimized for likert scales 1-6 and higher showing only min and max labels.' +
          ' Checkmark layout is optimized for likert scales 1-5 and lower where there are labels for each scale option.',
        },
        'WARNING_TEXT': 'For best results, choose <b>Print Scaling: None</b> and deactivate the checkbox <b> Auto-Rotate and Center </b> if these options exist in your print dialog.'
      },
      'CAN_DEACTIVATE': {
        'TITLE': ' Leave offline Sorting',
        'BODY': 'Are you sure you want to leave Sorting without saving?',
        'NO': 'No, don\'t save',
        'YES': 'Yes, save and leave'
      }
    },
    'PARTICIPANT_QUESTION': {
      'TITLE': 'Participant Question',
      'FOR': 'For',
      'BODY': 'Enter answers from Participant Questions ran offline.',
      'ENTER': 'Enter',
      'NO_ENTER': 'There are no participant questions set',
      'RESULTS': 'Participant Questions Results',
      'RESOURCES': 'PART. QUESTIONS RESOURCES:',
      'RECORDING': 'Part. Questions Sheets',
      'NO_RECORDING': 'No questions set',
      'UPLOAD_DATA': {
        'SWITCH_PARTICIPANT': 'Switch participant',
        'STATUS': 'PQ:',
        'SAVE': 'Save Participant Questions',
        'IMPORT': 'Import from file',
        'TAB_HELP': 'You can toggle between boxes by pressing the %0 key, it’ll save some time!',
        'OK': 'Ok',
        'SUCCESS': 'Data saved',
        'QUESTIONS': 'QUESTIONS',
        'ANSWERS': 'ANSWERS',
        'OTHER': 'Other: ',
        'OTHER_HELP': 'Type only if “other” option was included in previous answer',
        'SELECT_PLACEHOLDER': 'Select answer',
        'SELECT_SELECTED': 'Selected',
      },
      'IMPORT_MODAL': {
        'TITLE': 'Upload offline data for Participant Questions',
        'DESCRIPTION': 'Import offline data from a csv file',
        'NOTE': 'Note: ',
        'WARNING': 'This will override all data entered so far.',
        'DRAG': {
          'TITLE': 'Drag a csv file here to upload <small>or</small>',
          'BROWSE': 'Browse file (.csv)',
          'DIFFERENT': 'Upload a different file (.csv)',
          'ERROR': {
            'TYPE': 'Participant Questions can only be uploaded in CSV format.',
            'LIMIT': 'Only one file can be uploaded, try again.',
          }
        },
        'BUTTON': {
          'CANCEL': 'Cancel',
          'UPLOAD': 'Upload'
        }
      },
      'DOWNLOAD_DATA': {
        'EXPORT': 'Export to file'
      },
      'SWITCH_PARTICIPANTS_MODAL': {
        'TITLE': 'Switch participant',
        'PARTICIPANTS': {
          'TABLE_TABS': {
            'FIRST_NAME': 'First Name',
            'LAST_NAME': 'Last Name',
            'EMAIL': 'Email',
            'USERNAME': 'Username',
            'PQ': 'Pq'
          }
        }
      },
      'EXPORT_MODAL': {
        'TITLE': 'Download Questions As…',
        'SUBTITLE': 'Select your download options'
      },
      'CAN_DEACTIVATE': {
        'TITLE': ' Leave offline Participant Questions',
        'BODY': 'Are you sure you want to leave Participant Questions without saving?',
        'NO': 'No, don\'t save',
        'YES': 'Yes, save and leave'
      },
      'ERRORS': {
        'MULTIPLE': 'The answer is not a valid participant question answer option.',
        'SINGLE_SCALE': 'The answer must be between min and max values.',
        'DECIMALS': 'You have exceeded the number of decimals allowed'
      }
    },
    'RATING': {
      'TITLE': 'Rating',
      'FOR': 'For',
      'BODY': 'Enter all different Rating questions results from offline activities.',
      'ENTER': 'Enter',
      'RESULTS': 'Rating Results',
      'RESOURCES': 'RATING RESOURCES:',
      'RECORDING': 'Rating Sheets',
      'NO_RATING_QUESTIONS': 'No ratings set',
      'TABLE': {
        'HEAD': 'RATING'
      },
      'UPLOAD_DATA': {
        'SWITCH_PARTICIPANT': 'Switch participant',
        'STATUS': 'RT',
        'SAVE': 'Save Rating',
        'IMPORT': 'Import from file',
        'TAB_HELP': 'You can toggle between boxes by pressing the %0 key, it’ll save some time!',
        'OK': 'Ok',
        'SUCCESS': 'Data saved'
      },
      'SWITCH_PARTICIPANTS_MODAL': {
        'TITLE': 'Switch participant',
        'PARTICIPANTS': {
          'TABLE_TABS': {
            'FIRST_NAME': 'First Name',
            'LAST_NAME': 'Last Name',
            'EMAIL': 'Email',
            'USERNAME': 'Username',
            'RT': 'Rt'
          }
        }
      },
      'IMPORT_MODAL': {
        'TITLE': 'Upload offline data for Rating',
        'DESCRIPTION': 'Import offline data from a csv file',
        'NOTE': 'Note: ',
        'WARNING': 'This will override all data entered so far.',
        'DRAG': {
          'TITLE': 'Drag a csv file here to upload <small>or</small>',
          'BROWSE': 'Browse file (.csv)',
          'DIFFERENT': 'Upload a different file (.csv)',
          'ERROR': {
            'TYPE': 'Statements can only be uploaded in CSV format.',
            'LIMIT': 'Only one file can be uploaded, try again.',
          }
        },
        'BUTTON': {
          'CANCEL': 'Cancel',
          'UPLOAD': 'Upload'
        }
      },
      'ACTIONS': {
        'ALL': 'All Rating Questions'
      },
      'EXPORT_MODAL': {
        'TITLE': 'Download Rating Sheets',
        'SUBTITLE': 'Select how you want your rating sheets printed',
        'CONTENT': {
          'TITLE': 'Rating',
          'BUBBLE_LAYOUT': 'Bubble layout',
          'CHECKMARK_LAYOUT': 'Checkmark layout',
          'LABELS': 'Show labels'
        }
      },
      'CAN_DEACTIVATE': {
        'TITLE': ' Leave offline Rating',
        'BODY': 'Are you sure you want to leave Rating without saving?',
        'NO': 'No, don\'t save',
        'YES': 'Yes, save and leave'
      }
    },
    'PARTICIPANTS': {
      'TITLE': 'Data entry for',
      'SHOWING': 'Showing',
      'LOADING': 'Loading',
      'NO_RESULTS': 'No results found',
      'PARTICIPANTS': 'participants',
      'SEARCH_PLACEHOLDER': 'Search Participants',
      'SORTING': {
        'TITLE': 'Sorting',
        'TOOLTIP': 'Add sorting data'
      },
      'RATING': {
        'TITLE': 'Rating',
        'TOOLTIP': 'Add rating data for',
        'DROPDOWN': 'Add rating data for:'
      },
      'PARTICIPANT_QUESTIONS': {
        'TITLE': 'Participant Questions',
        'TOOLTIP': 'Add participant questions data'
      },
      'SHOW_BY_DROPDOWN': {
        'LABEL': 'Show',
        'ITEMS': {
          'ALL': 'All',
          'ASSIGNED': 'Assigned to Brainstorming',
          'NOT_ASSIGNED': 'Not assigned for Brainstorming',
          'COMPLETED': 'Completed Brainstorming',
          'STARTED': 'Started Brainstorming',
        }
      },
      'ONLY_CONTRIBUTORS': {
        'LABEL': 'Show contributors only',
        'TOOLTIP': 'Lorem ipsum'
      },
      'NEW_PARTICIPANT': 'New Participant',
      'TABLE_TABS': {
        'IC': 'IC',
        'USERNAME': 'Username',
        'BS_STATUS': 'BS Status',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_ACCEPTANCE': 'Time of Acceptance',
        'TIME_DECLINE': 'Time of Declination',
        'LAST_ACTIVITY': 'Last Active',
        'LAST_BRAINSTORMING': 'Last Brainstorming'
      },
      'TABLE_SETTINGS': {
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
        'TIME_OF_DECLINE': 'Time of Declination',
        'LAST_ACTIVE': 'Last Active',
        'LAST_BRAINSTORMING': 'Last Brainstorming'
      },
      'ASSIGNATION': {
        'PARTICIPANTS': 'Participants',
        'SELECTED': 'Selected',
        'ASSIGN_FOR': 'Assign for:',
        'BRAINSTORMING': 'Brainstorming',
        'ASSIGN': 'Assign',
        'ASSIGN_SENT': 'Assign & Send',
        'UNASSIGN': 'Unassign',
        'APPLY': 'Apply'
      },
      'ASSIGN_MODAL': {
        'TITLE': 'Send Invites for Brainstorming',
        'PREVIEW': {
          'DO_YOU_HAVE_QUESTIONS': 'Do you have any questions or feedback for our project? Contact us:',
          'UNSUSCRIBE': 'Unsubscribe',
          'PRIVACY': 'Privacy'
        },
        'MESSAGE': {
          'TITLE': 'You have been invited to Brainstorming.',
          'P1': 'We really appreciate your collaboration in our project!',
          'P2': 'In this opportunity, we would like you to participate in our Brainstorming activity, it is really easy and it will only take you a while. You don&rsquo;t\
          even have to do it all at once, you can add ideas and come back later whenever you like. <br>',
          'P3': 'Thank you again for your help and see you around'
        }
      }
    },
    'PROJECT': {
      'EXPORT_MODAL': {
        'TITLE': 'Download Project Instructions'
      }
    },
    'QUOTA_EXCEEDED': {
      'TITLE': 'Participant quota limit reached',
      'TEXT_1': 'You can\'t add any more offline data for participants because you\'ve reached your license limit.',
      'TEXT_2': 'Contact <a href="mailto:sales@conceptsystems.com">sales@conceptsystems.com</a> to purchase a quota increase or if applicable, deactivate unused participants.',
      'BUTTON': 'OK'
    }
  },

  // ===== RATING QUESTIONS ======
  // =============================
  'RATING_QUESTIONS': {
    'NEW_QUESTION': 'NEW QUESTION',
    'OPEN_QUESTION': 'OPEN QUESTION',
    'CLOSE_QUESTION': 'CLOSE QUESTION',
    'EXAMPLES': {
      'TITLE': 'Eksempel på titel',
      'DESCRIPTION': 'Description Example',
      'PAGE_DESCRIPTION': 'Page Description Example',
      'INSTRUCTION': 'Forklaring på spørgsmålet'
    },
    'CARD': {
      'ACTIONS': {
        'DRAG': 'Drag',
        'DUPLICATE': 'Duplicate',
        'DELETE': 'Delete'
      },
      'TYPE': {
        'RADIO': 'Radio buttons',
        'NUMERIC': 'Numeric',
        'MIN': 'Min',
        'MAX': 'Max',
        'INVALID_NUMBER': 'Maximum value should be greater than minimum',
        'TOOLTIP': 'Radio button data entry will automatically switch to numeric for scales larger than 5 on some devices (mobile). ' +
        'In Radio button entry, scales 5 and below will allow descriptors; scales 6 and above will provide descriptor for the highest and lowest scale anchors only. ' +
        'Scales larger than 1-10 for desktops will automatically switch to dropdown/numeric data entry.',
        'DESCRIPTION-TOOLTIP': 'If you have additional information to clarify the question, add it in this section. This is a good space to discuss the labels for the likert scale anchors.',
        'PAGE-DESCRIPTION-TOOLTIP': 'Enable this if you would like to display additional information at the top of the page while the participant is answering.',
        'SETTINGS-TOOLTIP': 'The default setting is on. If you turn this off, you can change the identification type, layout, and open/close options for each rating question.',
        'RANDOM-TOOLTIP': 'Selecting Always randomize will randomize the statements for each participant. Selecting Never randomize will keep the statements in the order' +
        ' of the brainstorming list for all participants. ' +
        'Selecting Permanently randomize statements will show all participants the same randomized order for all activities. This will also permanently randomize the brainstorming statements list. ',
        'THANK-YOU-TOOLTIP': 'This message will appear each time a rating is completed.  If your participants are invited to more than one rating,' +
        ' consider using the redirect link in the Project Settings' +
        ' - Thank You Message.' +
        ' Participants see that message when all activities assigned to them have been completed. ' +
        'If you enter a link into the redirection url, participants will be offered a link to that page upon completion of each rating. ' +
        'The participant will need to click the NEXT button to proceed to the destination url. This message can be toggled on (blue) and off (grey).',
        'HIDE-TOOLTIP': 'Activate this switch to hide the focus prompt from participants by default. Participants can still view the prompt by clicking the megaphone in the top left of the screen.'
      },
      'OPTIONS': {
        'OPTION': 'Option',
        'ADD_DESCRIPTION': 'Add description',
        'ADD_PAGE_DESCRIPTION': 'Add page description',
        'TO': 'to',
        'INVERT': {
          'TEXT': 'Invert rating scale',
          'TOOLTIP': 'Lorem ipsum dolor.'
        },
        'DECIMAL': {
          'TEXT': 'Decimals allowed',
          'TOOLTIP': 'Lorem ipsum dolor.'
        }
      },
      'PLACEHOLDER': {
        'DESCRIPTION': 'Description',
        'EXPLANATION': 'Question\'s explanation',
        'SCALE': 'Type skalaens navn'
      },
      'VALUE': {
        'EXPLANATION_DEFAULT': 'Question\'s explanation',
      }
    },
    'DELETE_CARD_MODAL': {
      'TITLE': 'Delete Rating',
      'TEXT': 'Are you sure you want to delete this rating?',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'CONTINUE': 'Continue'
      }
    },
    'ERROR_MODAL': {
      'TITLE': 'Rating Limit',
      'TEXT': 'You have reached your limit for Ratings. No new question can be created.',
      'BUTTON': 'Accept'
    }
  },

  // ========= SETTINGS ==========
  // =============================
  'SETTINGS': {
    'THIS-PAGE-CONTAINS-MULTI-LANGUAGE-CONTENT': 'This page contains multi-language content',
    'SHOW': 'Show:',
    'ENGLISH': 'English',
    'SPANISH': 'Spanish',
    'FRENCH': 'French',
    'CANADIAN FRENCH': 'Canadian French',
    'GERMAN': 'German',
    'DANISH': 'Danish',
    'DUTCH': 'Dutch',
    'INTRO-MESSAGE': {
      'TEXT': 'Intro Message',
      'TOOLTIP': 'These messages will show at the beginning of the activity as a tutorial.'
    },
    'INTRO-TO-ACTIVITY': 'intro to activity',
    'ACTIVITY_EXPLANATION': 'Activity Explanation',
    'PAGE_DESCRIPTION': 'Page Description',
    'ENG': 'Eng',
    'GER': 'Ger',
    'TEXTAREA-PLACEHOLDER': 'In this activity, you will categorize the statements, according to your view of their meaning \
    or theme.',
    'EDITED': 'Edited',
    'BACK-TO-DEFAULT': 'Back to default',
    'CHARACTERS-LEFT': 'characters left',
    'PROJECT-SPECIFIC-EXPLANATION': 'Project-specific explanation',
    'TEXTAREA-PLACEHOLDER-2': 'To do this, you will sort each statement into piles in a way that makes sense to you. \
    Group the statements for how similar in meaning or theme they are to one another.',
    'THANK-YOU-MESSAGE': 'Thank You Message',
    'TEXTAREA-PLACEHOLDER-3': 'For participating in the Sorting phase of The Future Foundation: Achieving National Wellness \
    project. We appreciate your time and effort. As a sign of our appretiation we want to offer you a gift, continue to \
    collect our reward, or return to project page to participate in the ratings activities',
    'DEFAULT': 'Default',
    'TEXTAREA-PLACEHOLDER-4': 'First, read through all the statements in the unsorted cards list below.',
    'TEXTAREA-PLACEHOLDER-5': 'Next, sort each statement into a pile as you create your own version of how these ideas are \
    related. Give each pile a name that describes its theme or contents.',
    'TEXTAREA-PLACEHOLDER-6': 'Switch to Piles view to create, edit and organize them. People vary in how many piles they \
    create. Usually 5 to 20 piles works well to organize this number of statements.',
    'TEXTAREA-PLACEHOLDER-7': 'You don’t have to do all at once, all you do will be auto-saved so you can leave at any time \
    and return to sort more statements later.',
    'TEXTAREA-PLACEHOLDER-8': 'Don’t create piles according to priority, or value, such as “Important”, or “Hard To Do”. \
    Also, avoid piles such as “Miscellaneous” or “Other” that group together dissimilar statements. Put a statement alone in \
    its own category if it is unrelated to all the other statements.',
    'TABLETOP': 'TABLETOP',
    'DROPDOWN': 'DROPDOWN',
    'DESKTOP-TABLET': 'desktop & tablet',
    'MOBILE': 'mobile',
    'INSTRUCTIONS': 'Instructions',
    'IDENTIFICATION': 'IDENTIFICATION',
    'STATEMENTS-REVIEW-SORTING': 'Statements review and sorting',
    'STATEMENTS-LIST-REVIEW': 'Statements list review',
    'SORTING-STATEMENTS': 'Sorting statements',
    'MANAGING-PILES': 'Managing piles',
    'AUTO-SAVING-AND-COMING-BACK': 'Auto-saving and coming back',
    'HOW-TO-NAME-PILES': 'NAMING PILES IS IMPORTANT! (Additional information)',
    'STATEMENT-RANDOMIZATION': 'STATEMENT RANDOMIZATION',
    'STATEMENT-RANDOMIZATION-TOOLTIP': '1. Selecting Always randomize will randomize the statements for each participant. ' +
    '2. Selecting Never randomize will keep the statements in the order of the brainstorming list for all participants.' +
    ' 3. Selecting Permanently randomize statements will show all participants the same randomized order for all activities.' +
    ' This will also permanently randomize the brainstorming statements list.',
    'INTRO-TOOLTIP': 'This is the initial welcome text that will greet your participants',
    'THANK-YOU-TOOLTIP': 'If you enter a link into the redirection url, participants will be offered a link to that page upon completion of sorting.' +
    ' The participant will need to click the NEXT button to proceed to the destination url. This message can be toggled on (blue) and off (grey). ',
    'TABLE-TOP-TOOLTIP': 'Depending on a participant’s device, they will see different instructions. Desktops and Tablets will see the tabletop sorting instructions,' +
    ' while mobile devices  or phones will see the Dropdown instructions.' +
    ' Toggle the button to edit the text for each section.',
    'INSTRUCTIONS-TOOLTIP': 'This is the tutorial for participants on how to sort.  Please note that there is different text for Tabletop (desktop/tablet) and Dropdown (mobile/phone).' +
    '  Please toggle the button above to edit the text for each view. ',
    'BRAINSTORMING_INSTRUCTIONS_TOOLTIP': 'These messages will show at the beginning of the activity as a tutorial',
    'CLOSE-DATE': 'CLOSE DATE',
    'OPEN-DATE': 'OPEN DATE',
    'ALWAYS-RANDOMIZE': 'Always randomize',
    'NEVER-RANDOMIZE': 'Never randomize',
    'ONCE-ONLY': 'Once only',
    'LEAVE-BLANK-IF-YOU-DONT': 'Leave blank if you don’t want to specify',
    'ASSIGNED-PARTICIPATION-ONLY': 'Assigned participation only',
    'ASSIGNED-ANONYMOUS-USERNAME': 'Assign anonymous username',
    'BLOCK-NEW-REGISTRATIONS': 'Block new registrations',
    'IDENTIFIER-NAME': 'Identifier Name',
    'ADD_REDIRECTION_URL': 'ADD REDIRECTION URL',
    'URL': 'URL',
    'REMOVE_URL': 'Remove redirection url',
    'URL_PLACEHOLDER': 'Paste url here',
    'REMOVE_REDIRECTION': 'Remove redirection url',
    'URL_ERROR': 'Invalid url',
    'IDENTIFICATION-TOOLTIP': 'Select how you would like your participants to log in to complete activities. ' +
    '1 .Email or Identifier: Participants can log in using their email address or a username of their choice. ' +
    '2. Email address: Participants must create their username with their email address. 3. Identifier: Participants ' +
    'enter the username of their choice. 4. Anonymous: Participants use a randomly generated account that cannot be ' +
    'linked to their identity.',
    'BLOCK-NEW-REGISTRATIONS-TOOLTIP': 'Only existing participants assigned to this activity can participate. \
     New participants will not be assigned to the activity from this link.',
    'ASSIGNED-ANONYMOUS-USERNAME-TOOLTIP': 'When enabled, this will allow your participants to return to activities under the same anonymous username.',
    'STATEMENTS_INPUT': 'STATEMENTS INPUT',
    'COLLECTED_STATEMENTS': 'Collected statements and multiple ideas',
    'ADDING_IDEAS': 'Adding Ideas',
    'TOOLTIPS-IDENTIFIER': 'Enter text in this field which will instruct the participant on what to enter.  For example, Student ID Number or Program Participant ID.  Leave blank for default text.'
  },

  // ======= PARTICIPANTS ========
  // =============================
  'PARTICIPANTS': {
    'TITLE': 'Participants',
    'TITLE_RECYCLED': 'Recycled Participants',
    'QUOTA': 'Available',
    'QUOTA_MESSAGE': 'This is the maximum number of participants whose data can be included in Sorting & Rating analysis in this project.  To add participants, contact CSI 607-272-1206 (toll-free).',
    'ADD': 'Add Participants',
    'NO_PARTICIPANTS_EMAIL': 'You have some participants selected that have no email associated to their account.',
    'PARTICIPANTS': 'participants',
    'RECYCLED_PARTICIPANTS': 'recycled participants',
    'SEND_EMAIL_TOOLTIP': 'Send Email to selected participants',
    'RECYCLE_PARTICIPANT_TOOLTIP': 'Recycle selected participants',
    'RESTORE_PARTICIPANT_TOOLTIP': 'Restore selected participants',
    'DELETE_PARTICIPANT_TOOLTIP': 'Delete selected participants',
    'BULK_RECYCLE': 'Recycle',
    'BULK_RESTORE': 'Restore',
    'BULK_DELETE': 'Delete',
    'NO_PARTICIPANTS_SELECTED': 'There aren\'t participants with emails on the current page',
    'RESET_PASSWORD_UNAVAILABLE': 'Unable to reset password since participant belongs to multiple projects',
    'SEND_EMAIL_FAIL': 'Email could not be sent to some or one participant/s. Please review the emails selected.',
    'EMAIL_MODAL': {
      'TITLE': 'Send Participants Email',
      'TO': 'To',
      'PARTICIPANTS': 'participants',
      'EDIT': 'EDIT',
      'PREVIEW': 'PREVIEW',
      'CONTACT_INFORMATION': 'Show contact information',
      'DO_YOU_HAVE_QUESTIONS': 'Do you have any questions or feedback for our project? Contact us:',
      'UNSUSCRIBE': 'Unsubscribe',
      'PRIVACY': 'Privacy',
      'COPY': 'Send me a copy',
      'SEND': 'SEND'
    },
    'PARTICIPANT_OPTIONS': {
      'REVIEW_DATA': 'Review participant\'s data',
      'ADD_OFFLINE_DATA': 'Add offline data for participant',
      'RESET_PASSWORD': 'Reset password',
      'DEACTIVATE_PARTICIPANT': 'Deactivate participant',
      'REACTIVATE_PARTICIPANT': 'Reactivate participant',
      'RECYCLE_PARTICIPANT' : 'Recycle Participant',
      'RESTORE_PARTICIPANT' : 'Restore Participant',
      'DELETE_PARTICIPANT': 'Delete participant',
      'VIEW_INFORMED_CONSENT': 'View Consent to Participate',
    },
    'ACTIONS': {
      'DROPDOWN': 'Export <strong>Participants</strong> list',
      'RECYCLED': 'View <strong>Recycled Participants</strong>',
      'NOT_RECYCLED': 'Return to <strong>Participant View</strong>'
    },
    'ADD_MODAL': {
      'TITLE': 'Add Participants',
      'TABS': {
        'WITH_EMAIL': 'With email',
        'WITH_CUSTOM_USERNAME': 'With custom username'
      },
      'GENERAL': {
        'UPLOAD_PARTICIPANTS': 'Add participants\' emails to invite them to your project or',
        'UPLOAD_PARTICIPANTS_USERNAME': 'Add custom usernames for participants or',
        'UPLOAD_PARTICIPANTS_BUTTON': 'upload list from file (.csv)',
        'UPLOAD_SUCCESS': '<img src="assets/images/ico-tick-green.svg"> Upload successful: <strong>%0 new participants</strong> imported correctly',
        'UPLOAD_ERROR_MESSAGE': '...Unfortunately, %0 couldn’t be imported',
        'UPLOAD_ERROR_BUTTON': 'show errors',
        'UPLOADING_LIST': 'Uploading list...',
        'BUTTONS': {
          'DOWNLOAD': 'Download this list',
          'CANCEL': 'Cancel',
          'ADD': 'Add %0 participants'
        },
        'EMAIL_FIELD': 'Email',
        'EMAIL_FIELD_PLACEHOLDER': 'example@conceptsystems.com',
        'PASSWORD_FIELD': 'Password',
        'PASSWORD_FIELD_ERROR': 'Your password needs a minimum of 6 characters',
        'PASSWORD_FIELD_PLACEHOLDER': 'Enter password',
        'REMOVE_LINE': 'Remove line',
        'NEW_EMAIL': '+ New email'
      },
      'OPTIONS': {
        'TITLE': 'Options',
        'PASSWORD': {
          'ASSIGN': 'Assign passwords',
          'ASSIGN_TOOLTIP': 'If on, you will need to create a password for your participants and provide it to them. ' +
          'If off, your participants will set their own password.',
          'CREATE_MANUALLY': 'Create manually',
          'AUTO_GENERATE': 'Auto generate',
          'FORCE_PASSWORD': 'Force password change upon first login'
        },
        'ASSIGN': {
          'TITLE': 'Assign activities',
          'TOOLTIP': 'If on, you may assign the participants to all the activities they will be participating in. ' +
          'If off, you can also assign participants to activities in the other participant pages later.   '
        }
      },
      'INPUT_TAKEN': 'This participant already exists',
      'INPUT_TAKEN_USERNAME': 'Error adding this participant',
      'WRONG_EMAIL': 'Wrong email address',
      'TAKEN_MESSAGE': 'We found %0 participant that already exists. Please review.',
      'TAKEN_MESSAGE_USERNAME': 'There was an error adding participants. One or more usernames have already been taken or include an email address. Please review.',
      'BY_USERNAME': {
        'TOOLTIP': 'Select whether to enter participant usernames one by one or generate multiple random generated usernames automatically.',
        'TYPES': {
          'MANUALLY': 'Enter Manually',
          'GENERATE': 'Auto Generate-Bulk'
        },
        'USERNAME_FIELD': {
          'LABEL': 'Username',
          'EXAMPLE': 'Ex: TFF-1, TFF-2, TFF-3, ...',
          'PLACEHOLDER': 'Custom username',
          'ERROR_SPACES': 'Username cannot contain a space'
        },
        'PREFIX_FIELD': {
          'LABEL': 'Prefix',
          'GENERATE': 'auto generate prefix',
          'EXAMPLE': 'Ex: TFF, TFFP',
          'PLACEHOLDER': 'Type prefix'
        },
        'QUANTITY_FIELD': {
          'LABEL': 'Quantity',
          'PLACEHOLDER': '20'
        },
        'NEW': '+ New username',
        'BUTTONS_GENERATE': {
          'GENERATE': 'Generate usernames',
          'CLEAR': 'Clear all'
        },
        'GENERATING': 'Generating usernames...',
        'BACK': 'Back to creating usernames'
      }
    },
    'ADD_ERROR_MODAL': {
      'TITLE': '%0 Errors Found',
      'TEXT': 'The following are not correctly formatted as emails.'
    },
    'ADD_SUCCESS_MODAL': {
      'TITLE': 'Participants added successfully!',
      'DOWNLOAD': 'Download list of participants & passwords',
      'BUTTON': 'Continue',
      'SMALL': 'You will no longer be able to view these passwords'
    },
    'ADD_DISCARD_MODAL': {
      'TITLE': 'Discard Changes?',
      'TEXT': 'Are you sure you want to exit this screen? All added participants will be discarded.',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'DISCARD': 'Yes, discard'
      }
    },
    'ADD_LEAVE_MODAL': {
      'TITLE': 'Leave Add Participants?',
      'TEXT': 'Are you sure you want leave? Participants will not be added.',
      'BUTTONS': {
        'CANCEL': 'No, don\'t leave',
        'LEAVE': 'Yes, leave'
      }
    },
    'LIST': {
      'HEADER': {
        'IC': 'IC',
        'USERNAME': 'USERNAME',
        'BS': 'BS',
        'PQ': 'PQ',
        'ST': 'ST',
        'RT': 'RT',
        'FIRST_NAME': 'FIRST NAME',
        'LAST_NAME': 'LAST NAME',
        'TIME_OF_ACCEPTANCE': 'TIME OF ACCEPTANCE',
        'TIME_OF_DECLINE': 'Time of Declination',
        'LAST_ACTIVE': 'LAST ACTIVE'
      },
      'TOOLTIP': {
        'IC': 'Consent to Participate',
        'BS': 'Brainstorming',
        'PQ': 'Participant Questions',
        'ST': 'Sorting',
        'LAST_ACTIVE': 'Last Active'
      }
    },
    'SEARCH_PLACEHOLDER': 'Search Participants',
    'TABLE_SETTINGS': {
      'TITLE': 'Displayed columns:',
      'ACTIVITIES': {
        'TITLE': 'activities',
        'ITEMS': {
          'PQ': 'Participant Questions',
          'BS': 'Brainstorming',
          'ST': 'Sorting',
          'RT': 'Rt'
        }
      },
      'LOGS': {
        'TITLE': 'logs',
        'ITEMS': {
          'FIRST_NAME': 'First Name',
          'LAST_NAME': 'Last Name',
          'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
          'TIME_OF_DECLINE': 'Time of Declination',
          'LAST_ACTIVE': 'Last Active'
        }
      }
    },
    'RESET_PARTICIPANT_PASSWORD_MODAL': {
      'TITLE': 'Change Password',
      'PARTICIPANT': 'Participant',
      'PASSWORD_FIELD': {
        'LABEL': 'New Password',
        'PLACEHOLDER': 'Enter new password',
        'LENGTH': 'Your password needs a minimum of 6 characters',
        'REQUIRED': 'You must enter a password',
      },
      'GENERATE': 'Generate automatically',
      'FORCE_RESET': 'Force password change on next login',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'CHANGE': 'Change password'
      }
    },
    'RESET_PARTICIPANT_PASSWORD_MODAL_SUCCESS': {
      'TITLE': 'Password changed successfully!',
      'BUTTON': 'Continue'
    },
    'DELETE_CONFIRMATION_MODAL': {
      'TITLE': 'Delete Participant(s)',
      'MESSAGE': 'Are you sure you want to remove the selected participant(s) from this project? All their data will be deleted as well. This action cannot be undone',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'DELETE': 'Yes, delete'
      }
    },
    'DEACTIVATE_CONFIRMATION_MODAL': {
      'TITLE': 'Deactivate Participant',
      'MESSAGE': 'Are you sure you want deactivate the participant selected from the list?',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'DEACTIVATE': 'Deactivate'
      }
    },
    'RECYCLE_CONFIRMATION_MODAL': {
      'TITLE': 'Recycle Participant(s)',
      'MESSAGE': 'Are you sure you want to recycle the selected participant(s)? You can restore the participant(s) from the recycle bin page. Their data will not be lost.',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'RECYCLE': 'Recycle'
      }
    },
    'RESTORE_CONFIRMATION_MODAL': {
      'TITLE': 'Restore Participant(s)',
      'MESSAGE': 'Would you like to restore the selected participant(s)? The participant(s) will be returned to the active participants list.',
      'BUTTONS': {
        'CANCEL': 'Cancel',
        'RESTORE': 'Restore'
      }
    },
    'REACTIVATE_LIMIT_MODAL': {
      'TITLE': 'Reactivate participant limit',
      'TEXT_1': 'You cannot reactivate this participant as you have reached your limit for Sorting & Rating data.',
      'TEXT_2': 'Contact <a href="mailto:sales@conceptsystems.com">sales@conceptsystems.com</a> to purchase a quota increase.',
      'BUTTON': 'OK'
    },
    'DEACTIVATE_LIMIT_MODAL': {
      'TITLE': 'Deactivate limit reached',
      'TEXT_1': 'You cannot deactivate anymore participants as you have reached your limit.',
      'BUTTON': 'OK'
    },
    'CLEAR_ALL': 'Clear all',
    'NARROWED_BY': 'Narrowed by:',
    'QUICK_FILTER_LABEL': 'Quick Filter:',
    'QUICK_FILTERS_LABEL': 'quick filters',
    'SHOW_PARTICIPANTS_WHO': 'show participants who:',
    'ADVANCED_FILTERS_LABEL': 'advanced filters',
    'ADVANCE_ASSIGN_LABEL': 'Advance Assign',
    'SHOW_BY': {
      'ALL': 'All participants',
      'DEACTIVATED': 'Deactivated participants',
      'IDENTIFIER': 'Identifier participants',
      'EMAIL': 'Email username participants',
      'ANONYMOUS': 'Anonymous participants'
    },
    'QUICK_FILTERS': {
      'REJECTEDDATA': 'Have rejected data',
      'NOSORTINGWITHMAIL': 'Haven\'t started sorting and have email',
      'INVITEDNOTPARTICIPATED': 'Were invited but not participated',
      'DECLINEDINFORMEDCONSENT': 'Declined the Consent to Participate',
      'NOBRAINSTORMINGWITHMAIL': 'Haven\'t started brainstorming and have email',
      'STARTEDPARTICIPANTQUESTION': 'Started Participant Questions',
      'ASSIGNEDPARTICIPANTQUESTION': 'Are assigned to Participant Questions',
      'COMPLETEDPARTICIPANTQUESTION': 'Completed Participant Questions'
    },
    'ADVANCED_FILTERS': {
      'IS': 'is',
      'TITLE': 'Add one or more filters to narrow down your search',
      'LABEL': {
        'ACTIVITY': 'Activity',
        'STATUS': 'Status',
        'INFORMED_CONSENT': 'Consent to Participate',
        'TYPE_OF_PARTICIPANT': 'Type of Participation',
        'IC-TOOLTIP': 'If consent to participate was enabled in Project Settings, you can sort your participant list by those' +
        ' who Accepted or Declined. Pending denotes the invited participants who have not chosen to accept or decline yet. ',
        'TYPE-TOOLTIP': 'If different types of participant registration were chosen during the setup of participant activities,' +
        '  you can filter the participants view by one or more registration type. ',
      },
      'ADD_FILTER': 'add filter',
      'INFORMED_CONSENT': {
        'ACCEPTED': 'Accepted',
        'DECLINED': 'Declined',
        'PENDING': 'Pending'
      },
      'TYPE_OF_PARTICIPATION': {
        'EMAIL': 'Email',
        'IDENTIFIER': 'Identifier',
        'ANONYMOUS': 'Anonymous'
      },
      'ACTIVITIES': {
        'ALL': 'All Activities',
        'ANY': 'Any Activities'
      },
      'ACTIVITY_STATUS': {
        'COMPLETED': 'Completed',
        'STARTED': 'Started',
        'APPROVED': 'Approved',
        'REJECTED': 'Rejected',
        'ASSIGNED': 'Assigned',
        'NOT_ASSIGNED': 'Not Assigned',
        'SELECT_STATUS': 'Select Status'
      },
      'IC_LABEL': 'Consent to Participate:',
      'TP_LABEL': 'Type:'
    },
    'ADVANCED_ASSIGNMENT': {
      'PARTICIPANTS_SELECTED': 'Participants <br>Selected',
      'ASSIGN_FOR': 'Assign for:',
      'UNASSIGN_FOR': 'Unassign for:',
      'BUTTON': {
        'APPLY': 'Apply',
        'CANCEL': 'Cancel'
      },
      'DISCARD_SELECTION_MODAL': {
        'TITLE': 'Remove Selection',
        'TEXT_1': 'If you go back, your selection to assign or unassign activities will be removed.',
        'TEXT_2': 'Are you sure you want to continue?',
        'BUTTON': {
          'NO': 'No, cancel',
          'YES': 'Yes, apply'
        }
      },
      'APPLY_FILTER_MODAL': {
        'TITLE': 'Apply Filter?',
        'TEXT_1': 'If you filter, any activities you have been selected to be assigned or unassigned will be removed',
        'TEXT_2': 'Are you sure you want to apply this filter?',
        'BUTTON': {
          'NO': 'No, cancel',
          'YES': 'Yes, apply'
        }
      },
      'QUOTA_LIMIT_REACHED_MODAL': {
        'TITLE': 'Participant quota limit reached',
        'TEXT_1': 'For Sorting and Rating, you can assign more participants to these activities, however you\'ve already reached your licence limit.',
        'TEXT_2': 'Participants will not be able to view the activity and cannot participate.',
        'TEXT_3': 'Contact <span>sales@conceptsystems.com</span> to purchase a quota increase or if applicable, deactivate unused participants.',
        'BUTTON': {
          'NO': 'No, don\'t apply',
          'YES': 'Yes, continue'
        }
      }
    },
    'UNASSIGNING_PARTICIPANTS_MODAL': {
      'TITLE': 'Unassigning Participants',
      'TEXT': 'Are you sure you want to unassign these participants? All data associated with the activity will be removed from the project for these participants.',
      'BUTTON': {
        'CANCEL': 'Cancel',
        'OK': 'Yes, unassign'
      }
    }
  },

  // ======== REVIEW DATA ========
  // =============================
  'REVIEWDATA': {
    'TITLE': 'Review Data',
    'PARTICIPANTS': 'Participants',
    'PARTICIPANTS_PERCENTAGE': 'Of participants for review |',
    'DATA_REVIEWED': 'Data Approved',
    'DATA_REVIEWED_TOOLTIP': 'This is a basic overview of your checked data. It compares the number' +
    ' of approved activities compared to those complete enough to be reviewed.' +
    ' It then provides a percentage of checked data compared to all data collected.',
    'QUOTA': 'quota',
    'ADD': 'Add Participants',
    'REVIEWED_DATA': 'Data Reviewed',
    'RATINGS': 'Ratings',
    'NOT_AVAILABLE_SORTING': 'There must be at least %0 statements sorted to approve for analysis.',
    'NOT_AVAILABLE_RATING': 'There must be at least 1 statement rated to approve for analysis.',
    'UNSORTED': 'Unsorted statements',
    'UNRATED': 'Unrated',
    'ACTIONS': {
      'DROPDOWN': 'Export <strong>Participants</strong> list'
    },
    'ADD_MODAL': {
      'TITLE': 'Add Participants',
      'TABS': {
        'WITH_EMAIL': 'With email',
        'WITH_CUSTOM_USERNAME': 'With custom username'
      }
    },
    'LIST': {
      'HEADER': {
        'IC': 'IC',
        'USERNAME': 'Username',
        'BS': 'BS',
        'PQ': 'PQ',
        'ST': 'ST',
        'RT': 'RT',
        'LAST_ACTIVITY': 'Last Active'
      },
      'TOOLTIP': {
        'BS': 'Brainstorming',
        'PQ': 'Participant Questions',
        'ST': 'Sorting',
        'LAST_ACTIVE': 'Last Active'
      }
    },
    'SEARCH_PLACEHOLDER': 'Search Participants',
    'TABLE_SETTINGS': {
      'TITLE': 'Displayed columns:',
      'ACTIVITIES': {
        'TITLE': 'activities',
        'ITEMS': {
          'PQ': 'Participant Questions',
          'BS': 'Brainstorming',
          'ST': 'Sorting',
          'RT': 'Rt'
        }
      },
      'LOGS': {
        'TITLE': 'logs',
        'ITEMS': {
          'TIME_OF_ACCEPTANCE': 'Time of Acceptance',
          'TIME_OF_DECLINE': 'Time of Declination',
          'LAST_ACTIVE': 'Last Active'
        }
      }
    },
    'HEADER': {
      'USER' : 'Data review for:'
    },
    'SORTING': 'Sorting',
    'SEARCH_WORDS': 'SEARCH WORDS',
    'REJECT': 'REJECT',
    'APPROVE': 'APPROVE',
    'STATEMENTS_SORTED': 'STATEMENTS SORTED',
    'STATEMENTS_RATED': 'STATEMENTS RATED',
    'PILES_CREATED': 'PILES CREATED',
    'SHOW_BY_DROPDOWN': {
      'ITEMS': {
        'ALL': 'All',
        'STARTED': 'All started activities',
        'COMPLETED': 'All completed activities',
        'MANUALLY_UPLOADED': 'All manually uploaded activities',
        'APPROVED': 'All approved activities',
        'REJECTED': 'All rejected activities',
      }
    },
    'NOT_AVAILABLE': 'Data not available for review',
    'REMOVE_APPROVAL': 'Remove Approval',
    'REMOVE_REJECTION': 'Remove Rejection',
    'NO_NAME': 'Unnamed',
    'TIME_SPENT': 'TIME SPENT',
    'START_DATE': 'Start Date:',
    'LAST_DATE': 'Last Save:',
    'FINISH_DATE': 'Finish Date:',
    'ELAPSED_SS': 'Elapsed time (from start to last save)',
    'ELAPSED_SF': 'Elapsed time (from start to finish)'
  },

  // ========== SHARED ===========
  // =============================
  'SHARED': {
    'SET_FOR': 'SET FOR'
  },

  // ===== MESSAGE CENTER ========
  // =============================
  'MESSAGE_CENTER': {
    'TITLE': 'Project Messages',
    'TABS': {
      'NOTIFICATIONS': 'SENT NOTIFICATIONS',
      'EMAILS': 'SENT EMAILS'
    },
    'EMAILS': 'EMAILS',
    'EMAIL': 'Email',
    'NO_EMAILS': 'You have no emails',
    'NEW_MESSAGE': {
      'TITLE': 'New Message',
      'NOTIFICATION': {
        'NEW_NOTIFICATION': 'Send new notification',
        'NEW_MESSAGE': 'Send new email',
        'MESSAGE': 'Message',
        'PLACEHOLDER': 'Type your notification here ...',
        'NOTIFICATION_CHECKBOX': 'Push to email registered',
        'SEND_NOTIFICATION': 'SEND NOTIFICATION',
        'TOOLTIP': 'This will also email the notification to participants who have registered emails.',
        'SUCCESS': 'Notification was sent successfully',
        'LOADING': 'Loading ...'
      },
      'EMAIL': {
        'FROM': 'FROM',
        'RECIPIENTS': 'RECIPIENTS',
        'RECIPIENTS_TOOLTIP': 'The participant must be added to the project\'s Participants list before their email can be selected. ',
        'GROUPS_DROPDOWN': {
          'TITLE': 'GROUPS',
          'ALL_PROJECT_CONTACTS': 'All project contacts',
          'ONLY_ADMINS': 'Only Project Team',
          'INVITED': 'All invited participants',
          'PER_ACTIVITY': 'Participants per Activity',
          'PLACEHOLDER': 'Select groups',
          'TOOLTIP': 'You do not need to make a selection in both RECIPIENTS and GROUPS to send an email. It is required that you make a selection in one or the other to continue with your message.'
        },
        'ACTIVITIES': 'ACTIVITIES',
        'SUBJECT': 'SUBJECT',
        'MESSAGE': 'MESSAGE',
        'SEND_EMAIL': 'SEND EMAIL',
        'INCLUDE_LOGO': 'Include logo in the email',
        'INCLUDE_LINK': 'Include link to the project',
        'TOOLTIP': 'Check this box to add a link to the project activities page. You need to manually assign participants who receive this link to activities.',
        'PREVIEW': 'Email Preview',
        'PLACEHOLDER_SUBJECT': 'Type a subject heading...',
        'MAX_CHARACTERS': '(max. 80 characters)',
        'PLACEHOLDER_RECIPIENTS': 'Type username or email',
        'PLACEHOLDER_ACTIVITIES': 'Select activities',
        'STARTED': 'Started',
        'ASSIGNED': 'Assigned-Invited',
        'FINISHED': 'Completed',
        'PROJECT_LINK': 'ENTER THE PROJECT',
        'NO_REPLY': 'This email was sent from an unmonitored e-mail address. Please do not reply to this message.',
        'PCS': 'Powered by Concept Systems, Inc. 136 East State St. Ithaca, NY 14850',
        'SUCCESS': 'Email was sent successfully'
      }
    }
  },

  // ========= ANALYSIS ==========
  // =============================
  'ANALYSIS': {
    'LANDING': {
      'TITLE': 'Analysis',
      'NEW_SCENARIO': 'New Scenario',
      'CAN_CREATE': 'Looks like everything is ready to get started:',
      'CANNOT_CREATE': 'You can\'t create a scenario yet because:',
      'OPEN_ACTIVITIES_1': 'You still have open activities.',
      'OPEN_ACTIVITIES_2': 'Close all activities',
      'CLOSED_ACTIVITIES': 'You have closed all activities',
      'APPROVED_PARTICIPANTS': 'You have approved participants sorting data',
      'NOT_APPROVED_PARTICIPANTS_1': 'You have no approved participants sorting.',
      'NOT_APPROVED_PARTICIPANTS_2': 'Review data',
      'APPROVED_PARTICIPANTS_RATING': 'You have approved participants rating data',
      'NOT_APPROVED_PARTICIPANTS_RATING_1': 'You have no approved participants rating.',
      'NOT_APPROVED_PARTICIPANTS_RATING_2': 'Review data',
      'NO_SCENARIOS': 'You haven\'t created any scenarios yet',
      'LOADING_SCENARIOS': 'Loading',
      'OPEN_ACTIVITIES_WARNING_1': 'There are open activities. You would have to',
      'OPEN_ACTIVITIES_WARNING_2': 'close all activities',
      'OPEN_ACTIVITIES_WARNING_3': 'in order to work on analysis.',
      'OPTIONS': {
        'FAVORITE': 'Mark as favorite',
        'EDIT': 'Edit scenario',
        'DUPLICATE': 'Duplicate scenario',
        'DELETE': 'Delete scenario'
      },
      'ITEMS': {
        'PARTICIPANTS': 'Participants',
        'FILTERS': 'PQ Filters',
        'CUTOFF': 'Similarity Cutoff',
        'CREATED': 'Created',
        'UPDATED': 'Updated',
        'BY': 'by',
        'ITERATIONS': 'Iterations'
      },
      'DELETE_SCENARIO_MODAL': {
        'TITLE': 'Are you sure you want to delete this scenario?',
        'TEXT': 'Deleting a scenario will permanently delete all scenario configurations including concept maps, pattern matches, and go-zones. You cannot undo this action.',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'CONTINUE': 'Continue'
        }
      },
      'CLONE_SCENARIO_MODAL': {
        'TITLE': 'Clone Scenario',
        'TEXT': 'New Scenario Name:',
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'CONTINUE': 'Continue'
        }
      },
      'CLOSE_ACTIVITIES_MODAL': {
        'TITLE': 'Close Activities?',
        'TEXT': 'You still have some activities open for participants. In order to start your analysis, you need to close all of these.',
        'BUTTONS': {
          'CANCEL': 'No, don\'t close',
          'CONTINUE': 'Yes, close all'
        }
      },
      'FAVORITE_SCENARIO_MODAL': {
        'TITLE': 'Change favorite scenario?',
        'TEXT': 'Are you sure you want to change the favorite scenario? Other members of your project team will also see this change.',
        'BUTTONS': {
          'CANCEL': 'No, keep favorite ',
          'CONTINUE': 'Yes, change favorite'
        }
      },
      'STATEMENTS_WARNING_MODAL': {
        'TITLE': 'Potential for Analysis Error',
        'TEXT': ' Additional statements were added after participant data was approved. This may cause an analysis ' +
        'problem. Please return to Review Data and re-review your participant sort data which may no longer meet the ' +
        'required 75% completion threshold.',
        'CANCEL': 'CANCEL',
        'CONTINUE': 'CREATE ANYWAY'
      },
      'DELETE_RATING_MAP': {
        'TITLE': 'Delete %0',
        'TEXT': 'Are you sure you want to delete this map? Once deleted, you cannot undo this action.',
        'BUTTONS': {
          'CANCEL': 'No, don\'t',
          'OK': 'Yes, delete'
        }
      }
    },
    'SCENARIO': {
      'TITLE_NEW': 'New Scenario',
      'TITLE_EDIT': 'Edit Scenario',
      'DESCRIPTION': 'The scenario configurations below will affect the arrangement of points on the point map',
      'NAME': {
        'TOOLTIP': 'This Scenario name will appear on the main Analysis screen and it will be used in drop-down menus and exports. There is a 22 character limit for this title.',
        'TITLE': 'Name',
        'PLACEHOLDER': 'Type a name for your scenario'
      },
      'PARTICIPANTS': {
        'NAME' : {
          'TOOLTIP': 'Click Show participants below to see the sorting data included in this scenario.' +
          ' This will pull data from only participants with approved sorting data. '
        },
        'TITLE': 'Participants Included',
        'TITLE_TOOLTIP': 'Use this to add a condition to filter participants by their response to  participant question(s). You can include multiple filters by pressing ' +
        'Add AND condition and Add OR condition. AND CONDITIONS narrow the selected participants since  demographic information meets both the first and second conditions.' +
        ' OR CONDITIONS select participants that meet one of the selected conditions.',
        'APPROVED': 'participants with approved',
        'SHOW': 'Show participants',
        'HIDE': 'Hide participants',
        'SORTING': 'sorting',
        'RATING': 'rating'
      },
      'FILTER': {
        'TITLE': 'Filter Participants',
        'TITLE_TOOLTIP': 'A concept map can be drawn from any subset of sorting participants,' +
        ' but it is recommended to have 25-40 completed sorts in the subset.  For example, you may want to view a concept map' +
        ' that includes sorts from only a certain subgroup of the users.',
        'DESCRIPTION': 'By adding conditions based on your participant questions',
        'ADD': 'Add a condition',
        'SELECT_SORTS': 'Select sorts by participant questions',
        'ADD_AND': 'Add AND condition',
        'ADD_OR': 'Add OR condition'
      },
      'CUTOFF': {
        'TITLE': 'Similarity Cutoff',
        'TOOLTIP': 'The default is No Similarity Cutoff.  A similarity cutoff is used to refine the analysis results by identifying' +
        ' instances of “outlying” sorts, on the item level. Use of the similarity cutoff is rare, but it has great value when' +
        ' the analysis results with all data included are difficult to interpret. It is advisable to use a low similarity cutoff (1 or, rarely, 2)' +
        ' and then review the results to determine if the map has become clearer in cluster content coherence.',
      },
      'BUTTONS': {
        'RUN': 'RUN ANALYSIS',
        'CANCEL': 'CANCEL',
        'ACCEPT_RESULTS': 'ACCEPT RESULTS',
        'TRY_AGAIN': 'TRY AGAIN',
        'SAVE': 'SAVE',
        'SAVE_AND_RUN': 'Run Analysis & Save',
        'OK': 'OK',
        'CONTINUE': 'Continue'
      },
      'RUNNING_ANALYSIS': {
        'TITLE': 'Running analysis...',
        'DESCRIPTION': 'Still working… this might take a couple of minutes'
      },
      'ANALYSIS_RESULTS': {
        'TITLE': 'Point Map Analysis Complete',
        'STRESS_VALUE': 'Stress value',
        'ITERATIONS': 'Iterations',
        'ITERATIONS_TOOLTIP': 'Iterations is the number of attempts completed by the software to get the lowest stress value that represents the aggregated sort data. ',
        'FILTERS': 'Filters',
        'SIM_CUTOFF': 'Sim. Cutoff',
        'UPDATED': 'Ran on',
        'CREATE': 'and Create Scenario',
        'TOOLTIP': 'The stress value is the major metric for indicating the degree to which a multidimensional ' +
        'scaling solution fits the original similarity matrix.  The better the fit of a map to the similarity matrix, the lower the stress value. In typical projects, ' +
        'the stress is usually from .10 to .35 and the results are interpretable.',
      },
      'ANALYSIS_ERROR': {
        'TITLE': 'Something went wrong',
        'DESCRIPTION': 'We weren’t able to complete analysis, please try again.',
        'DUPLICATE_NAME': 'Title is already in use'
      },
      'RUN_ANALYSIS_ERROR': {
        'TITLE': 'Run Analysis Error',
        'DESCRIPTION': 'We couldn\'t run the analysis because of the following error/s:',
        'PARTICIPANTS': 'You have no participants selected to run the analysis.',
        'FILTERS': 'You need to complete the filter condition/s for selecting users by participant questions',
        'CLOSE': 'CLOSE'
      },
      'CUTOFF_WARNING': {
        'TITLE': 'Cutoff value',
        'DESCRIPTION': 'Caution! Setting the similarity cutoff above two may eliminate perceived relationships.'
      },
      'PARTICIPANTS_LIST': {
        'TITLE': 'Participants',
        'SELECT_ALL': 'Select all',
        'SELECT_NONE': 'Select none',
        'TOTAL': 'total',
        'EMPTY': 'No results found'
      },
      'CONFIRM_QUIT': {
        'TITLE_NEW': 'Quit New Scenario',
        'TITLE_EDIT': 'Quit Edit Scenario',
        'DESCRIPTION_1': 'You have changed one or more scenario options, wich have not been saved.',
        'DESCRIPTION_2': 'Click OK to discard this changes, or CANCEL to continue editing the scenario'
      },
      'LANDING': {
        'TITLE': 'SCENARIO:',
        'NEW_MAP': 'NEW MAP',
        'POINT_MAP': {
          'TITLE': 'POINT MAPS'
        },
        'CLUSTER_MAP': {
          'TITLE': 'CLUSTER MAPS',
          'CREATOR': 'Cluster map creator',
          'CREATOR_TOOLTIP': 'Click on a cluster thumbnail to toggle between maps to compare. Set as a cluster solution using the link in the ' +
          'Quick View or by clicking the three dot menu on the left of the thumbnail.  You can also remove a cluster solution by using the link in the ' +
          'Quick View or by selecting that option in the three dot menu.  ',
          'SOLUTION': 'Cluster solution',
          'EMPTY': 'You haven\'t chosen a <b>cluster solution</b> yet',
          'SELECT_CLUSTER': 'select a cluster solution for this scenario',
          'OPTIONS': {
            'CHANGE_SOLUTION': 'Change cluster solution',
            'DELETE': 'Delete Cluster Map'
          }
        },
        'POINT_RATING_MAP': {
          'TITLE': 'POINT RATING MAPS',
          'EMPTY': 'You haven\'t created any <b>point rating</b> maps yet',
          'OPTIONS': {
            'EDIT': 'Edit Point Rating Map',
            'CLONE': 'Clone Point Rating Map',
            'DELETE': 'Delete Point Rating Map'
          }
        },
        'CLUSTER_RATING_MAP': {
          'TITLE': 'CLUSTER RATING MAPS',
          'EMPTY': 'You haven\'t created any <b>cluster rating</b> maps yet',
          'OPTIONS': {
            'EDIT': 'Edit Cluster Rating Map',
            'CLONE': 'Clone Cluster Rating Map',
            'DELETE': 'Delete Cluster Rating Map'
          }
        }
      },
      'NEW_MAP_MODAL': {
        'TITLE': 'New Map',
        'DESCRIPTION': 'Select the type of map you want to create',
        'MAP_TYPES': {
          'POINT': 'Point',
          'CLUSTER': 'Cluster',
          'POINT_RATING': 'Point Rating',
          'CLUSTER_RATING': 'Cluster Rating'
        },
        'BUTTONS': {
          'CANCEL': 'Cancel',
          'NEW_MAP': 'New Map'
        },
        'TOOLTIP': 'Cluster Rating maps are based on your Cluster Solution. You can create Cluster Rating maps once you select a Cluster Solution for your scenario'
      }
    },
    'POINT_MAP': {
      'EDIT_NAME': 'Name:',
      'EDIT_NAME_TOOLTIP': 'Click here to edit the title of the cluster map. This will be used in dropdown menus and exports.',
      'EDIT_MAP': {
        'BUTTON': 'Edit map',
        'DISCARD': 'Discard',
        'SAVE_CHANGES': 'Save changes'
      },
      'EDIT_POINT_POSITION': 'Edit point\'s position',
      'EDITING_POINT_POSITION': 'Editing point\'s position',
      'SHOW_CLOSEST_STATEMENTS': 'Show closest statements',
      'HIDE_CLOSEST_STATEMENTS': 'Hide closest statements',
      'RELOCATE_STATEMENT': 'Relocate statement',
      'AVERAGE_RATING': 'Average Rating',
      'EXPORT': 'Export map as...',
      'EXPORT_REPORT': 'Export report as...',
      'EXPORT_SUMMARY': 'Export summary as...',
      'DELETE': 'Delete map',
      'CURRENT_LOCATION': 'Current location:',
      'ORIGINAL_LOCATION': 'Original location:',
      'ENABLE_RELOCATION': 'Enable relocation (drag point)',
      'RESTORE': 'Restore',
      'COLOR_PICKER': 'Point Color',
      'IN_CLUSTER': 'In cluster:',
      'MOVING_POINT_TO_CLUSTER': 'Move point to cluster:',
      'REVERT_POINT_POSITION': 'Revert point to original position',
      'REVERT_POINTS_POSITION': 'Revert all points to original position',
      'MOVING_POINT_TO_CLUSTER_BUTTONS': {
        'CANCEL': 'Cancel',
        'MOVE': 'Move'
      },
      'MOVE_TO_CLUSTER': 'move to cluster…',
      'SPANNING_PROMPT': 'Click on a point to see spanning analysis',
      'NO_ELEMENTS': 'Cluster Rating Map Corrupted - Please remove this map using the three dots on the map title box, delete Cluster Rating Map, then reconstruct this Cluster Rating Map',
      'MAP_DETAILS': {
        'TITLE': 'Map details',
        'TOOLTIP': 'These are the reference numbers for the statements that correspond to the numbered points.',
        'TOOLTIP_SIZE': 'Toggle on or off the overlaid points from the point map on the cluster solutions. ',
        'TOOLTIP_SIZE_OPTIONS': 'You can edit the sizing of the points. S = Small, M=Medium, L=Large. ',
        'TOOLTIP_NUMBERS': 'Toggle to turn the reference numbers on and off.  You can also edit the size of the numbers: S = Small, M=Medium, L=Large.',
        'TOOLTIP_INFO': 'Toggle on and off the number of sorters, the stress value, and iterations. ',
        'TOOLTIP_BRIDGING': 'Bridging is a value that ranges from 0 to 1 and is computed for each statement and cluster as part of the GCM analysis.' +
        ' It describes how each item on the map is related by the strength of the aggregated sorting data to the statements around it. \n' +
        'Lower values are anchors. Higher values are bridges. For more information, go to the Help Center section about point maps.',
        'TOOLTIP_SPANNING': 'A spanning analysis shows how frequently a statement on the map has been sorted with every other statement. ',
        'TOOLTIP_COLOR': 'This changes the color of all points. To change an individual point, click the point then click the color dot to the left of the number and statement. ',
        'TOOLTIP_LABEL': 'This changes the position of the reference number for all points. To change the reference number position of an individual point,' +
        ' click the point then click the position menu to the left of the number and statement.',
        'TOOLTIP_FONT': 'This changes the font family of all the reference numbers.',
        'SHOW_BEST_LABELS_TOOLTIP': 'Labels shown are based on participants\' sort pile titles most similar to the cluster shown. Ideal cluster label length is 64 characters or less.',
        'RESET': 'reset',
        'SPANNING': {
          'TITLE': 'Spanning values',
          'REF': 'REF',
          'TIMES_SORTED': 'TIMES SORTED*',
          'EXPLANATION': '*Number of times sorted together',
          'LINE_1': '0 to <20%',
          'LINE_2': '20% to <40%',
          'LINE_3': '40% to <60%',
          'LINE_4': '60% to <80%',
          'LINE_5': '80% to 100%',
        },
        'BRIDGING': {
          'TITLE': 'Bridging values',
          'REF': 'REF',
          'BRIDGING_VALUES': 'BRIDGING VALUES',
          'LEGEND': '%0 to %1'
        },
        'CLUSTER_LAYERS_VALUE': 'Value',
        'RATING': {
          'TITLE': 'Rating values',
          'REF': 'REF',
          'RATING_VALUES': 'RATING VALUES',
          'LEGEND': '%0 to %1'
        },
      },
      'REPORT_DETAILS': {
        'TITLE': 'Report details',
      },
      'POPUP': {
        'CLOSEST': {
          'DIST': 'DIST.',
          'STATEMENT': 'STATEMENT'
        },
        'BRIDGING': {
          'VALUE': 'Bridging value:'
        },
        'SPANNING': {
          'WITH': 'Sorted with',
          'TIMES': 'times'
        },
        'RATING': {
          'VALUE': 'Rating (Importance):'
        },
        'AVERAGE_BRIDGING': 'Average Bridging:'
      },
      'OPTIONS': {
        'TITLE': 'VIEW:',
        'POINTS': 'Points',
        'SIZE': 'Size:',
        'STATEMENT_NUMBERS': 'Statement numbers',
        'SCENARIO_INFO': 'Scenario info',
        'ADITIONAL_INFORMATION': 'Additional Information:',
        'BRIDGING_VALUES': 'Bridging values',
        'BRIDGING_INFO': 'Bridging info',
        'SPANNING_INFO': 'Spanning info',
        'CLUSTER_INFO': 'Cluster info',
        'CLUSTER_NUMBERS': 'Cluster numbers',
        'CLUSTER_LABELS': 'Cluster labels',
        'CLUSTER_COLORS': 'Cluster colors',
        'CLUSTER_SHAPE': 'Cluster shape',
        'CLUSTER_SHAPE_TOOLTIP': 'This will smooth the cluster edges, softening line linking the points instead of' +
        ' a connect-the-dots view.  You can select among 3 levels of smoothness.',
        'NAME_TOOLTIP': 'Click here to edit the title of the cluster map. This will be used in dropdown menus and exports.',
        'SAMPLE_SIZE': 'Sample size',
        'SAMPLE_SIZE_TOOLTIP': 'Toggle on to show the number of participants involved in this rating.',
        'BACK_TO_DEFAULT': 'Back to default'
      },
      'RELOCATE_MODAL': {
        'TITLE': 'Relocate point',
        'DESCRIPTION_1': 'Do you want to relocate this point?',
        'DESCRIPTION_2': 'You can undo this and return the point to its original location.'
      },
      'SCENARIO_INFO': {
        'PARTICIPANTS': 'Participants',
        'FILTERS': 'PQ Filters',
        'CUTOFF': 'Sim. Cutoff',
        'STRESS': 'Stress Value',
        'ITERATIONS': 'Iterations'
      },
      'CUSTOMIZATION': {
        'TITLE': 'Map customization',
        'COLOR': 'Color of points',
        'CLUSTER_COLOR': 'Color of clusters',
        'CLUSTER_COLOR_TOOLTIP': 'This changes the color of all clusters. To change an individual cluster,' +
        ' click the cluster then click the color dot to the left of the number and cluster title. ',
        'LABEL': 'Label position',
        'POINT': 'Point position',
        'FONT': 'Text font',
        'FONT_TOOLTIP': 'This changes the font family of all the cluster labels.',
        'TEXT_SIZE': 'Text size',
        'OPACITY': 'Labels opacity',
        'OPACITY_TOOLTIP': 'You can adjust how transparent or opaque the label backgrounds are: 0 shows a fully transparent background and 100 shows a solid white background behind the label.',
        'LABELS_COLOR': 'Color of labels',
        'LABELS_COLOR_TOOLTIP': 'This changes the color of all the text in each label. ',
        'CLUSTER_COLOR_PICKER': 'Cluster color',
        'LABEL_COLOR_PICKER': 'Label color',
      },
      'CUSTOMIZATION_REPORT': {
        'TITLE': 'Report customization'
      },
      'BRIDGING_VALUES_EXPORT': {
        'LEGEND': 'Point Legend',
        'LAYER': 'Layer',
        'VALUE': 'Value'
      },
      'BRIDGING_VALUES_EXPORT_CLUSTER': {
        'LEGEND': 'Cluster Legend',
        'LAYER': 'Layer',
        'VALUE': 'Value'
      },
      'BACK_TO_DEFAULT_EDIT': {
        'TITLE': 'Go back to default view?',
        'DESCRIPTION': 'Are you sure you want to change your current settings and go back to the default map settings?'
      }
    },
    'NEW_MAP': {
      'POINT_MAP': 'Point Map',
      'TITLE_POINT': 'New Point Rating Map',
      'TITLE_POINT_EDIT': 'Edit Point Rating Map',
      'TITLE_CLUSTER': 'New Cluster Rating Map',
      'TITLE_CLUSTER_EDIT': 'Edit Cluster Rating Map',
      'BASED_ON': 'Based on <strong>%0</strong> in <strong>%1</strong> scenario',
      'RATING_QUESTION': 'Rating Question',
      'RATING_QUESTION_TOOLTIP': 'This overlays rating data from approved participant data for the selected rating ' +
      'question on the point map generated by the sorting data for this scenario. ',
      'EDIT': 'edit',
      'NAME_PLACEHOLDER': 'Type a name for your map',
      'PARTICIPANTS_INCLUDED': 'participants with approved <strong>%0</strong> rating',
      'SELECT_A_RATING_QUESTION': 'Select a question to view how many approved ratings are available',
      'CREATE_BUTTON': 'Create Map',
      'SAVE_BUTTON': 'Save',
      'UPDATE_BUTTON': 'Update Map',
      'CONFIRM_QUIT': {
        'TITLE_NEW_POINT': 'Quit New Point Rating Map',
        'TITLE_NEW_CLUSTER': 'Quit New Cluster Rating Map',
        'TITLE_EDIT_POINT': 'Quit Edit Point Rating Map',
        'TITLE_EDIT_CLUSTER': 'Quit Edit Cluster Rating Map',
        'DESCRIPTION_1': 'You have changed one or more map options, wich have not been saved.',
        'DESCRIPTION_2': 'Click OK to discard this changes, or CANCEL to continue editing the map'
      },
      'CREATE_ERROR': {
        'TITLE': 'Something went wrong',
        'DESCRIPTION': 'We weren’t able to create the map, please try again.',
        'DUPLICATE_NAME': 'Title is already in use'
      }
    },
    'EXPORT_MAPS': {
      'TITLE': 'Export Map As...',
      'SUMMARY': 'Export Summary As...'
    },
    'EXPORT_REPORT': {
      'TITLE': 'Export Report As...'
    },
    'CLUSTER_MAP_CREATOR': {
      'TITLE_1': 'Cluster Map',
      'TITLE_2': 'Creator',
      'TAB': {
        'REVIEW': 'REVIEW',
        'COMPARE': 'COMPARE',
        'COMPARE_TOOLTIP': 'Click this button to add the currently selected cluster solution to the compare group. The Compare group is viewable by clicking Compare above.',
      },
      'VISUALIZE': {
        'TEXT_1': 'Visualize and compare from ',
        'TEXT_2': 'to',
        'TEXT_3': 'cluster solutions',
        'EDIT': 'edit',
        'EDIT_LABEL': 'When you replay from a larger cluster number to a small number,' +
        ' the labels of the starting (higher) cluster solution will remain as clusters are combined in the replay.' +
        ' This illustrates where clusters have merged. ',
      },
      'EDIT_RANGE': {
        'TITLE': 'EDIT RANGE',
        'FROM': 'From:',
        'TO': 'To:'
      },
      'BUTTONS': {
        'CANCEL': 'CANCEL',
        'UPDATE': 'UPDATE'
      },
      'OPTIONS': {
        'TITLE': 'View:',
        'CLUSTER_NUMBERS': 'Cluster numbers',
        'CLUSTER_NUMBERS_TOOLTIP': 'Toggle on or off the system generated reference number for each cluster. ',
        'CLUSTER_LABELS': 'Cluster labels',
        'CLUSTER_LABELS_TOOLTIP': 'Toggle on or off the system generated label that is based on participants sort pile titles, for each cluster. ',
        'CLUSTER_COLORS': 'Cluster colors',
        'CLUSTER_COLORS_TOOLTIP': 'Toggle on or off the colors of the clusters. ',
      },
      'CLUSTERS': 'clusters',
      'ADD_COMPARE': 'Add to compare',
      'ADD_COMPARE_TOOLTIP': 'Click this button to add the currently selected cluster solution to the compare group. The Compare group is viewable by clicking Compare above.',
      'MERGE_DETAILS': {
        'TITLE': 'Merge details',
        'START': 'Start:',
        'DOWNLOAD': 'Download merge info',
        'NO_CLUSTERS': 'No clusters were merged yet'
      },
      'COMPARE': {
        'TITLE': 'Compare all your added maps and choose a Cluster Solution for your scenario',
        'TITLE_TOOLTIP': 'Click this button to add the currently selected cluster solution to the compare group. The Compare group is viewable by clicking Compare above.',
        'SET_SOLUTION': 'Set as my cluster solution',
        'REMOVE': 'Remove from list',
        'QUICK_VIEW': 'Quick view',
        'SOLUTION': 'Cluster Solution'
      },
      'INTRO': {
        'SKIP': 'Skip intro',
        'NEXT': 'NEXT',
        'BACK': 'BACK',
        'DONE': 'DONE',
        'INTRO_1': {
          'TITLE_1': 'Welcome',
          'TITLE_2': 'to the Cluster Map Creator'
        },
        'INTRO_2': {
          'TITLE': 'Review',
          'DESCRIPTION': 'First, preview different cluster configurations and save as many as you need for deeper comparison'
        },
        'INTRO_3': {
          'TITLE': 'Compare',
          'DESCRIPTION': 'Then, compare through the cluster configurations you saved and select one as the solution for your scenario'
        }
      },
      'MODAL_SOLUTION_OK': {
        'TITLE': 'Congratulations!',
        'DESCRIPTION': 'You have successfully chosen a cluster solution for your scenario',
        'GO_TO': 'GO TO MY MAPS',
        'CONTINUE': 'Continue reviewing cluster maps'
      },
      'MODAL_CONFIRM_SOLUTION': {
        'TITLE': 'Change Cluster Solution?',
        'CURRENT': 'Current:',
        'NEW': 'New:',
        'CHANGE_WILL': {
          'TITLE': 'Changing your cluster solution:',
          'DESC_1': '<strong>Old saved maps and reports</strong> will remain based on the previous solution. You may want to edit old map and report titles.  ',
          'DESC_2': '<strong>New Cluster Rating Maps and reports</strong> will build using the most recently selected cluster solution.'
        },
        'CANCEL': 'CANCEL',
        'CONTINUE': 'CONTINUE'
      },
      'MODAL_REMOVE_CLUSTER': {
        'TITLE': 'Delete Cluster Map',
        'DESCRIPTION_1': 'Are you sure you want to delete this map?',
        'DESCRIPTION_2': 'If you are removing a map that is your cluster solution, you will need to choose another map. <strong>All maps and reports built using the deleted cluster solution will also be deleted.</strong>',
        'CANCEL': 'Cancel',
        'CONFIRM': 'YES, delete'
      }
    }
  },

  // ========== REPORTS ==========
  // =============================
  'REPORTS': {
    'LANDING': {
      'TITLE': 'Reports',
      'NEW_REPORT': 'NEW REPORT',
      'EDIT_REPORT': 'Edit Report',
      'DUPLICATE_REPORT': 'Duplicate Report',
      'DUPLICATING': 'Duplicating...',
      'DUPLICATING_ERROR': 'Failed to duplicate report',
      'DELETE_REPORT': 'Delete Report',
      'SELECT_SCENARIO': 'Select scenario',
      'SHOW_BY_DROPDOWN': {
        'LABEL': 'Show',
        'ITEMS': {
          'ALL': 'All reports',
          'GO_ZONES': 'Go-Zones only',
          'PATTERN_MATCHES': 'Pattern Matches only',
          'T_TESTS': 'T-Tests only',
          'STATEMENTS_AND_CLUSTERS': 'Statements & Clusters only',
          'SIMILARITY_MATRIX': 'Similarity Matrices only',
          'DISTANCE_MATRIX': 'Distance Matrices only',
        },
      },
      'NEW_REPORT_MODAL': {
        'RATING_TITLE': 'New Rating Report',
        'PRR': 'Participant rating report',
        'RRR': 'Raw rating report',
        'TITLE': 'New Report',
        'TEXT': 'Select the type of report you want to create',
        'DESC': 'Reports based on ',
        'DESC_STRONG': 'Cluster Map',
        'GO_ZONE': 'Go-Zone',
        'GO_ZONE_DESC': 'Go-A quadrant-based comparison of statements within clusters',
        'GO_ZONE_TOOLTIP': 'A Go-zone is a quadrant-based ratings comparison of statements within a specific cluster, comparing two ratings or two subgroups on one rating.',
        'PATTERN_MATCH': 'Pattern Match',
        'PATTERN_MATCH_DESC': 'A side by side comparison of ratings based on clusters',
        'PATTERN_MATCH_TOOLTIP': 'A Pattern Match is a side by side comparison of ratings based on cluster averages, comparing two ratings or subgroups on one rating.',
        'T_TEST': 'T-Test',
        'T_TEST_DESC': 'Calculate t and p values between clusters and ratings',
        'T_TEST_TOOLTIP': 'Calculate t and p values between clusters and ratings',
        'STATEMENTS_CLUSTERS': 'Statements & Clusters',
        'STATEMENTS_CLUSTERS_DESC': 'All the information and stats on statements and clusters',
        'STATEMENTS_CLUSTERS_TOOLTIP': 'All the information and stats on statements and clusters',
        'POINT_MAP_BASED': 'Reports based on ',
        'POINT_MAP': 'Point Map',
        'SIMILARITY': 'Similarity Matrix',
        'SIMILARITY_DESC': 'View how many participants sorted two statements together',
        'SIMILARITY_TOOLTIP': 'This shows the number of participants who sorted each statement with any other statement.',
        'DISTANCE': 'Distance Matrix',
        'DISTANCE_DESC': 'View the distance between each point with every other point',
        'DISTANCE_TOOLTIP': 'This shows the distance between each point and every other point in a map.',
      },
      'NEW_SIMILARITY_MATRIX_MODAL': {
        'TITLE': 'New Similarity Matrix',
        'TITLE_EDIT': 'Edit Similarity Matrix',
        'CANCEL': 'CANCEL',
        'CONTINUE': 'CONTINUE',
        'NAME': 'NAME',
        'SCENARIO': 'SCENARIO'
      },
      'EXPORT_SIMILARITY_MATRIX_MODAL': {
        'TITLE': 'Export Report As...',
        'CHOOSE': 'Choose the layout for the download file:',
        'DIAGONAL': 'Diagonal',
        'TABLE': 'Table',
      },
      'EXPORT_DISTANCE_MATRIX_MODAL': {
        'TITLE': 'Export Report As...',
        'SUBTITLE': 'Export Distance Matrix',
      },
      'NEW_DISTANCE_MATRIX_MODAL': {
        'TITLE': 'New Distance Matrix',
        'TITLE_EDIT': 'Edit Distance Matrix',
        'CANCEL': 'CANCEL',
        'CONTINUE': 'CONTINUE',
        'NAME': 'NAME',
        'SCENARIO': 'SCENARIO'
      },
      'NEW_CLUSTER_REPORT': {
        'TITLE': 'New Cluster Report',
        'EDIT_TITLE': 'Edit cluster Report',
        'NAME': 'NAME',
        'SCENARIO': 'SELECT SCENARIO',
        'CANCEL': 'CANCEL',
        'CONTINUE': 'CREATE',
      },
      'DELETE_REPORT_MODAL': {
        'TITLE': 'Delete Report',
        'DESC': 'Are you sure you want to delete this report',
        'CANCEL': 'CANCEL',
        'CONTINUE': 'DELETE',
      },
      'NO_REPORTS': 'You haven\'t created any reports yet',
      'LOADING_REPORTS': 'LOADING',
      'RAW_DATA': 'Raw Data',
      'RAW_DATA_DESC': 'View and download all collected data from each activity',
      'PQ': 'Participant Questions',
      'ST': 'Sorting',
      'RT': 'Rating Questions',
    },
    'NEW_T_TEST': {
      'TITLE': 'New T-Test',
      'NAME': 'NAME',
      'SELECT_SCENARIO': 'SELECT SCENARIO',
      'CLUSTER': 'Cluster',
      'SELECT_CLUSTER': 'SELECT CLUSTER MAP',
      'RATING_QUESTION': 'Rating Question',
      'CONFIGURATION': {
        'TITLE': 'Configure your T-Test...',
        'GROUP_1': 'Group 1',
        'GROUP_2': 'Group 2',
      },
      'PARTICIPANTS_LIST': {
        'TITLE_GROUP_2': 'Participants Group 2',
        'TITLE_GROUP_1': 'Participants Group 1',
      },
      'EDIT_BUTTON': 'SAVE',
      'DEFAULT_SELECTORS': {
        'SCENARIO': 'Select scenario',
        'CLUSTER': 'Select cluster',
        'RATING': 'Select rating question'
      }
    },
    'T_TEST': {
      'LANDING': {
        'TITLE': 'TITLE',
        'T_TEST': 'T-Test',
        'EXPORT': 'EXPORT',
        'T_VALUE': 'T-Value',
        'DEGREES_FREEDOM': 'Degrees of Freedom',
        'LEVEL_SIGNIFICANCE': 'Level of Significance',
        'PI_VALUE': 'P-Value',
        'ONE': 'one tail',
        'TWO': 'two tails',
        'GROUP': 'Group',
        'RTG': 'Rtg',
        'RTG_QUESTION': 'Rating Question',
        'CLUSTER': 'Cluster',
        'PARTICIPANTS_INC': 'Participants Included',
        'FILTERS': 'Filters',
        'CLUSTER_RATING_AVG': 'Cluster Rating Average',
        'CLUSTER_RATING_VAR': 'Cluster Rating Variance',
        'NUMBER_STATEMENTS': 'Number of Statements',
      },
    },
    'CLUSTER_REPORT': {
      'LANDING': {
        'TITLE': 'STATEMENTS & CLUSTERS',
        'EXPORT': 'EXPORT AS...',
      },
      'SCENARIO': 'Scenario',
      'EDIT': 'edit',
      'CLUSTER': 'Cluster',
      'BRIDGING_DATA': 'Bridging data',
      'RATING_DATA': 'Rating data',
      'SUMARIZED_STATS': 'Summarized Stats',
      'CLUSTERS_INFO': 'Clusters Info',
      'SCENARIO_INFO': 'Scenario Info',
      'PARTICIPANTS': ' Participants',
      'PQ_FILTERS': ' PQ Filters',
      'SIM_CUTOFF': ' Sim. Cutoff',
      'STRESS_VALUE': ' Stress value',
      'ITERATIONS': ' Iterations',
      'AVERAGE': 'Average ',
      'MEDIAN': 'Median ',
      'VARIANCE': 'Variance ',
      'STD_DEV': 'Std. Dev ',
      'MIN': 'Min ',
      'MAX': 'Max ',
      'COUNT': 'Count ',
      'CLUSTER_STATS': 'Cluster Stats',
      'TABLE': {
        'STATEMENTS': 'STATEMENTS',
        'BRIDGING': 'BRIDGING',
        'RATING': 'AVERAGE RATING'
      },
    },
    'NEW_PATTERN_MATCH': {
      'NEW_TITLE': 'New Pattern Match',
      'EDIT_TITLE': 'Edit Pattern Match',
      'NAME': 'Name',
      'SELECT_SCENARIO': 'select scenario',
      'SELECT_CLUSTER': 'select cluster map',
      'CONFIGURE': {
        'TITLE': 'Configure your Pattern Match…',
        'TOOLTIP': 'Pattern Matches compare the same set of participants on different rating scales OR different sets of  participants on the same rating scale.',
        'LINE': 'Line',
        'DELETE': 'Delete',
        'RATING_QUESTION': 'Rating Question',
        'AXIS': {
          'NAME': 'Axis name',
          'VALUES': 'Axis values',
          'VALUES_TOOLTIP': 'A Relative Pattern Match sets the axis values for the rating question(s) and rating data from participants who are identified as part ' +
          'of the subgroup being analyzed. An Absolute Pattern Match sets the axis values using the highest average and the lowest average from all sub-scales included in the Pattern Match.' +
          ' A Custom scale allows manual selection of the high and low of the Pattern Match. In rare cases, rounding may cause a cluster line to not appear. Use the custom scale to adjust the ' +
          'minimum and/or maximum to make the cluster line appear.',
          'MIN': 'Min',
          'MAX': 'Max'
        },
        'NEW_LINE': 'Add new line',
        'NEW_LINE_TOOLTIP': 'This allows you to develop a multiple line pattern match.  To make a multi-pattern match, you should set Axis Values to Absolute.'
      },
      'CREATE': 'create',
      'EDIT': 'save',
      'CONFIRM_QUIT': {
        'TITLE_NEW': 'Quit New Pattern Match',
        'DESCRIPTION_1': 'You have changed one or more pattern match options, wich have not been saved.',
        'DESCRIPTION_2': 'Click OK to discard this changes, or CANCEL to continue editing the pattern match'
      },
      'BUTTONS': {
        'CANCEL': 'CANCEL',
        'OK': 'OK'
      },
      'FILTER_ERROR': 'Something went wrong applying filters.',
      'SAVE_ERROR': {
        'TITLE': 'Something went wrong',
        'DESCRIPTION': 'We weren’t able to load the requested REPORT, please try again.  If this issue persists, please contact support@conceptsystems.com.',
        'DUPLICATE_NAME': 'Title is already in use'
      }
    },
    'NEW_GO_ZONE': {
      'NEW_TITLE': 'New Go-Zone',
      'EDIT_TITLE': 'Edit Go-Zone',
      'NAME': 'Name',
      'NAME_TOOLTIP': 'This name will be used in drop-down menus and exports. There is a 22 character limit for this title.',
      'SCENARIO_TOOLTIP': 'This selects the scenario for you to use to produce figures.',
      'CLUSTER_TOOLTIP': 'This is the cluster map that the ratings overlay will use. ',
      'SELECT_SCENARIO': 'select scenario',
      'SELECT_CLUSTER_MAP': 'SELECT CLUSTER MAP',
      'STATEMENTS_FROM': 'statements from',
      'STATEMENTS_FROM_TOOLTIP': 'To create a go-zone, select the cluster that you want display, or select "all statements" from the drop down box in the upper left portion of the window.',
      'CONFIGURE': {
        'TOOLTIP': 'Go-Zones can compare the same participants on different rating scales, and different subsets of  participants on the same rating scale.',
        'TITLE': 'Configure your Go-Zone...',
        'HORIZONTAL_AXIS': 'Horizontal Axis',
        'VERTICAL_AXIS': 'Vertical Axis',
        'SWAP_AXES_POSITION': 'Swap axes position',
        'CLEAR_AXIS_CONTENT': 'Clear axis content',
        'RATING_QUESTION': 'Rating Question',
        'RATING_QUESTION_TOOLTIP': 'Select the rating question from the dropdown box in each section. Selecting the rating question will automatically ' +
        'generate the list of “Users with completed rating” list .' +
        ' This can be edited with the filter participants function below.',
        'ALL_CLUSTERS': 'All clusters'
      },
      'CREATE': 'create',
      'EDIT': 'Save'
    },
    'GO_ZONE': {
      'GO_ZONE': 'Go-Zone',
      'EXPORT_AS': 'Export as...',
      'SCENARIO': 'Scenario:',
      'STATEMENTS_FROM': 'Statements from cluster:',
      'EDIT': 'edit',
      'ALL_CLUSTERS': 'All clusters',
      'AVERAGE': 'avg',
      'EDIT_MAP': 'Edit report',
      'DETAILS': 'Details',
      'OPTIONS': {
        'VIEW': 'View:',
        'POINT_COLORS': 'Point\'s cluster color',
        'POINT_COLORS_TOOLTIP': 'Toggle on or off the color of the points. The default view is the color of the cluster that the statement is in.',
        'MONOCHROME': 'Monochrome version',
        'MONOCHROME_TOOLTIP': 'Toggle on or off the background colors of the Go-Zone quadrants. ',
        'ROTATE_Y_AXIS': 'Rotate Y axis label',
        'ROTATE_Y_AXIS_TOOLTIP': 'Toggle on to rotate the Y-axis label 90 degrees to be parallel with the Y-axis, toggle off to leave the label horizontal.',
        'SAMPLE_SIZE': 'Sample size',
        'SAMPLE_SIZE_TOOLTIP': 'Toggle on to add the number of rating participants on each axis (n=#), off to remove.',
        'X_Y_AVERAGES': 'X/Y averages',
        'X_Y_AVERAGES_TOOLTIP': 'Toggle on or off the display of the (X,Y) average ratings for each point on the Go-Zone. ',
        'DIVIDER': 'Bold dividers',
        'DIVIDER_TOOLTIP': 'Toggle on to bold dividing lines (showing the means) between sections of the Go-Zone, off for lighter view.. ',

      },
      'DISCARD': 'Discard',
      'SAVE_CHANGES': 'Save Changes',
      'CHANGE_AXIS_NAME': {
        'INPUT': 'Label Name',
        'CANCEL': 'Cancel',
        'RENAME': 'Rename'
      },
      'CORRELATION': {
        'TITLE': 'Correlation',
        'REFERENCES': 'References',
        'TOOLTIP_ABBREVIATION': 'Edit abbreviation'
      },
      'SAMPLE_SIZE': {
        'TITLE': 'Sample size'
      },
      'LABEL_INFO': {
        'TITLE': 'Axis Statement Average',
        'RATING_QUESTION': 'Rating Question: ',
        'AXIS_LABEL': 'Axis Label: ',
        'SAMPLE': 'Sample Size: ',
      }
    },
    'SORTING': {
      'TITLE': 'Sorting',
      'SUBTITLE': 'RAW DATA',
      'RESET': 'Reset Filters',
      'SHOW_UNSORTED': 'Show Unsorted',
      'SHOW_UNSORTED_TOOLTIP': 'Toggle on or off to show or hide statements participants left unsorted.',
      'PILES_CREATED': 'piles created',
      'SORTED': 'sorted',
      'PILE': 'PILE',
      'UNSORTED': 'Unsorted statements:',
      'NO_PARTICIPANTS': 'No participants',
      'LOADING': 'Loading ...',
      'PARTICIPANTS_TYPES': {
        'LABEL': 'Showing sorting for',
        'LABEL1': 'participants, that',
        'LABEL2': 'sorting',
        'ALL': 'all',
        'ANONYMOUS': 'only anonymous',
        'NO_ANONYMOUS': 'not anonymous',
        'EMAIL': 'only email registered',
        'IDENTIFIER': 'only identifier registered'
      },
      'REGISTRATION_TYPES': {
        'ASSIGNED': 'were assigned to',
        'STATED': 'have started',
        'FINISHED': 'have completed',
        'INVITED': 'were invited to',
        'APPROVED': 'have approved data for',
        'REJECTED': 'have rejected data for'
      },
      'DOWNLOAD_DROPDOWN': {
        'CSV': 'Download report as CSV',
        'WORD': 'Download report as WORD'
      }
    },
    'PATTERN_MATCH': {
      'PATTERN_MATCH': 'Pattern Match',
      'AXIS': 'Axis:',
      'OPTIONS': {
        'AXIS_VALUES': 'Axis values',
        'AXIS_VALUES_TOOLTIP': 'Toggle on to show the values for each axis; toggle off to remove them'
      },
      'CHANGE_ABBREVIATION': {
        'TITLE': 'Change the abbreviation for:',
        'INPUT': 'Abbreviation',
        'MAX_CHAR': '(max. 3 char.)',
        'DUPLICATE': 'You can not have two labels with the same abbr'
      },
      'CORRELATION_TOOLTIP': 'The "r" value is a Pearson product-moment correlation which indicates the amount of predictable alignment between the average cluster ratings on the ladder graph axes.'
    },
    'EDIT_T_TEST': {
      'TITLE': 'Edit T-Test',
    },
    'SIMILARITY_MATRIX': {
      'TITLE': 'Reports',
      'SIMILARITY_MATRIX': 'Similarity Matrix',
      'LOADING': 'Loading',
      'SCENARIO': 'Scenario',
      'TOTALS': 'TOTALS',
      'INDIVIDUAL': 'INDIVIDUAL',
      'STATEMENT_NUMBER': 'Statement number',
      'STMT': 'Stmt',
      'FULL': 'Full',
      'EDIT': 'edit',
      'DIAGONAL': 'Diagonal',
      'VECTOR': 'Vector',
    },
    'DISTANCE_MATRIX': {
      'TITLE': 'Reports',
      'DISTANCE_MATRIX': 'Distance matrix',
      'LOADING': 'Loading',
      'SCENARIO': 'Scenario',
      'DIAGONAL': 'DIAGONAL',
      'TABLE': 'TABLE',
      'STATEMENT_NUMBER': 'Statement number',
      'STMT': 'Stmt',
      'FULL': 'Full',
      'EDIT': 'edit',
      'SHOW_CORDINATES': 'Show XY coordinates',
      'SHOW_CORDINATES_TOOLTIP': 'Toggle on to show the x-y coordinates for each point by reference number. Toggle off to remove.',
      'EXPORT': 'Export matrix',
      'EXPORT2': 'Export table',
    },
    'RATING': {
      'TITLE': 'Rating Questions',
      'RAW_RATING': {
        'NUMERIC': 'Numeric',
        'RADIO_BUTTON': 'Radio buttons',
        'RSI': 'Rating scale inverted',
        'RSN': 'Rating scale normal',
        'PARTICIPANTS': 'Participants',
        'STATEMENTS': 'Statements',
        'SHOW_DEMOGRAPHICS': 'Show demographics',
        'SHOW_DEMOGRAPHICS_TOOLTIP': 'Toggle on to show each participant\'s demographic data.' +
        ' It will appear to the right after the participant\'s rating data. Use the horizontal scroll to view if necessary. Toggle off to hide demographics.',
        'MEDIAN': 'Median',
        'MODE': 'Mode',
        'MIN_VALUE': 'Min. Value',
        'MAX_VALUE': 'Max. Value',
        'MEAN': 'Mean',
        'COUNT': 'Count',
        'VARIANCE': 'Variance',
        'DEVIATION': 'Deviation',
        'RATING_SUMMARY': 'RATING SUMMARY',
        'RATING_SUMMARY_TOOLTIP': 'Toggle on or off to show or hide ratings summary statistics. ',
        'HIDE': 'hide',
        'SHOW': 'show',
        'FREQUENCY_VALUE': 'Frequency of value:',
        'NO_DATA': 'No participant has rated this activity',
        'LOADING': 'Loading',
        'TYPE': 'Type',
        'MIN': 'Min',
        'MAX': 'Max',
        'EXPORT': 'Export raw ratings data',
        'EXPORT_ERROR': 'An error occurred while trying to get the report data.',
        'RAW_RATING_ERROR': {
          'TITLE': 'Generating Raw Rating Report',
          'DESCRIPTION': 'Due to the number of participants in your project, this report will take several hours for the system to compile. Select OK to continue working and you will receive the report in your email when it is complete.',
          'BUTTON': 'Ok'
        }
      },
      'PARTICIPANT_RATING': {
        'TITLE': 'Participant Rating',
        'SHOWING': 'Showing',
        'FOR': 'question results for',
        'UNRATED': 'Show unrated',
        'UNRATED_TOOLTIP': 'Toggle on or off to show or hide statements that participants left unrated. ',
        'RATING': 'RATING',
        'RATED': 'rated',
        'LABEL1': 'participants, that',
        'LABEL2': 'rating'
      }
    },
    'PARTICIPANT_QUESTIONS': {
      'TITLE': 'Participant Questions',
      'SUBTITLE': 'Raw Data',
      'NO_DATA': 'No data available',
      'PARTICIPANTS_TYPES': {
        'LABEL': 'showing answers for',
        'LABEL0': 'with the response',
        'LABEL1': 'for participants assigned to',
        'LABEL2': 'including',
        'LABEL3': 'status with',
        'LABEL4': 'data and filter by',
      },
      'TABS': {
        'SUMMARY': 'Summary',
        'DETAILS': 'Details'
      },
      'EXPORT': {
        'DETAILS': 'Export details as...',
        'SUMMARY': 'Export summary as...',
        'MODAL': {
          'TITLE': 'Export As...'
        }
      },
      'DETAILS': {
        'QUESTION': 'QUESTION',
        'PARTICIPANT': 'PARTICIPANT',
        'ANSWER': 'ANSWER'
      },
      'Q': 'Q',
      'OPTION': 'OPTION',
      'FREQUENCY': 'FREQUENCY',
      'TOTAL': 'Total',
      'SHOW_LEGEND': 'Show Legend',
      'HIDE_TOTALS': 'Hide did not respond totals',
      'HIDE_NO_RESPONSES': 'Hide rows with no responses',
      'SINGLE_CHOICE': 'Single Choice',
      'MULTIPLE_CHOICE': 'Multiple Choice',
      'SCALE': 'Scale',
      'OPEN_TEXT': 'Open Text',
      'QUESTION_STATS': {
        'TITLE': 'QUESTION STATS',
        'MAXIMUM': 'Maximum',
        'MEDIAN': 'Median',
        'MINIMUM': 'Minimum',
        'MODE': 'Mode',
        'COUNT': 'Count',
        'AVERAGE': 'Average',
        'DID_NOT_RESPOND': 'Did not respond',
        'STANDARD_DEVIATION': 'Standard Deviation'
      },
      'FILTERS': {
        'ALL_QUESTIONS': 'All Questions',
        'ANY_ACTIVITY': 'Any Activity',
        'ANY_RESPONSE': 'Any Response',
        'BRAINSTORMING': 'Brainstorming',
        'SORTING': 'Sorting',
        'ALL_RATINGS': 'All Ratings',
        'ALL_RATINGS_SORTING': 'All Ratings & Sorting',
        'ANY': 'Any',
        'ANY_QUESTION': 'Any question type',
        'NOT_COMPLETED': 'Not Completed',
        'ONLY_100': 'Only 100% completed',
        'APPROVED': 'Only Approved',
        'REJECTED': 'Only Rejected',
        'ASSIGNED': 'Assigned',
        'STARTED': 'Started',
        'COMPLETED': 'Completed',
      },
      'COLOR': 'Change color',
      'DOWNLOAD_DROPDOWN': {
        'JPG': 'JPG',
        'PNG': 'PNG',
        'SVG': 'SVG',
        'PDF': 'PDF',
        'PPT': 'PPT'
      }
    }
  },

  // =========== STAFF ===========
  // =============================
  'STAFF': {
    'MENU': {
      'DASHBOARD': 'DASHBOARD',
      'ACCOUNTS': 'ACCOUNTS',
      'PROJECTS': 'PROJECTS',
      'LICENSES': 'LICENSES',
      'LOG_ENTRIES': 'LOG ENTRIES',
      'MESSAGE_CENTER': 'MESSAGE CENTER',
      'FAQS': 'FAQS SETTINGS',
      'MIGRATION': 'MIGRATION'
    },
    'COPYRIGHT': {
      'MAIN': 'Copyright © 2026. Concept Systems, Inc. All rights reserved.',
    },
    'DASHBOARD': {
      'HI': 'Hi',
      'WELCOME': 'some quick info since your',
      'LAST_LOGIN': 'last login',
      'SEARCH': {
        'PLACEHOLDER': 'QUICK SEARCH: Type a project or account'
      },
      'LAST_PROJECT': {
        'TITLE': 'Last Project',
        'TOOLTIP': {
          'EDIT': 'Edit project',
          'GO': 'Project Entry'
        },
        'CREATED': 'Created',
        'TEAM': 'team members involved',
        'STATEMENTS': 'statements',
        'QUESTIONS': 'questions set',
        'OF': 'of',
        'PARTICIPANTS': {
          'TITLE': 'participants',
          'FINISHED': 'finished',
          'AVAILABLE': 'available'
        }
      },
      'MY_PROJECTS': {
        'TITLE': 'My Projects',
        'HEADERS': {
          'NAME': 'NAME',
          'STATUS': 'STATUS',
          'OWNER': 'PROJECT OWNER'
        },
        'FOOTER': {
          'SHOWING': 'Showing',
          'OF': 'of %0 projects'
        },
        'VIEW_ALL': 'VIEW ALL',
        'VIEW_LESS': 'VIEW LESS'
      },
      'MY_FAVOURITE_PROJECTS': {
        'TITLE': 'My Favorite Projects',
      },
      'ACCOUNTS': {
        'TITLE': 'Accounts',
        'MODULES': {
          'CSI_STAFF': 'CSI STAFF',
          'CUSTOMERS': 'CUSTOMERS',
          'PARTICIPANTS': 'PARTICIPANTS',
        },
        'BOXES': {
          'MEMBERS': 'MEMBERS',
          'LOCKED': 'LOCKED PASSWORD',
          'ANON': 'ANON ACCOUNT',
          'NEW': 'NEW ACCOUNT'
        }
      },
      'LICENSES': {
        'TITLE': 'Licenses',
        'BOXES': {
          'STANDARD': 'STANDARD LICENSES',
          'GOLD': 'GOLD LICENSES',
          'EXPIRED': 'LICENSES EXPIRED'
        },
        'PROJECTS': 'projects',
        'ACCOUNTS': 'accounts'
      }
    },
    'ACCOUNTS': {
      'TITLE': 'Accounts',
      'EXPORT_TABLE': 'EXPORT TABLE',
      'ADD_NEW_ACCOUNT': 'ADD NEW ACCOUNT',
      'SAVE': 'SAVE',
      'BACK': 'BACK',
      'DELETE': 'DELETE',
      'EMAIL': 'EMAIL',
      'USERNAME': 'USERNAME',
      'TABS': {
        'CSI_STAFF': 'CSI STAFF',
        'CUSTOMERS': 'CUSTOMERS',
        'PARTICIPANTS': 'PARTICIPANTS'
      },
      'WARNING': 'Warning message',
      'WARNING_PASSWORD': 'You are changing another account\'s password',
      'NOTIFICATIONS': {
        'ACCOUNT': {
          'SUCCESS': 'Successfully saved',
          'RE_SEND_EMAIL': 'Email has been sent correctly',
          'FAIL': 'Something went wrong. Please try again.'
        }
      },
      'FILTER': {
        'ADD_MORE': 'Add one or more filters to narrow down your search',
        'BY_WORD': 'BY WORD',
        'ACCOUNT_FILTERS': 'ACCOUNT FILTERS',
        'WITH_LICENSE': 'With license',
        'NOT_OWNER': 'Not project owner',
        'PLACEHOLDER': 'Type a username account',
        'ACCOUNT_STATUS': 'Account Status',
        'ACCOUNT_ROLE': 'Account Role',
        'ORGANIZATION_TYPE': 'Organization Type',
        'CREATED': 'Created',
        'ACTIVE': 'Active',
        'ACTIVATED': 'Activated',
        'DEACTIVATED': 'Deactivated',
        'BLOCKED': 'Blocked',
        'LOCKED_PASSWORD': 'Locked Password',
        'SUPER_ADMIN': 'Super-admin',
        'ADMIN': 'Admin',
        'CONSULTANT': 'Consultant',
        'SALES': 'Sales',
        'OWNER': 'Owner',
        'ADMINISTRATOR': 'Administrator',
        'PRODUCER': 'Producer',
        'DESIGNER': 'Designer',
        'COLLABORATOR': 'Collaborator',
        'READER': 'Reader',
        'NONE': 'None',
        'STUDENT': 'Student',
        'UNIVERSITY_COLLEGE': 'University / College',
        'FEDERAL_GOVERNMENT': 'Federal Government',
        'STATE_GOVERNMENT': 'State Government',
        'LOCAL_GOVERNMENT': 'Local Government',
        'COMMUNITY_BASED': 'Community Based',
        'FOUNDATION': 'Foundation / Not For Profit Organization',
        'COMMUNITY_BASED_ORGANIZATION': 'Community Based Organization',
        'FOR_PROFIT_CORPORATION': 'For profit corporation',
        'ACCEPTED': 'Accepted',
        'DECLINED': 'Declined',
        'PENDING': 'Pending',
        'TYPE_OF_PARTICIPATION': 'Type of Participation',
        'EMAIL_OR_IDENTIFIER': 'Email or Identifier',
        'EMAIL': 'Email',
        'IDENTIFIER': 'Identifier',
        'ANONYMOUS': 'Anonymous',
        'DISABLED': 'Disabled',
        'NARROWED_BY': 'Narrowed by:',
        'CLEAR_ALL': 'Clear all'
      },
      'ACCOUNT_RESULTS': 'Account Results',
      'SHOWING': 'Showing',
      'OF': 'of',
      'TABLE': {
        'USERNAME': 'USERNAME',
        'TYPE': 'TYPE',
        'EMAIL': 'EMAIL',
        'FIRST_NAME': 'FIRST NAME',
        'LAST_NAME': 'LAST NAME',
        'PHONE': 'PHONE',
        'STATUS': 'STATUS',
        'ROLE': 'ROLE',
        'CREATED': 'CREATED',
        'ORGANIZATION': 'ORGANIZATION',
        'PROJECTS': 'PROJECTS',
        'TOOLTIP': {
          'EDIT': 'Settings'
        },
        'DROPDOWN': {
          'DOWNLOAD_IC': 'Download Inform Consent',
          'DELETE_IC': 'Delete Inform Consent',
          'REMOVE_PROJECT': 'Remove Project',
          'ASSOCIATE_PROJECT': 'Associate Project',
        },
        'PAGINATION': {
          'PAGE': 'Page',
          'LABEL': 'Rows per page',
          'ALL': 'all'
        }
      },
      'TYPE': {
        'TITLE': 'TYPE',
        'EMAIL_OR_IDENTIFIER': 'Email or Identifier',
        'EMAIL': 'Email',
        'IDENTIFIER': 'Identifier',
        'ANONYMOUS': 'Anonymous'
      },
      'ERROR': {
        'VALIDATION': {
          'USERNAME': 'Username is required',
          'EMAIL': 'Please check this field, can\'t be blank or invalid mail.',
          'FIRST_NAME': 'First Name is required',
          'LAST_NAME': 'Last Name is required',
          'PHONE': 'Please check this field, can\'t be blank or invalid phone.',
          'ORGANIZATION': 'Organization is required',
          'SEATS': 'Number of seats is required.'
        }
      },
      'MODAL': {
        'EXIST_WARNING': {
          'TITLE': 'Existing Account',
          'TEXT': 'This account already exists as a participant. Please share the admin login link with this user. Their password will be the same as their participant password.'
        },
        'ADD_PROJECT': {
          'TITLE': 'Add Project',
          'DESCRIPTION': 'Search a project to associate with this account',
          'PLACEHOLDER': 'QUICK SEARCH: Type a project name',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE'
          }
        },
        'EDIT_ROLE': {
          'TITLE': 'Edit Account Project Role',
          'WARNING': 'Actual project owner will be replaced.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE'
          }
        },
        'EDIT_LICENSE': {
          'TITLE': 'Edit License',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE',
            'CONFIRM': 'CONFIRM',
            'ADD': 'ADD'
          },

        },
        'DELETE': {
          'TITLE': 'Delete Account',
          'DESCRIPTION': 'Are you sure you want to delete this CSI Staff account? You will lose all data related to this account that cannot be recovered.',
          'DESCRIPTION_CUSTOMER': 'Are you sure you want to delete this customer account? All data will be removed. This action cannot be undone.',
          'DESCRIPTION_PARTICIPANT': 'Are you sure you want to delete this participant account? All data will be removed. This action cannot be undone.',
          'ACTIVE_PROJECTS': 'Active projects:',
          'INACTIVE_PROJECTS': 'Inactive projects:',
          'CLOSED_PROJECTS': 'Closed projects:',
          'INPUTS': {
            'CURRENT_PASSWORD': 'CURRENT PASSWORD',
            'PLACEHOLDER': 'Enter you password',
            'ERRORS': {
              'REQUIRED': 'You must enter a password',
              'LENGTH': 'Your password needs a minimum of 6 characters'
            }
          },
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE'
          }
        },
        '2FA': {
          'TITLE': 'Enter a phone number',
          'DESCRIPTION': 'You need to enter your phone number first.'
        },
        'RESET_PASSWORD': {
          'TITLE': 'Reset Account Password',
          'FORCE': 'Force password change on next login',
          'INPUTS': {
            'NEW_PASSWORD': 'NEW PASSWORD',
            'CONFIRM_PASSWORD': 'CONFIRM PASSWORD',
            'PLACEHOLDER': {
              'NEW_PASSWORD': 'Enter password',
              'CONFIRM_PASSWORD': 'Confirm password'
            },
            'ERRORS': {
              'REQUIRED': 'You must enter a password',
              'LENGTH': 'Your password needs a minimum of 6 characters',
              'MATCH': 'Passwords don\'t match',
              'MATCH_USERNAME': 'Password can be equal or contain username/email'
            }
          },
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'RESET_PASSWORD': 'RESET PASSWORD'
          }
        }
      },
      'CREATE': {
        'CSI_STAFF': {
          'TITLE': 'New CSI Staff Account',
          'GENERAL_INFORMATION': 'General information',
          'USERNAME': 'USERNAME',
          'EMAIL': 'EMAIL',
          'FIRST_NAME': 'FIRST NAME',
          'LAST_NAME': 'LAST NAME',
          'PHONE': 'PHONE',
          'ROLE': 'ROLE',
          'STATUS': 'STATUS',
          'CREATED': 'Created',
          'RESEND_ACTIVATION_EMAIL': 'Resend activation email',
          'ASSOCIATED_PROJECTS': 'Associated projects',
          'ADD_PROJECT': '+ ADD PROJECT',
          'ACCOUNT_ROLE': 'Account Role',
          'PLACEHOLDER': {
            'USERNAME': 'Enter Username',
            'EMAIL': 'Enter Email',
            'FIRST_NAME': 'Enter First Name',
            'LAST_NAME': 'Enter Last Name'
          },
        },
        'CUSTOMERS': {
          'TITLE': 'New Customer Account',
          'GENERAL_INFORMATION': 'General information',
          'USERNAME': 'USERNAME',
          'EMAIL': 'EMAIL',
          'FIRST_NAME': 'FIRST NAME',
          'LAST_NAME': 'LAST NAME',
          'PHONE': 'PHONE',
          'STATUS': 'STATUS',
          'CREATED': 'Created',
          'RESEND_ACTIVATION_EMAIL': 'Resend activation email',
          'ASSOCIATED_PROJECTS': 'Associated projects',
          'ADD_PROJECT': '+ ADD PROJECT',
          'ACCOUNT_ROLE': 'Account Role',
          'PARTICIPANT_TYPE': 'PARTICIPANT TYPE',
          'PLACEHOLDER': {
            'USERNAME': 'Enter Username',
            'EMAIL': 'Enter Email',
            'FIRST_NAME': 'Enter First Name',
            'LAST_NAME': 'Enter Last Name',
            'ORGANIZATION': 'Enter Organization Name'
          },
          'NAME': 'NAME',
          'ROLE': 'ROLE',
          'ORGANIZATION': 'ORGANIZATION',
          'RESEND_ACCOUNT_ACTIVATION_EMAIL': 'Resend account activation email',
          'RESET_ACCOUNT_PASSWORD': 'Reset account password',
          'CUSTOMER': 'CUSTOMER',
          'LICENSE_INFORMATION': 'License Information',
          'SPECIAL_PERMISSIONS': 'Special permissions',
          'LICENSE_TYPE': 'LICENSE TYPE',
          'SEATS_AVAILABLE': 'SEATS AVAILABLE',
          'LICENSE_AGREEMENT': 'License agreement',
          'SHOW': 'Show',
          'SINGLE_USE': 'Single Use',
          'ANNUAL': 'Annual',
          'FLIP_SCALE': 'Flip scale',
          'DELETE_PARTICIPANTS': 'Delete a participant',
          'RELOCATE_POINTS': 'Relocate statement points'
        }
      },
      'EDIT': {
        'CSI_STAFF': {
          'CREATED': 'CREATED',
          'LAST_MODIFIED': 'LAST MODIFIED',
          'SECURITY': 'Security',
          '2FA': 'Two-Factor authentification',
          'ENABLED': 'Enabled',
          'DISABLED': 'Disabled',
          'RESEND_ACCOUNT_ACTIVATION_EMAIL': 'Resend account activation email',
          'RESET_ACCOUNT_PASSWORD': 'Reset account password',
          'BLOCK_ACCOUNT': 'Block Account',
          'UNBLOCKED': 'Unblocked',
          'BLOCKED': 'Blocked',
          'RESET': 'Reset:',
          'WARN': 'Changes will be apply after click on "SAVE" button.'
        },
        'CUSTOMERS': {
          'CREATED': 'CREATED',
          'LAST_MODIFIED': 'LAST MODIFIED',
          'SECURITY': 'Security',
          '2FA': 'Two-Factor authentification',
          'ENABLED': 'Enabled',
          'DISABLED': 'Disabled',
          'RESEND_ACCOUNT_ACTIVATION_EMAIL': 'Resend account activation email',
          'RESET_ACCOUNT_PASSWORD': 'Reset account password',
          'BLOCK_ACCOUNT': 'Block Account',
          'UNBLOCKED': 'Unblocked',
          'BLOCKED': 'Blocked',
          'RESET': 'Reset:',
          'STANDARD': 'Standard',
          'NO_LICENSE': 'No license',
          'SELECT_LICENSE': 'Select a license',
          'STATUS': {
            'ACCEPTED': 'Accepted',
            'PENDING': 'Pending',
            'DECLINED': 'Declined'
          }
        }
      },
      'STATUS': {
        'CREATED': 'Created',
        'ACTIVE': 'Active',
        'LOCKED': 'Locked',
        'BLOCKED': 'Blocked',
      },
      'ROLES': {
        'TITLE': 'CSI Staff Account Role'
      }
    },
    'PROJECTS': {
      'TITLE': 'Projects',
      'EXPORT_TABLE': 'EXPORT TABLE',
      'NEW_PROJECT': 'ADD NEW PROJECT',
      'PROJECT_RESULTS': 'Projects Results',
      'INVALID_FORMAT': 'Error uploading file: Invalid Format',
      'TABLE': {
        'ID': 'ID.',
        'PROJECT_NAME': 'NAME',
        'OWNER_USERNAME': 'OWNER USERNAME',
        'STATUS': 'STATUS',
        'LICENSE': 'LICENSE',
        'CREATED': 'CREATED',
        'TOOLTIP': {
          'FAVORITE': 'Favorite',
          'EDIT': 'Settings',
          'PROJECT_ENTRY': 'Project Entry',
        },
      },
      'CREATE': {
        'TITLE': 'New Project',
        'GENERAL_SETTINGS': 'General Settings',
        'PROJECT_NAME': 'PROJECT NAME',
        'ABBREVIATION': 'ABBREVIATION',
        'PROJECT_OWNER': 'Project Owner',
        'NO_PROJECT_OWNER': 'QUICK SEARCH: Type a customer account username',
        'IMPORT_PROJECT': 'Import Project',
        'OPTIONAL': '- Optional',
        'PLACEHOLDER': {
          'NAME': 'Project Name Example',
          'ABBREVIATION': 'TFF',
        },
        'NO_ROLE_SELECTED': 'No Role selected',
        'IMPORT': {
          'UPLOAD_LOGO': 'Upload logo (jpg or png)',
          'UPLOAD_FILE': 'UPLOAD FILE',
          'PROJECT_CONTENT': 'Project Content',
          'PROJECT_CUSTOM_INSTRUCTIONS': 'Project Custom Instructions',
          'PARTICIPANT_QUESTIONS': 'Participant Questions',
          'BRAINSTORMING_STATEMENT_LIST': 'Brainstorming statement list',
          'RATING_QUESTIONS': 'Rating Questions',
          'PARTICIPANT_LIST': 'Participant List',
          'SORTING_DATA': 'Sorting Data',
          'RATING_DATA': 'Rating Data',
          'PARTICIPANT_QUESTIONS_DATA': 'Participant Question Data',
          'TOOLTIP': {
            'CONTENT': 'Upload the focus prompt, consent to participate, project welcome and thank you title text & messages',
            'INSTRUCTIONS': 'Upload activity custom instruction titles and messages',
            'SORTING_DATA': 'You need to upload statements and participants in order to upload participant sorting data',
            'RATING_DATA': 'You need to upload rating questions, statements and participants in order to upload participant rating data',
            'PARTICIPANT_QUESTION_DATA': 'You need to upload participant questions and participants in order upload participant question data'
          }
        }
      },
      'FILTER': {
        'PLACEHOLDER': 'Type a project Name',
        'BY_WORD': 'BY WORD',
        'STATUS': 'STATUS',
        'ALL': 'All',
        'ACTIVE': 'Active',
        'INACTIVE': 'Inactive',
        'LICENSE': 'LICENSE TYPE:',
        'STANDARD': 'Standard',
        'GOLD': 'Gold',
      },
      'EDIT': {
        'MULTILINGUAL': 'Multilingual',
        'MULTILINGUAL_MAX': '(max. 3 lang.)',
        'ABBR_MAX': '(max. 3 char.)',
        'ENABLED': 'ENABLED',
        'DISABLED': 'DISABLED',
        'EXPIRATION_DATE': 'EXPIRATION DATE',
        'USERNAME': 'USERNAME',
        'PHONE': 'PHONE',
        'LICENSE_TYPE': 'LICENSE TYPE',
        'CHANGE_OWNER': 'CHANGE OWNER',
        'REMOVE_OWNER': 'REMOVE OWNER',
        'ADD_OWNER': 'ADD OWNER',
        'CREATED': 'CREATED',
        'LAST_MODIFIED': 'LAST MODIFIED',
        'ANNUAL': ' Annual',
        'OTHER_MEMBERS': 'Other Project Members',
        'CLOSE': 'Close',
        'OPEN': 'Open',
        'DUPLICATE': 'Duplicate',
        'SHADOW': 'Project Entry',
        'MEMBERS_TABLE': {
          'NAME': 'NAME',
          'ROLE': 'ROLE',
        },
        'UNBLOCKED': 'Unblocked',
        'LOCKED': 'Locked',
        'ADD_ACCOUNT': '+ ADD ACCOUNT',
        'STAFF_MEMBERS': 'Assigned CSI Staff Accounts',
        'PROJECT_SUMMARY': 'Project Summary',
        'PROJECT_LIMITS': 'Project Limits',
        'PROJECT_SETTINGS': 'Project Settings',
        'DELETE_PARTICIPANTS': 'Delete Participants',
        'SUMMARY': {
          'STATEMENTS': 'Statements',
          'RQ': 'Rating Questions',
          'PQ': 'Participant Questions',
          'PARTICIPANTS': 'Participants',
          'NOTIFICATIONS': 'Notifications Sent',
          'TEAM_MEMBERS': 'Project Team Members',
        },
        'SETTINGS': {
          'ANALYSIS_AND_REPORTS': 'Analysis & Reports',
          'STATEMENTS': 'Statements',
          'STATEMENTS_TOOLTIP': 'Locked statements means that statements cannot be edited in Brainstorming',
          'FLIP_RATING': 'Flip Rating Scale Function',
          'RELOCATE_POINTS': 'Relocate Statement Points',
          'PROJECT_EMAILS': 'Project Emails',
          'PROJECT_NOTIFICATIONS': 'Project Notifications',
          'DELETE_PARTICIPANTS': 'Delete Participants',
          'HIDE_STATEMENTS': 'Hide Brainstorm Statements List',
        },
        'LIMITS': {
          'PARTICIPANT': 'Participant limit for sorting and rating/project',
          'RQ': 'Rating question limit/project',
          'PQ': 'Participant/demographic question limit/project',
          'STATEMENTS_SR': 'Number of statements permitted for sorting and rating',
          'STATEMENTS_B': 'Number of statements permitted for Brainstorming',
          'DEACTIVATED_PARTICIPANTS': 'Deactivated participant limit',
        },
      },
      'SAVE': 'SAVE',
      'DELETE': 'DELETE',
      'BACK': 'BACK',
      'ERROR': {
        'VALIDATION': {
          'NAME': 'Project name is required',
          'ABBREVIATION': 'Abbreviation is required',
          'OWNER_ID': 'Project owner can not be empty',
        },
      },
      'MODAL': {
        'REMOVE_OWNER': {
          'TITLE': 'REMOVE OWNER',
          'DESCRIPTION': 'Are you sure you want to remove this project owner? \
          <br> If you remove the current Owner, the CSI Superadmin will be assigned to the project until a new Customer is assigned as Project Owner.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'REMOVE': 'REMOVE',
            'SAVE': 'SAVE',
          } ,
        },
        'REMOVE_MEMBER': {
          'TITLE': 'Remove Member Account',
          'DESCRIPTION': 'You have selected to remove this account form this project, do you want to proceed?',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'REMOVE': 'REMOVE',
          } ,
        },
        'REMOVE_STAFF_MEMBER': {
          'TITLE': 'Remove CSI Account',
          'DESCRIPTION': 'You have selected to remove this account form this project, do you want to proceed?',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'REMOVE': 'REMOVE',
          } ,
        },
        'CHANGE_OWNER': {
          'TITLE': 'CHANGE PROJECT OWNER',
          'DESCRIPTION': 'Search a customer account to assign to this project.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'CHANGE': 'SAVE',
          } ,
        },
        'ADD_OWNER': {
          'TITLE': 'Add Project Owner',
          'DESCRIPTION': 'Search a customer account to assign to this project.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'CHANGE': 'SAVE',
          } ,
        },
        'ADD_MEMBER': {
          'TITLE': 'Add Project Member',
          'DESCRIPTION': 'Search a customer account to assign to this project.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE',
          },
        },
        'ADD_STAFF_MEMBER': {
          'TITLE': 'Assign CSI Staff Account',
          'DESCRIPTION': 'Search a CSI Staff account to assign to this project.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE',
          },
        },
        'CLOSE_PROJECT': {
          'TITLE': 'Close Project',
          'TITLE_CONFIRMATION': 'Close Project',
          'DESCRIPTION_CONFIRMATION': 'You are about to close %0 project.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE',
          },
          'RADIO': {
            'READ': 'Entire project is Read only',
            'BLOCK': 'Entry blocked',
          },
          'CHECK': {
            'ANALYSIS': 'Allow analysis functions only',
            'REPORT': 'Allow report functions only',
          },
        },
        'DELETE_PROJECT': {
          'TITLE': 'Delete Project     ',
          'DESCRIPTION': 'You have selected to delete this project, do you want to proceed?',
          'TITLE_CONFIRM': 'Delete Project     ',
          'PASSWORD': 'PASSWORD',
          'DESCRIPTION_CONFIRM': 'Make sure you have exported the entire project as a backup. Please enter your password to confirm.',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'CONTINUE',
          },
        },
        'DUPLICATE_PROJECT': {
          'TITLE': 'Duplicate Project',
          'DESCRIPTION': 'This new duplicated project will inherit all settings from the original project.',
          'DESCRIPTION_EXPLANATION': 'Project Owner\'s and any associated customer accounts will also view the cloned project.',
          'LOADING': 'Please wait while cloning...',
          'ERROR': 'Something went wrong',
          'ERROR_HELP': 'Check your connection or does the Project Owner have the license limit to create multiple projects?',
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'CONTINUE',
          },
        },
        'IMPORT_LOGO': {
          'TITLE': 'Import Logo',
          'DIFFERENT': 'Upload a different file (.jpg or png)',
          'DRAG': {
            'BROWSE': 'Browse',
          },
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'CONTINUE',
          },
        },
        'IMPORT_PROJECT_CONTENT': {
          'TITLE': 'Import Project Content',
          'DIFFERENT': 'Upload a different file (.csv)',
          'DRAG': {
            'BROWSE': 'Browse',
          },
          'BUTTON': {
            'CANCEL': 'CANCEL',
            'SAVE': 'CONTINUE',
          },
        },
        'IMPORT_PROJECT_CUSTOM_INSTRUCTIONS': {
          'TITLE': 'Import Project Custom Instructions',
        },
        'IMPORT_PARTICIPANT_QUESTIONS': {
          'TITLE': 'Import Participant Questions',
        },
        'IMPORT_BRAINSTORMING_STATEMENT_LIST': {
          'TITLE': 'Import Brainstorming Statement List',
        },
        'IMPORT_RATING_QUESTIONS': {
          'TITLE': 'Import Rating Questions',
        },
        'IMPORT_PARTICIPANT_LIST': {
          'TITLE': 'Import Participant List',
        },
        'IMPORT_SORTING_DATA': {
          'TITLE': 'Import Sorting Data',
        },
        'IMPORT_RATING_DATA': {
          'TITLE': 'Import Rating Data',
        },
        'IMPORT_PARTICIPANT_QUESTION_DATA': {
          'TITLE': 'Import Participant Questions Data',
        },
        'UNABLE_TO_CREATE_PROJECT': {
          'TITLE': 'Unable to create project',
          'IMPORTANT': 'IMPORTANT',
          'DESCRIPTION': 'Do you want to create the project anyway or return and re-upload the invalid files?',
          'BUTTON': {
            'RETURN': 'RETURN',
            'CREATE': 'CREATE PROJECT'
          }
        }
      },
    },
    'LICENSES': {
      'TITLE': 'Licenses',
      'LICENSE': 'License',
      'ERRORS': {
        'REQUIRED': 'This field is required'
      },
      'TYPES': {
        'TITLE': 'Licenses Types',
        'ADD_NEW_LICENSE': 'ADD NEW LICENSE',
        'FILTER': {
          'LABEL': 'Show',
          'OPTIONS': {
            'ALL': 'All Licenses',
            'CURRENT': 'Current Licenses',
            'ARCHIVED': 'Archived Licenses'
          }
        },
        'HEADERS': {
          'STANDARD': 'STANDARD LICENSES',
          'GOLD': 'GOLD LICENSES',
          'EXPIRED': 'LICENSES EXPIRED'
        },
        'ROWS': {
          'PROJECTS_LIMIT': 'Rating question limit/project',
          'PARTICIPANT_LIMIT': 'Participant limit for sorting and rating/project',
          'STATEMENTS_ALLOWED_RATING_AND_SORTING': 'Statements permitted for sorting and rating',
          'PARTICIPANT_QUESTION_LIMIT': 'Participant questions limit/project',
          'RATING_ALLOWED': '',
          'DEACTIVATE_PARTICIPANT_LIMIT': '',
          'STATEMENT_PERMITTED_BRAINSTORMING': 'Statements permitted for Brainstorming',
          'LICENSE_DURATION': '',
        }
      },
      'AGREEMENT': {
        'TITLE': 'License Agreement',
        'TEXT': 'License Agreement text',
        'TRANSLATION': {
          'TITLE': 'License translation text',
          'DEFAULT': 'English'
        },
        'MODAL': {
          'TITLE': 'License Agreement',
          'LOADING': 'Loading...',
          'BUTTONS': {
            'CANCEL': 'CANCEL',
            'SAVE': 'SAVE'
          },
          'PLACEHOLDER': 'Add License Agreement text',
          'NOTIFICATION': 'Push update to Project Owners to re-accept the license agreement'
        }
      },
      'NEW': {
        'TITLE': 'New License information',
        'SUBTITLE': 'License limits settings',
        'NAME': 'LICENSE NAME',
        'SETTINGS': {
          'LIMIT_ST_RT_PROJECT': 'Participant limit for sorting and rating/project',
          'LIMIT_RT': 'Rating question limit/project',
          'LIMIT_PQ': 'Participant questions limit/project',
          'STATEMENTS_ST_RT': 'Number of statements permitted for Sorting and Rating/project',
          'STATEMENTS_BS': 'Number of statements permitted for Brainstorming/project'
        }
      },
      'NAME': 'Name',
      'CREATED': 'Created',
      'LAST_UPDATE': 'Last update',
      'SAVE': 'SAVE',
      'BACK': 'BACK',
      'DELETE': 'DELETE',
      'ARCHIVE': 'Archive',
      'UNARCHIVE': 'Unarchive',
      'NOTIFICATIONS': {
        'CREATE': {
          'SUCCESS': 'Successfully saved'
        }
      },
      'MODAL': {
        'DISCARD_CHANGES': {
          'TITLE': 'Discard changes',
          'DESCRIPTION': 'Are you sure you want to exit this screen? Any changes will not be saved',
          'BUTTON': {
            'CANCEL': 'No, don\'t leave',
            'SAVE': 'Yes, discard changes'
          }
        },
        'SAVE_EDITED_TEXT': {
          'TITLE': 'Save edited text',
          'DESCRIPTION': 'Do you want to leave editing the license agreement? Note: You need to save each translation text as you add them.',
          'BUTTON': {
            'SAVE_KEEP': 'Save and keep editing',
            'SAVE_LEAVE': 'Save and leave'
          }
        },
        'DELETE': {
          'TITLE': 'Delete License',
          'DESCRIPTION': 'Are you sure you want to delete this license? <br> License limits will not be changed for current projects. <br> Please enter your password to confirm.',
          'INPUTS': {
            'CURRENT_PASSWORD': 'CURRENT PASSWORD',
            'PLACEHOLDER': 'Enter you password',
            'ERRORS': {
              'REQUIRED': 'You must enter a password',
              'LENGTH': 'Your password needs a minimum of 6 characters'
            }
          },
          'BUTTON': {
            'CANCEL': 'No, don\'t delete',
            'SAVE': 'Yes, delete'
          }
        }
      }
    },
    'FAQS': {
      'TITLE': 'FAQs Settings',
      'SUBTITLE': 'FAQs Articles',
      'NEW_FAQ_TITLE': 'New FAQ',
      'EDIT_FAQ_TITLE': 'Edit FAQ',
      'BTN_ADD': 'ADD NEW FAQ',
      'SECTION': 'SECTION',
      'CATEGORY': 'CATEGORY',
      'BACK': 'BACK',
      'SAVE': 'Save',
      'FAQ_TITLE': 'TITLE',
      'FAQ_TITLE_PLACEHOLDER': 'Type FAQ title ',
      'TEXT': 'TEXT',
      'PROJECT_SETUP': 'PROJECT SETUP',
      'PARTICIPANTS': 'PARTICIPANTS ',
      'FIELDS_VALIDATION_ERROR': 'You must complete all fields in this section in order to save.',
      'SERVE_ERROR': 'There was an error saving the FAQ please try again',
      'CATEGORY_DROPDOWN': {
        'LABEL': 'Category',
        'ITEMS': {
          'METHODOLOGY': 'Methodology',
          'TROUBLESHOOTING': 'Troubleshooting',
          'LICENSING_AND_SALES': 'Licensing & Sales',
          'PARTICIPANT_QUESTIONS': 'Participant questions',
          'BRAINSTORMING': 'Brainstorming',
          'TABLETOP_SORTING': 'Tabletop Sorting',
          'MOBILE_SORTING': 'Mobile Sorting',
          'RATING_QUESTIONS': 'Questions',
        }
      },
      'TABS': {
        'PROJECT_SETUP': 'PROJECT SETUP',
        'PARTICIPANTS': 'PARTICIPANTS',
      },
      'TABLE_TABS': {
        'FAQS': 'FAQ',
        'CREATED': 'CREATED',
      },
      'LOADING': 'Loading',
      'NO_RESULTS': 'No Results',
      'SUCCESS': 'Successfully saved',
      'CONFIRMATION_MODAL': {
        'TITLE': 'Confirm changes',
        'TEXT': 'Are you sure you want to proceed? Your Customer/Participant interface will be updated.',
        'CANCEL': 'CANCEL',
        'YES': 'SAVE AND LEAVE',
        'SAVE_AND_KEEP': 'SAVE AND KEEP EDITING',
        'YES_DISCARD': 'YES, DISCARD',
        'DELETE': 'DELETE',
        'TITLE_DISCARD': 'Are you sure you want to change to another language?',
        'TEXT_DISCARD': 'All added FAQ information will be discarded unless you save.',
      },
      'CONFIRMATION_DELETE_MODAL': {
        'TITLE': 'Delete FAQ',
        'TEXT': 'Are you sure you want to delete this FAQ? Your Customer/Participant interface will be updated.',
      }
    },
    'MESSAGE_CENTER': {
      'TITLE': 'Message Center',
      'TABS': {
        'SYSTEM_NOTIFICATIONS': 'SYSTEM NOTIFICATIONS',
        'PROJECTS_EMAIL': 'PROJECTS EMAIL',
      },
      'RESULTS': 'messages',
      'NEW_NOTIFICATION': 'NEW NOTIFICATION',
      'NOTIFICATIONS_SENT': 'Notifications sent',
      'SORT_BY': 'Sort by:',
      'PROJECT': 'Project:',
      'SEARCH_PLACEHOLDER': 'QUICK SEARCH: Type a project',
      'PROJECT_PLACEHOLDER': 'Type a project',
      'MESSAGE_PLACEHOLDER': 'Type message',
      'SHOWING': 'Showing',
      'OF': 'of',
      'TO': 'To',
      'DELETE_ALL': 'DELETE ALL',
      'DELETE_SELECTED': 'DELETE SELECTED',
      'MODAL': {
        'DELETE': {
          'NOTIFICATION': {
            'TITLE': 'Delete Notification',
            'DESCRIPTION': 'Are you sure you want to delete this project message? <br /> Recipients will no longer be able  to view this.',
            'BUTTONS': {
              'CANCEL': 'CANCEL',
              'YES': 'YES'
            }
          },
          'EMAIL': {
            'TITLE': 'Delete Email',
            'DESCRIPTION': 'Are you sure you want to delete this project email? <br /> Recipients will no longer be able to view this.',
            'BUTTONS': {
              'CANCEL': 'CANCEL',
              'YES': 'YES'
            }
          }
        },
        'OPEN': {
          'TITLE': 'Notification sent',
          'BUTTONS': {
            'CANCEL': 'CANCEL',
            'DELETE': 'DELETE'
          }
        }
      },
      'MESSAGE_INFORMATION': 'Message information',
      'SEND_TO': 'SEND TO',
      'FROM': 'FROM',
      'TEMPLATE': 'TEMPLATE',
      'MESSAGE': 'MESSAGE',
      'SEND': 'SEND',
      'OPTIONAL': 'Optional',
      'RECIPIENT': 'RECIPIENT',
      'DROPDOWN': {
        'SORT_BY': {
          'ALL': 'All',
          'MOST_RECENT': 'Most recent',
          'LAST_YEAR': 'Last year',
          'LEAST_RECENT': 'Least recent',
          'PROJECT_NAME': 'Project Name'
        },
        'SEND_TO': {
          'ALL_PROJECTS': 'All projects',
          'ALL_ACTIVE_PROJECTS': 'All active projects',
          'SPECIFIC_PROJECT': 'Specific project'
        },
        'TEMPLATE': {
          'SELECT_TEMPLATE': 'Select a template',
          'SYSTEM_MAINTENANCE_NOTIFICATIONS': {
            'LABEL': 'System maintenance notifications',
            'TEXT': 'System will go through scheduled maintenance from [Tue 29, 11:59 pm] to [Wed 30, 01:30am]. Some delays are expected.'
          },
          'LICENSE_EXPIRATIONS': {
            'LABEL': 'License expirations',
            // tslint:disable-next-line:max-line-length
            'TEXT': 'Your Project Owner’s license is about to expire. Contact csiinfo@conceptsystems.com or purchase another license at gw.tech (30 day warning, 15 day warning, 7 day warning, 3 day, 2day, 1 day)'
          },
          'PATCH_NOTIFICATIONS': {
            'LABEL': 'Patch notifications',
            'TEXT': 'Patch [1.2] is released.'
          }
        },
        'RECIPIENT': {
          'ALL_PROJECT_TEAM_CONTACTS': 'All Project team contacts',
          'ALL_PROJECT_TEAM_CONTACTS_AND_PARTICIPANTS': 'All Project team contacts and participants',
          'PROJECT_OWNER_ONLY': 'Project Owner/s only',
          'CSI_STAFF': 'All GroupWisdom contacts (includes CSI Staff)',
        },
        'GROUPS': {
          'ALL_PROJECTS_CONTACTS': 'All project contacts',
          'ONLY_PROJECT_ADMINS': 'Only Project admins',
          'ALL_INVIDED_PARTICIPANTS': 'All invited participants',
          'PARTICIPANTS_PER_ACTIVITY': 'Participants per activity'
        },
        'ACTIVITIES': {
          'BRAINSTORMING': 'Brainstorming',
          'SORTING': 'Sorting',
          'RATINGS': 'Ratings',
          'PARTICIPANT_QUESTIONS': 'Participant Questions'
        }
      },
      'EMAIL_SENT': 'Emails sent',
      'NEW_EMAIL': 'NEW EMAIL',
      'GROUPS': 'GROUPS',
      'EMAIL_PREVIEW': 'Email Preview',
      'INCLUDE_LOGO': 'Include logotype in the email',
      'INCLUDE_LINK': 'Include link to the project',
      'SUBJECT': 'SUBJECT',
      'SUBJECT_PLACEHOLDER': 'Type a subject heading...',
      'SUBJECT_MAX_CHARACTERS': '(max. 80 characters)',
      'ACTIVITIES': 'ACTIVITIES',
      'ASSIGNED': 'Assigned',
      'STARTED': 'Started',
      'FINISHED': 'Finished',
      'NOTIFICATIONS': {
        'SYSTEM_NOTIFICATIONS': {
          'SUCCESS': 'Successfully saved'
        }
      },
      'ERRORS': {
        'REQUIRED': 'This field is required',
        'PROJECT': 'This project not is valid'
      }
    },
    'LOGS': {
      'TITLE': 'Log entries',
      'EXPORT_TABLE': 'Export Table',
      'OF': 'of',
      'FILTER': {
        'ADD_FILTERS': {
          'TITLE': 'Add Filters',
          'BACK': 'All filters',
          'LOG_TYPES_SELECTED': 'Log Types selected',
          'SEARCH_PLACEHOLDER': 'Search Log Type filter',
          'ACCOUNT': 'Account',
          'PROJECTS': 'Projects',
          'LICENSES': 'Licenses',
          'CSI': 'Csi'
        }
      },
      'SEARCH': {
        'TITLE': 'SEARCH',
        'PLACEHOLDER': 'Type account or project'
      },
      'DATE_CREATED': {
        'TITLE': 'DATE CREATED',
        'TO': 'to',
        'ERROR': 'First date can\'t be lower than second one.'
      },
      'TABLE': {
        'TITLE': 'Log Results',
        'LOG_TYPE': 'Log Type',
        'USERNAME': 'Username',
        'RECIPIENT': 'Recipient',
        'PROJECT': 'Project',
        'TIME_STAMP': 'Time Stamp',
        'MESSAGE': 'Message',
        'BROWSER': 'Browser',
        'TOOLTIP': 'View detail',
        'PAGINATION': {
          'SHOWING': 'Showing',
          'OF': 'of',
          'PAGE': 'Page',
          'LABEL': 'Rows per page',
          'ALL': 'all'
        }
      },
      'MODAL': {
        'TITLE': 'Log information',
        'LOG_CATEGORY': 'LOG CATEGORY:',
        'LOG_SUBCATEGORY': 'LOG SUBCATEGORY',
        'ACCOUNT': 'ACCOUNT:',
        'PROJECT': 'PROJECT:',
        'MESSAGE': 'MESSAGE:',
        'LOG_INFORMATION': 'LOG INFORMATION:',
      }
    }
  },

  // =========== MIGRATION ===========
  // =================================

  'MIGRATION': {
    'TITLE': 'Migration',
    'PAGINATION': {
      'LABEL': 'projects'
    },
    'SEARCH_PLACEHOLDER': 'SEARCH PROJECTS',
    'TABLE': {
      'ID': 'ID.',
      'NAME': 'NAME',
      'ABR': 'ABBREVIATION',
      'OWNER': 'PROJECT OWNER',
      'TOOLTIP_MIGRATE': 'Migrate',
      'TOOLTIP_MIGRATED': 'Migrated',
      'TOOLTIP_DISABLED': 'This project must be disabled in order to migrate it.'
    },
    'MODAL': {
      'FAIL': 'Something went wrong',
      'SUCCESS': 'Project was successfully migrated!'
    }
  }
};

export const LANG_DA_TRANS = Object.assign(LANG_DA, COUNTRIES_EN);



// WEBPACK FOOTER //
// ./src/app/translation/i18n/lang-da.ts